export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: any; output: any };
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any };
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any };
  /** Represents untyped JSON */
  JSON: { input: any; output: any };
  Upload: { input: any; output: any };
};

/** Autogenerated input type of AcceptEventPlanInvitation */
export type AcceptEventPlanInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptEventPlanInvitation. */
export type AcceptEventPlanInvitationPayload = {
  __typename?: 'AcceptEventPlanInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventPlan?: Maybe<EventPlan>;
};

/** Autogenerated input type of AcceptExpressBookRequest */
export type AcceptExpressBookRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptExpressBookRequest. */
export type AcceptExpressBookRequestPayload = {
  __typename?: 'AcceptExpressBookRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  expressBookRequest?: Maybe<ExpressBookRequest>;
};

/** Autogenerated input type of AcceptSuggestedAction */
export type AcceptSuggestedActionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptSuggestedAction. */
export type AcceptSuggestedActionPayload = {
  __typename?: 'AcceptSuggestedActionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  suggestedAction?: Maybe<SuggestedAction>;
};

export type Account = {
  __typename?: 'Account';
  address?: Maybe<Address>;
  averageSpend: Scalars['Int']['output'];
  contactsCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lostEventCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  pastEventCount: Scalars['Int']['output'];
  planners: Array<Planner>;
  totalSpend: Scalars['Int']['output'];
  upcomingEventCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Account. */
export type AccountConnection = {
  __typename?: 'AccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Account>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccountEdge = {
  __typename?: 'AccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Account>;
};

export type ActiveEvent = {
  __typename?: 'ActiveEvent';
  acceptedContract?: Maybe<Contract>;
  additionalContacts: Array<Planner>;
  amount?: Maybe<Scalars['Int']['output']>;
  /** Whether the event message thread has been archived from the inbox */
  archived: Scalars['Boolean']['output'];
  budget?: Maybe<Scalars['Int']['output']>;
  budgetOrContractAmount?: Maybe<Scalars['Int']['output']>;
  canShowEventBudget: AuthorizationResult;
  canUpdate: AuthorizationResult;
  cancelReason?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  confirmationPath?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  contract?: Maybe<Contract>;
  contracts: Array<Contract>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdAtDate: Scalars['ISO8601Date']['output'];
  createdByGuest?: Maybe<Scalars['Boolean']['output']>;
  customFieldValues: Scalars['JSON']['output'];
  cventIntegrationSync?: Maybe<EventIntegrationSync>;
  cventSyncEligibility: IntegrationSyncEligibility;
  depositAmount?: Maybe<Scalars['Int']['output']>;
  depositPayment?: Maybe<Payment>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  documents: Array<Document>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventFloorPlans: Array<EventFloorPlan>;
  eventType?: Maybe<Scalars['String']['output']>;
  eventTypeName?: Maybe<Scalars['String']['output']>;
  eventbriteIntegrationSync?: Maybe<EventIntegrationSync>;
  eventbriteSyncEligibility: IntegrationSyncEligibility;
  fraudDetections: Array<FraudDetection>;
  groupSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  internalNoteHtml?: Maybe<Scalars['String']['output']>;
  interpolatedInternalNoteHtml?: Maybe<Scalars['String']['output']>;
  interpolatedProposalNoteHtml?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lastEmailedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latestMessage?: Maybe<Message>;
  lostReasonCategories?: Maybe<Array<LostReasonCategory>>;
  markedFraudulentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  merriId?: Maybe<Scalars['Int']['output']>;
  messages: Array<Message>;
  multiDayEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numDays?: Maybe<Scalars['Int']['output']>;
  offlineCommunications: Array<OfflineCommunication>;
  opentableIntegrationSync?: Maybe<EventIntegrationSync>;
  opentableSyncEligibility: IntegrationSyncEligibility;
  origin: EventOrigin;
  otherAmount?: Maybe<Scalars['Int']['output']>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  paymentProvider: PaymentProvider;
  payments: Array<Payment>;
  planner?: Maybe<Planner>;
  prismmId?: Maybe<Scalars['String']['output']>;
  proposalNoteHtml?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Int']['output']>;
  refundedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rehearsalEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  rehearsalEndOffset?: Maybe<Scalars['Int']['output']>;
  rehearsalStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  rehearsalStartOffset?: Maybe<Scalars['Int']['output']>;
  remainingBalanceAmount?: Maybe<Scalars['Int']['output']>;
  remainingBalancePayment?: Maybe<Payment>;
  review?: Maybe<Review>;
  seatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  seniorSpace?: Maybe<Space>;
  sessions: Array<Session>;
  sevenShiftsIntegrationSync?: Maybe<EventIntegrationSync>;
  sevenShiftsSyncEligibility: IntegrationSyncEligibility;
  skipFraudDetection: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  smartFieldValues: Scalars['JSON']['output'];
  spaceAvailability?: Maybe<Scalars['JSON']['output']>;
  spaces: Array<Space>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: EventStatus;
  suggestedActions: SuggestedActionConnection;
  tasks: Array<Task>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
  totalBySalesCategoryName: Scalars['JSON']['output'];
  tourEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  tourEndOffset?: Maybe<Scalars['Int']['output']>;
  tourStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  tourStartOffset?: Maybe<Scalars['Int']['output']>;
  unreadMessageCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  userFields: Scalars['JSON']['output'];
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  valueForReporting?: Maybe<Scalars['Int']['output']>;
  venue: Venue;
};

export type ActiveEventSuggestedActionsArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for ActiveEvent. */
export type ActiveEventConnection = {
  __typename?: 'ActiveEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActiveEventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ActiveEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ActiveEventEdge = {
  __typename?: 'ActiveEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ActiveEvent>;
};

export type ActiveStorageDirectUploadResult = {
  __typename?: 'ActiveStorageDirectUploadResult';
  directUpload: DirectUpload;
  signedId: Scalars['String']['output'];
};

/** Autogenerated input type of AddContractPolicySection */
export type AddContractPolicySectionInput = {
  body?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  policySectionId?: InputMaybe<Scalars['ID']['input']>;
  requiresInitial?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of AddContractPolicySection. */
export type AddContractPolicySectionPayload = {
  __typename?: 'AddContractPolicySectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
};

/** Autogenerated input type of AddGuestSpaceFavorite */
export type AddGuestSpaceFavoriteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  spaceSlug: Scalars['String']['input'];
};

/** Autogenerated return type of AddGuestSpaceFavorite. */
export type AddGuestSpaceFavoritePayload = {
  __typename?: 'AddGuestSpaceFavoritePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  space?: Maybe<MarketplaceSpace>;
};

export type AddOnDefinition = {
  __typename?: 'AddOnDefinition';
  active: Scalars['Boolean']['output'];
  annualRate: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  monthlyRate: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  stripeConfigured: Scalars['Boolean']['output'];
  stripePriceIdAnnual?: Maybe<Scalars['String']['output']>;
  stripePriceIdMonthly?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  trialDays: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type AddOnPlan = {
  __typename?: 'AddOnPlan';
  active: Scalars['Boolean']['output'];
  addOnDefinition: AddOnDefinition;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discount: Scalars['Float']['output'];
  effectiveAnnualRate: Scalars['Int']['output'];
  effectiveMonthlyRate: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  lastBillingDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextBillingDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  status: SubscriptionStatus;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionItemId?: Maybe<Scalars['String']['output']>;
  trialEndsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  trialExpired: Scalars['Boolean']['output'];
  trialing: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venueId: Scalars['ID']['output'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress1?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Address Input */
export type AddressInput = {
  /** City */
  city: Scalars['String']['input'];
  /** Country */
  country: Scalars['String']['input'];
  /** Formatted Address */
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  /** Place ID */
  placeId?: InputMaybe<Scalars['String']['input']>;
  /** State */
  state: Scalars['String']['input'];
  /** Street Address 1 */
  streetAddress1: Scalars['String']['input'];
  /** Street Address 2 */
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
  /** Zip */
  zip: Scalars['String']['input'];
};

export type Admin = {
  __typename?: 'Admin';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of AdminCancelPlanTierTrial */
export type AdminCancelPlanTierTrialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminCancelPlanTierTrial. */
export type AdminCancelPlanTierTrialPayload = {
  __typename?: 'AdminCancelPlanTierTrialPayload';
  adminVenue?: Maybe<AdminVenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AdminCancelVenueSubscriptions */
export type AdminCancelVenueSubscriptionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminCancelVenueSubscriptions. */
export type AdminCancelVenueSubscriptionsPayload = {
  __typename?: 'AdminCancelVenueSubscriptionsPayload';
  adminVenue?: Maybe<AdminVenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AdminCreateOauthApplication */
export type AdminCreateOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  logoSignedId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  redirectUri: Scalars['String']['input'];
  scopes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminCreateOauthApplication. */
export type AdminCreateOauthApplicationPayload = {
  __typename?: 'AdminCreateOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  oauthApplication?: Maybe<OauthApplication>;
};

/** Autogenerated input type of AdminDeleteOauthApplication */
export type AdminDeleteOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminDeleteOauthApplication. */
export type AdminDeleteOauthApplicationPayload = {
  __typename?: 'AdminDeleteOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AdminDeleteOrganizationAiFeeAgreement */
export type AdminDeleteOrganizationAiFeeAgreementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminDeleteOrganizationAiFeeAgreement. */
export type AdminDeleteOrganizationAiFeeAgreementPayload = {
  __typename?: 'AdminDeleteOrganizationAiFeeAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of AdminDeletePlanTierTrial */
export type AdminDeletePlanTierTrialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminDeletePlanTierTrial. */
export type AdminDeletePlanTierTrialPayload = {
  __typename?: 'AdminDeletePlanTierTrialPayload';
  adminVenue?: Maybe<AdminVenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AdminExtendPlanTierTrial */
export type AdminExtendPlanTierTrialInput = {
  additionalDays: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminExtendPlanTierTrial. */
export type AdminExtendPlanTierTrialPayload = {
  __typename?: 'AdminExtendPlanTierTrialPayload';
  adminVenue?: Maybe<AdminVenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AdminExtendVenueSubscription */
export type AdminExtendVenueSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminExtendVenueSubscription. */
export type AdminExtendVenueSubscriptionPayload = {
  __typename?: 'AdminExtendVenueSubscriptionPayload';
  adminVenue?: Maybe<AdminVenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AdminMarkOpentableSyncComplete */
export type AdminMarkOpentableSyncCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reservationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminMarkOpentableSyncComplete. */
export type AdminMarkOpentableSyncCompletePayload = {
  __typename?: 'AdminMarkOpentableSyncCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  opentableSync?: Maybe<EventIntegrationSync>;
};

/** The connection type for Searchable. */
export type AdminSearch = {
  __typename?: 'AdminSearch';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SearchableEdge>>>;
  id: Scalars['ID']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Searchable>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  query: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of AdminStartPlanTierTrial */
export type AdminStartPlanTierTrialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  trialDays?: InputMaybe<Scalars['Int']['input']>;
  trialTier: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdminStartPlanTierTrial. */
export type AdminStartPlanTierTrialPayload = {
  __typename?: 'AdminStartPlanTierTrialPayload';
  adminVenue?: Maybe<AdminVenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AdminUpdateOauthApplication */
export type AdminUpdateOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logoSignedId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminUpdateOauthApplication. */
export type AdminUpdateOauthApplicationPayload = {
  __typename?: 'AdminUpdateOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  oauthApplication?: Maybe<OauthApplication>;
};

/** Autogenerated input type of AdminUpdateOrganization */
export type AdminUpdateOrganizationInput = {
  addOnDiscount?: InputMaybe<Scalars['Float']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  featureFlags?: InputMaybe<Scalars['JSON']['input']>;
  hubspotDealId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  planSetId?: InputMaybe<Scalars['ID']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminUpdateOrganization. */
export type AdminUpdateOrganizationPayload = {
  __typename?: 'AdminUpdateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of AdminUpdateVenue */
export type AdminUpdateVenueInput = {
  achEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerStartedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  defaultPaymentProvider?: InputMaybe<PaymentProvider>;
  featureFlags?: InputMaybe<Scalars['JSON']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  liveAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  marketplaceRank?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numberOfTrialDays?: InputMaybe<Scalars['Int']['input']>;
  paymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  planDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  planSetId?: InputMaybe<Scalars['ID']['input']>;
  removeCustomerStartedAt?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  suspicious?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  trialEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdminUpdateVenue. */
export type AdminUpdateVenuePayload = {
  __typename?: 'AdminUpdateVenuePayload';
  adminVenue?: Maybe<AdminVenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of AdminUpsertOrganizationAiFeeAgreement */
export type AdminUpsertOrganizationAiFeeAgreementInput = {
  accepted: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  /** Fraction added to the application fee, e.g. 0.015 for 1.5% */
  rate: Scalars['Float']['input'];
  startsOn: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of AdminUpsertOrganizationAiFeeAgreement. */
export type AdminUpsertOrganizationAiFeeAgreementPayload = {
  __typename?: 'AdminUpsertOrganizationAiFeeAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organization?: Maybe<Organization>;
};

export type AdminVenue = {
  __typename?: 'AdminVenue';
  achApplicationFeeRate?: Maybe<Scalars['Float']['output']>;
  achEnabled: Scalars['Boolean']['output'];
  activePlanTierTrial?: Maybe<VenueTierTrial>;
  addOnPlans: Array<AddOnPlan>;
  address?: Maybe<Address>;
  aiReplyProvider: AiReplyProvider;
  aiReplySessions: Array<AiReplySession>;
  aiReplySessionsCount: Scalars['Int']['output'];
  allowedOrigins: Array<AllowedOrigin>;
  autoAdvanceProposalAction: Scalars['Boolean']['output'];
  autoCancelStaleLeads: Scalars['Boolean']['output'];
  autoGuestGreetingEnabled: Scalars['Boolean']['output'];
  availabilityBlocks: Array<AvailabilityBlock>;
  banner?: Maybe<Scalars['String']['output']>;
  basicFeaturesEnabled: Scalars['Boolean']['output'];
  beoCustomization: BeoCustomization;
  billingAddress?: Maybe<Address>;
  billingInterval?: Maybe<BillingInterval>;
  blockedMessagesCount: Scalars['Int']['output'];
  canListFees: AuthorizationResult;
  canListMessages: AuthorizationResult;
  canListPayments: AuthorizationResult;
  canListReports: AuthorizationResult;
  canListTaxes: AuthorizationResult;
  canUpdate: AuthorizationResult;
  cardApplicationFeeRate?: Maybe<Scalars['Float']['output']>;
  contactFormBackgroundColor: Scalars['String']['output'];
  contactFormBanner?: Maybe<Scalars['String']['output']>;
  contactFormButtonColor: Scalars['String']['output'];
  contactFormSettings: ContactFormSettings;
  countersignEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  customFields: Array<UserFieldDefinition>;
  customerStartedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  cventPropertyId?: Maybe<Scalars['String']['output']>;
  defaultDepositAmount?: Maybe<Scalars['Int']['output']>;
  defaultDepositRate?: Maybe<Scalars['Float']['output']>;
  defaultDiscountEnabled: Scalars['Boolean']['output'];
  defaultEventOwner?: Maybe<VenueMembership>;
  defaultMinimumAmount?: Maybe<Scalars['Int']['output']>;
  defaultMinimumEnabled: Scalars['Boolean']['output'];
  defaultPaymentMethodMechanism: PaymentMethodMechanism;
  defaultPaymentProvider?: Maybe<PaymentProvider>;
  description?: Maybe<Scalars['String']['output']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  discardedEvents: Array<Event>;
  displayFeedbackInProfile: Scalars['Boolean']['output'];
  documentTemplates: Array<DocumentTemplate>;
  documents: Array<Document>;
  email: Scalars['String']['output'];
  emailAddress: EmailAddress;
  emailApiOpenTableAddress?: Maybe<Scalars['String']['output']>;
  emailApiTheKnotAddress?: Maybe<Scalars['String']['output']>;
  emailApiTockAddress?: Maybe<Scalars['String']['output']>;
  emailApiWeddingWireAddress?: Maybe<Scalars['String']['output']>;
  emailTemplates: Array<EmailTemplate>;
  eventEndOffset: Scalars['Int']['output'];
  eventOwners: Array<User>;
  eventStartOffset: Scalars['Int']['output'];
  events: Array<Event>;
  eventsCount: Scalars['Int']['output'];
  eventsSummary: Scalars['JSON']['output'];
  expressBookSettings: ExpressBookSettings;
  featureFlags: Scalars['JSON']['output'];
  featureScope: FeatureScope;
  feedbackEnabled: Scalars['Boolean']['output'];
  fees: Array<Fee>;
  foodAndBeverageMinimums: Array<FoodAndBeverageMinimum>;
  googlePlaceInfo?: Maybe<GooglePlaceInfo>;
  gtmId?: Maybe<Scalars['String']['output']>;
  helloLeadFormPath: Scalars['String']['output'];
  helloLeadFormUrl: Scalars['String']['output'];
  hoursOfOperation: Array<HoursOfOperation>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Image>>;
  incomingMessagesCount: Scalars['Int']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  liveAvailability: Scalars['Boolean']['output'];
  marketplaceRank?: Maybe<Scalars['Int']['output']>;
  menu?: Maybe<Menu>;
  merriId?: Maybe<Scalars['Int']['output']>;
  messageSuggestionPreamble: Scalars['String']['output'];
  messages: Array<Message>;
  minGroupSize?: Maybe<Scalars['Int']['output']>;
  monthlyRate?: Maybe<Scalars['Int']['output']>;
  multiDayEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  onActivePaidSubscription: Scalars['Boolean']['output'];
  opentableConnected: Scalars['Boolean']['output'];
  opentableCustomInstructions?: Maybe<Scalars['String']['output']>;
  opentableRestaurantId?: Maybe<Scalars['String']['output']>;
  opentableSyncTriggerStatus: EventStatus;
  organization: Organization;
  outgoingMessagesCount: Scalars['Int']['output'];
  payments: Array<Payment>;
  paymentsEnabled: Scalars['Boolean']['output'];
  planName?: Maybe<Scalars['String']['output']>;
  planSet?: Maybe<PlanSet>;
  planTierTrialHistory: Array<VenueTierTrial>;
  policySectionInitialsEnabled: Scalars['Boolean']['output'];
  policySections: Array<PolicySection>;
  premiumFeaturesEnabled: Scalars['Boolean']['output'];
  priceCategory: Scalars['String']['output'];
  prismmId?: Maybe<Scalars['String']['output']>;
  proFeaturesEnabled: Scalars['Boolean']['output'];
  profileBanner?: Maybe<Scalars['String']['output']>;
  proposalLockCondition: ProposalLockCondition;
  publicApiKey?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  qrcodePngUrl: Scalars['String']['output'];
  sentMessagesCount: Scalars['Int']['output'];
  sevenShiftsId?: Maybe<Scalars['Int']['output']>;
  showPvBranding: Scalars['Boolean']['output'];
  skipSpamCheck: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  smartFieldDefinitions: Scalars['JSON']['output'];
  spaceGraph: Scalars['JSON']['output'];
  spaces: Array<Space>;
  spacesCount: Scalars['Int']['output'];
  squareAccount?: Maybe<SquareAccount>;
  squareLocationId?: Maybe<Scalars['String']['output']>;
  stripeAccount?: Maybe<StripeAccount>;
  subscription?: Maybe<SubscriptionPlan>;
  suspicious: Scalars['Boolean']['output'];
  taxes: Array<Tax>;
  timezone: Scalars['String']['output'];
  trialEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unreadMessageCount: Scalars['Int']['output'];
  upcomingSubscription?: Maybe<SubscriptionPlan>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userFieldDefinitions: Array<UserFieldDefinition>;
  users: Array<User>;
  venueAiReplyInstructions: Array<VenueAiReplyInstruction>;
  venueCollection?: Maybe<VenueCollection>;
  venueCollectionId?: Maybe<Scalars['ID']['output']>;
  venueMemberships: Array<VenueMembership>;
  venuePolicies: Array<VenuePolicy>;
  venueType?: Maybe<VenueType>;
  websiteScans: Array<WebsiteScan>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  widgetContactFormRedirectUrl?: Maybe<Scalars['String']['output']>;
  widgetInstanceId: Scalars['String']['output'];
};

export type AdminVenueAiReplySessionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminVenueDiscardedEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminVenueMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminVenuePaymentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminVenueUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for AdminVenue. */
export type AdminVenueConnection = {
  __typename?: 'AdminVenueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AdminVenueEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AdminVenue>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AdminVenueEdge = {
  __typename?: 'AdminVenueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AdminVenue>;
};

export enum AiReplyProvider {
  Openai = 'openai',
}

export type AiReplySession = {
  __typename?: 'AiReplySession';
  actionMessage?: Maybe<Message>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: Event;
  id: Scalars['ID']['output'];
  messageSuggestions: Array<MessageSuggestion>;
  publicId?: Maybe<Scalars['String']['output']>;
  triggerMessage?: Maybe<Message>;
};

export type AllowedOrigin = {
  __typename?: 'AllowedOrigin';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  origin: Scalars['String']['output'];
};

export type Amenity = {
  __typename?: 'Amenity';
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type AnalyticsDatum = {
  __typename?: 'AnalyticsDatum';
  comparison: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  confirmed: Scalars['Int']['output'];
  definite: Scalars['Int']['output'];
  goal: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  metric: Scalars['String']['output'];
  month: Scalars['String']['output'];
  tentative: Scalars['Int']['output'];
};

/** Autogenerated input type of ApplyAssistantDraft */
export type ApplyAssistantDraftInput = {
  browserSessionId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['ID']['input'];
  expectedRevision?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  replaceConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  toolCallId: Scalars['ID']['input'];
};

/** Autogenerated return type of ApplyAssistantDraft. */
export type ApplyAssistantDraftPayload = {
  __typename?: 'ApplyAssistantDraftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  message?: Maybe<Message>;
  revision?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ApproveVenueDataImport */
export type ApproveVenueDataImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ApproveVenueDataImport. */
export type ApproveVenueDataImportPayload = {
  __typename?: 'ApproveVenueDataImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venueDataImport?: Maybe<VenueDataImport>;
};

/** Autogenerated input type of ArchiveDocument */
export type ArchiveDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveDocument. */
export type ArchiveDocumentPayload = {
  __typename?: 'ArchiveDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  errors: Array<Error>;
};

/** Autogenerated input type of ArchiveEvents */
export type ArchiveEventsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ArchiveEvents. */
export type ArchiveEventsPayload = {
  __typename?: 'ArchiveEventsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  events: Array<Event>;
};

/** Autogenerated input type of ArchivePlanner */
export type ArchivePlannerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchivePlanner. */
export type ArchivePlannerPayload = {
  __typename?: 'ArchivePlannerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  planner?: Maybe<Planner>;
};

/** Autogenerated input type of ArchiveVenueEvents */
export type ArchiveVenueEventsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ArchiveVenueEvents. */
export type ArchiveVenueEventsPayload = {
  __typename?: 'ArchiveVenueEventsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export enum AssistantCommandAction {
  Acknowledge = 'acknowledge',
  Archive = 'archive',
  Cancel = 'cancel',
  Continue = 'continue',
  Insert = 'insert',
  RetryAction = 'retry_action',
  Submit = 'submit',
}

/** Autogenerated input type of AssistantCommand */
export type AssistantCommandInput = {
  action: AssistantCommandAction;
  browserSessionId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['ID']['input'];
  payload?: InputMaybe<Scalars['JSON']['input']>;
  requestKey?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  toolCallId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AssistantCommand. */
export type AssistantCommandPayload = {
  __typename?: 'AssistantCommandPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Scalars['JSON']['output']>;
  errors: Array<Error>;
};

export type AuthorizationResult = {
  __typename?: 'AuthorizationResult';
  /** Human-readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Reasons of check failure */
  reasons?: Maybe<FailureReasons>;
  /** Result of applying a policy rule */
  value: Scalars['Boolean']['output'];
};

export type AutomaticTaskOption = {
  __typename?: 'AutomaticTaskOption';
  eventTypes: Array<SelectOption>;
  owners: Array<SelectOption>;
  taskDueDateOffsetAnchors: Array<SelectOption>;
  taskDueDateOffsetDirections: Array<SelectOption>;
  triggers: Array<SelectOption>;
};

export type AutomaticTaskTemplate = {
  __typename?: 'AutomaticTaskTemplate';
  createWhen: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventType?: Maybe<Scalars['String']['output']>;
  eventTypeFormatted?: Maybe<Scalars['String']['output']>;
  eventTypeName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  taskDescription?: Maybe<Scalars['String']['output']>;
  taskDueDateOffsetAnchor: Scalars['String']['output'];
  taskDueDateOffsetDays: Scalars['Int']['output'];
  taskDueDateOffsetDirection: Scalars['String']['output'];
  taskName?: Maybe<Scalars['String']['output']>;
  taskOwnerId?: Maybe<Scalars['Int']['output']>;
  trigger: Scalars['String']['output'];
  venueId: Scalars['Int']['output'];
};

export type AvailabilityBlock = {
  __typename?: 'AvailabilityBlock';
  blocks: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  endDate: Scalars['ISO8601Date']['output'];
  endOffset?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  spaces?: Maybe<Array<Space>>;
  startDate: Scalars['ISO8601Date']['output'];
  startOffset?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venue: Venue;
};

export type BeoCustomization = {
  __typename?: 'BeoCustomization';
  id: Scalars['ID']['output'];
  showItemDetailsOnBeo: Scalars['Boolean']['output'];
  showItemDetailsOnStaffBeo: Scalars['Boolean']['output'];
  showItemInternalDetailsOnBeo: Scalars['Boolean']['output'];
  showItemInternalDetailsOnStaffBeo: Scalars['Boolean']['output'];
  venue: Venue;
};

export enum BillingInterval {
  Annual = 'annual',
  Monthly = 'monthly',
}

export type BookableTime = {
  __typename?: 'BookableTime';
  available: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
};

export type BookingWindow = {
  __typename?: 'BookingWindow';
  dayOfWeek: Scalars['String']['output'];
  endOffset: Scalars['Int']['output'];
  foodAndBeverageMinimum: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  menuCategoryIds: Array<Scalars['ID']['output']>;
  requiredMenuItemIds: Array<Scalars['ID']['output']>;
  startOffset: Scalars['Int']['output'];
};

/** A recurring window of time a space can be booked in */
export type BookingWindowInput = {
  dayOfWeek: Scalars['String']['input'];
  endOffset: Scalars['Int']['input'];
  foodAndBeverageMinimum?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Menu sections offered in this window. Empty offers every section; omitted leaves them as they are. */
  menuCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Menu items added to every express booking in this window. Omitted leaves them as they are. */
  requiredMenuItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startOffset: Scalars['Int']['input'];
};

export type Bounds = {
  __typename?: 'Bounds';
  neLat: Scalars['Float']['output'];
  neLng: Scalars['Float']['output'];
  swLat: Scalars['Float']['output'];
  swLng: Scalars['Float']['output'];
};

export type BulkEventUpdateInput = {
  eventOwnerId?: InputMaybe<Scalars['ID']['input']>;
  eventTypeId?: InputMaybe<Scalars['ID']['input']>;
  spaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of BulkUpdateEvents */
export type BulkUpdateEventsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  updateParams: BulkEventUpdateInput;
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkUpdateEvents. */
export type BulkUpdateEventsPayload = {
  __typename?: 'BulkUpdateEventsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CancelAddOn */
export type CancelAddOnInput = {
  addOnPlanId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CancelAddOn. */
export type CancelAddOnPayload = {
  __typename?: 'CancelAddOnPayload';
  addOnPlan?: Maybe<AddOnPlan>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CancelEvent */
export type CancelEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lostReasonCategories?: InputMaybe<Array<LostReasonCategory>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  referralEventManagerEmail?: InputMaybe<Scalars['String']['input']>;
  referralEventManagerName?: InputMaybe<Scalars['String']['input']>;
  referralVenueName?: InputMaybe<Scalars['String']['input']>;
  refundAmount?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CancelEvent. */
export type CancelEventPayload = {
  __typename?: 'CancelEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of CancelPlanTierTrial */
export type CancelPlanTierTrialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelPlanTierTrial. */
export type CancelPlanTierTrialPayload = {
  __typename?: 'CancelPlanTierTrialPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of CancelReportExport */
export type CancelReportExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportExportId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelReportExport. */
export type CancelReportExportPayload = {
  __typename?: 'CancelReportExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reportExport?: Maybe<ReportExport>;
};

/** Autogenerated input type of CancelScheduledMessage */
export type CancelScheduledMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  messageId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelScheduledMessage. */
export type CancelScheduledMessagePayload = {
  __typename?: 'CancelScheduledMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of CloneMerriEvent */
export type CloneMerriEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  merriId: Scalars['ID']['input'];
};

/** Autogenerated return type of CloneMerriEvent. */
export type CloneMerriEventPayload = {
  __typename?: 'CloneMerriEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

export type Comment = {
  __typename?: 'Comment';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  user?: Maybe<User>;
};

/** The connection type for Comment. */
export type CommentConnection = {
  __typename?: 'CommentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CommentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Comment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommentEdge = {
  __typename?: 'CommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Comment>;
};

export enum ContactFormEntity {
  Organization = 'Organization',
  Venue = 'Venue',
  VenueCollection = 'VenueCollection',
}

export type ContactFormFeatureScope = {
  __typename?: 'ContactFormFeatureScope';
  id: Scalars['ID']['output'];
  premiumFeaturesEnabled: Scalars['Boolean']['output'];
};

export type ContactFormSettings = {
  __typename?: 'ContactFormSettings';
  availableVenues: Array<ContactFormVenue>;
  backgroundColor: Scalars['String']['output'];
  banner?: Maybe<Scalars['String']['output']>;
  buttonColor: Scalars['String']['output'];
  canEmbedWidget: Scalars['Boolean']['output'];
  enterpriseFeaturesEnabled: Scalars['Boolean']['output'];
  entityId: Scalars['String']['output'];
  entityType: ContactFormEntity;
  gtmId?: Maybe<Scalars['String']['output']>;
  helloLeadFormPath: Scalars['String']['output'];
  helloLeadFormUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  preEventQuestionnaireEarlyAccess: Scalars['Boolean']['output'];
  premiumFeaturesEnabled: Scalars['Boolean']['output'];
  qrCodePngUrl: Scalars['String']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  showPvBranding: Scalars['Boolean']['output'];
  showVenueSelector: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  userFieldDefinitions: Array<UserFieldDefinition>;
  widgetInstanceId: Scalars['String']['output'];
};

export type ContactFormVenue = {
  __typename?: 'ContactFormVenue';
  eventEndOffset: Scalars['Int']['output'];
  eventStartOffset: Scalars['Int']['output'];
  featureScope: ContactFormFeatureScope;
  id: Scalars['ID']['output'];
  minGroupSize?: Maybe<Scalars['Int']['output']>;
  multiDayEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publicApiKey?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ContactSales */
export type ContactSalesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContactSales. */
export type ContactSalesPayload = {
  __typename?: 'ContactSalesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organization?: Maybe<Organization>;
};

export type Contract = {
  __typename?: 'Contract';
  accepted: Scalars['Boolean']['output'];
  action?: Maybe<Scalars['String']['output']>;
  canUpdate: AuthorizationResult;
  cardSurchargeRate: Scalars['Float']['output'];
  contractFees: Array<ContractFee>;
  contractItems: Array<ContractItem>;
  contractTaxes: Array<ContractTax>;
  countersignEnabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  depositAmount?: Maybe<Scalars['Int']['output']>;
  depositPayment?: Maybe<Payment>;
  depositRate?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountEnabled: Scalars['Boolean']['output'];
  discountRate?: Maybe<Scalars['Float']['output']>;
  effectivePolicySections: Array<EventPolicySection>;
  event: Event;
  eventPolicySections?: Maybe<Array<EventPolicySection>>;
  expressBookMenuCategories: Array<MenuCategory>;
  expressBookMenuNarrowed: Scalars['Boolean']['output'];
  foodAndBeverageMinimumId?: Maybe<Scalars['ID']['output']>;
  guestPortalFields: Array<UserFieldDefinition>;
  hasEventPolicy: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lockCondition: ContractProposalLockCondition;
  locked: Scalars['Boolean']['output'];
  minimumAmount?: Maybe<Scalars['Int']['output']>;
  minimumEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  otherPaymentAmount?: Maybe<Scalars['Int']['output']>;
  paymentMethodMechanism: PaymentMethodMechanism;
  policyHtml?: Maybe<Scalars['String']['output']>;
  questionnaireEnabled: Scalars['Boolean']['output'];
  questionnaireFields: Array<UserFieldDefinition>;
  remainingBalancePayment?: Maybe<Payment>;
  requiresCountersign: Scalars['Boolean']['output'];
  signature?: Maybe<Scalars['String']['output']>;
  signed: Scalars['Boolean']['output'];
  signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  totals: Scalars['JSON']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
  venuePolicy: VenuePolicy;
  venuePolicyHtml?: Maybe<Scalars['String']['output']>;
  venueSignature?: Maybe<Scalars['String']['output']>;
  venueSigned: Scalars['Boolean']['output'];
  venueSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  venueSigner?: Maybe<User>;
};

export type ContractFee = {
  __typename?: 'ContractFee';
  applyToMinimum: Scalars['Boolean']['output'];
  cachedAmount: Scalars['Int']['output'];
  contract: Contract;
  contractTaxes: Array<ContractTax>;
  enabled: Scalars['Boolean']['output'];
  fee: Fee;
  feeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  overrideAmount?: Maybe<Scalars['Int']['output']>;
  rate: Scalars['Float']['output'];
};

/** Contract Fee Input */
export type ContractFeeInput = {
  /** Enabled */
  enabled: Scalars['Boolean']['input'];
  /** ID */
  id: Scalars['ID']['input'];
  /** Override Amount */
  overrideAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Rate */
  rate: Scalars['Float']['input'];
};

export type ContractItem = {
  __typename?: 'ContractItem';
  addonIds: Scalars['JSON']['output'];
  addonQuantities: Scalars['JSON']['output'];
  addons: Array<MenuItemAddon>;
  basePrice?: Maybe<Scalars['Int']['output']>;
  choices: Array<MenuItemChoice>;
  contract: Contract;
  contractFees: Array<ContractFee>;
  contractTaxes: Array<ContractTax>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountRate?: Maybe<Scalars['Float']['output']>;
  displayOnGuestMenu: Scalars['Boolean']['output'];
  event: Event;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  internalDetails?: Maybe<Scalars['String']['output']>;
  menuCategory?: Maybe<MenuCategory>;
  name: Scalars['String']['output'];
  optionIds: Scalars['JSON']['output'];
  optionQuantities: Scalars['JSON']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  quantitiesEditableByGuest: Scalars['Boolean']['output'];
  quantitiesOnExtrasEnabled: Scalars['Boolean']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  required: Scalars['Boolean']['output'];
  selectedAddons: Array<MenuItemAddon>;
  selectedOptions: Array<MenuItemOption>;
  session?: Maybe<Session>;
  sessionId?: Maybe<Scalars['ID']['output']>;
  total?: Maybe<Scalars['BigInt']['output']>;
  unit: ContractItemUnit;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ContractItemImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for ContractItem. */
export type ContractItemConnection = {
  __typename?: 'ContractItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContractItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ContractItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContractItemEdge = {
  __typename?: 'ContractItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ContractItem>;
};

/** Contract Item Input */
export type ContractItemInput = {
  /** ID */
  id: Scalars['ID']['input'];
  /** Index */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** Quantity */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContractItemUnit {
  /** Hour */
  Hour = 'hour',
  /** Item */
  Item = 'item',
  /** Person */
  Person = 'person',
}

export enum ContractProposalLockCondition {
  LockContractOneWeekBeforeEvent = 'lock_contract_one_week_before_event',
  LockContractThreeWeeksBeforeEvent = 'lock_contract_three_weeks_before_event',
  LockContractTwoWeeksBeforeEvent = 'lock_contract_two_weeks_before_event',
  LockContractWhenSigned = 'lock_contract_when_signed',
  Locked = 'locked',
  NeverLockContract = 'never_lock_contract',
}

export type ContractTax = {
  __typename?: 'ContractTax';
  applyToMinimum: Scalars['Boolean']['output'];
  cachedAmount: Scalars['Int']['output'];
  contract: Contract;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  overrideAmount?: Maybe<Scalars['Int']['output']>;
  rate: Scalars['Float']['output'];
  tax: Tax;
  taxId: Scalars['ID']['output'];
};

/** Contract Tax Input */
export type ContractTaxInput = {
  /** Enabled */
  enabled: Scalars['Boolean']['input'];
  /** ID */
  id: Scalars['ID']['input'];
  /** Override Amount */
  overrideAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Rate */
  rate: Scalars['Float']['input'];
};

export type ConversionAnalyticsDatum = {
  __typename?: 'ConversionAnalyticsDatum';
  changePercent: Scalars['Float']['output'];
  comparisonValue: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type ConversionRateAnalytics = {
  __typename?: 'ConversionRateAnalytics';
  averageResponseTimeMinutes: ConversionAnalyticsDatum;
  comparisonEndDate: Scalars['ISO8601DateTime']['output'];
  comparisonStartDate: Scalars['ISO8601DateTime']['output'];
  confirmedEventsCount: ConversionAnalyticsDatum;
  conversionRatePercent: ConversionAnalyticsDatum;
  endDate: Scalars['ISO8601DateTime']['output'];
  lostEventsCount: ConversionAnalyticsDatum;
  newLeadsCount: ConversionAnalyticsDatum;
  proposalSentEventsCount: ConversionAnalyticsDatum;
  startDate: Scalars['ISO8601DateTime']['output'];
  totalPaymentsAmount: ConversionAnalyticsDatum;
  totalSalesAmount: ConversionAnalyticsDatum;
  user?: Maybe<User>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of ConvertMessageToDraft */
export type ConvertMessageToDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ConvertMessageToDraft. */
export type ConvertMessageToDraftPayload = {
  __typename?: 'ConvertMessageToDraftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of CountersignContract */
export type CountersignContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  signature: Scalars['String']['input'];
};

/** Autogenerated return type of CountersignContract. */
export type CountersignContractPayload = {
  __typename?: 'CountersignContractPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateAccount */
export type CreateAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateAccount. */
export type CreateAccountPayload = {
  __typename?: 'CreateAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateAdditionalContact */
export type CreateAdditionalContactInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  plannerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateAdditionalContact. */
export type CreateAdditionalContactPayload = {
  __typename?: 'CreateAdditionalContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
  planner?: Maybe<Planner>;
};

/** Autogenerated input type of CreateAllowedOrigin */
export type CreateAllowedOriginInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateAllowedOrigin. */
export type CreateAllowedOriginPayload = {
  __typename?: 'CreateAllowedOriginPayload';
  allowedOrigin?: Maybe<AllowedOrigin>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateAssistantConversation */
export type CreateAssistantConversationInput = {
  assistantKey?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateAssistantConversation. */
export type CreateAssistantConversationPayload = {
  __typename?: 'CreateAssistantConversationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Scalars['JSON']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateAutomaticTaskTemplate */
export type CreateAutomaticTaskTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventTypeName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  taskDescription?: InputMaybe<Scalars['String']['input']>;
  taskDueDateOffsetAnchor: Scalars['String']['input'];
  taskDueDateOffsetDays: Scalars['String']['input'];
  taskDueDateOffsetDirection: Scalars['String']['input'];
  taskName: Scalars['String']['input'];
  taskOwnerId?: InputMaybe<Scalars['String']['input']>;
  trigger: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateAutomaticTaskTemplate. */
export type CreateAutomaticTaskTemplatePayload = {
  __typename?: 'CreateAutomaticTaskTemplatePayload';
  automaticTaskTemplate?: Maybe<AutomaticTaskTemplate>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateAvailabilityBlock */
export type CreateAvailabilityBlockInput = {
  blocks: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['ISO8601Date']['input'];
  endOffset?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  spaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['ISO8601Date']['input'];
  startOffset?: InputMaybe<Scalars['Int']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateAvailabilityBlock. */
export type CreateAvailabilityBlockPayload = {
  __typename?: 'CreateAvailabilityBlockPayload';
  availabilityBlock?: Maybe<AvailabilityBlock>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateContract */
export type CreateContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateContractItem */
export type CreateContractItemInput = {
  addToMenu?: InputMaybe<Scalars['Boolean']['input']>;
  addonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  addonQuantities?: InputMaybe<Scalars['JSON']['input']>;
  addons?: InputMaybe<Array<MenuItemAddonInput>>;
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  choices?: InputMaybe<Array<MenuItemChoiceInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractFeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractId: Scalars['ID']['input'];
  contractTaxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  details?: InputMaybe<Scalars['String']['input']>;
  displayOnExpressBook?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnGuestMenu: Scalars['Boolean']['input'];
  feeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  internalDetails?: InputMaybe<Scalars['String']['input']>;
  menuCategoryId?: InputMaybe<Scalars['ID']['input']>;
  menuItemId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionQuantities?: InputMaybe<Scalars['JSON']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantitiesEditableByGuest?: InputMaybe<Scalars['Boolean']['input']>;
  quantitiesOnExtrasEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  taxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  unit: Scalars['String']['input'];
};

/** Autogenerated return type of CreateContractItem. */
export type CreateContractItemPayload = {
  __typename?: 'CreateContractItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  contractItem?: Maybe<ContractItem>;
  errors: Array<Error>;
  menuItem?: Maybe<MenuItem>;
};

/** Autogenerated return type of CreateContract. */
export type CreateContractPayload = {
  __typename?: 'CreateContractPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateContractVenuePolicy */
export type CreateContractVenuePolicyInput = {
  body: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  venuePolicyId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateContractVenuePolicy. */
export type CreateContractVenuePolicyPayload = {
  __typename?: 'CreateContractVenuePolicyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
  venuePolicy?: Maybe<VenuePolicy>;
};

/** Autogenerated input type of CreateCustomEventTypeName */
export type CreateCustomEventTypeNameInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCustomEventTypeName. */
export type CreateCustomEventTypeNamePayload = {
  __typename?: 'CreateCustomEventTypeNamePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventType?: Maybe<EventType>;
};

/** Autogenerated input type of CreateCustomGoalView */
export type CreateCustomGoalViewInput = {
  breakdownType: CustomGoalViewBreakdown;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  interval: CustomGoalViewInterval;
  metric: CustomGoalViewMetric;
  name: Scalars['String']['input'];
  organizationMembershipIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  year: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateCustomGoalView. */
export type CreateCustomGoalViewPayload = {
  __typename?: 'CreateCustomGoalViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customGoalView?: Maybe<CustomGoalView>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateCventEvent */
export type CreateCventEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCventEvent. */
export type CreateCventEventPayload = {
  __typename?: 'CreateCventEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cventIntegrationSync?: Maybe<EventIntegrationSync>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateCventIntegration */
export type CreateCventIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCventIntegration. */
export type CreateCventIntegrationPayload = {
  __typename?: 'CreateCventIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  cventIntegration?: Maybe<CventIntegration>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateDirectUpload */
export type CreateDirectUploadInput = {
  byteSize: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

/** Autogenerated return type of CreateDirectUpload. */
export type CreateDirectUploadPayload = {
  __typename?: 'CreateDirectUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  directUploadResult?: Maybe<ActiveStorageDirectUploadResult>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateDocumentTemplate */
export type CreateDocumentTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateDocumentTemplate. */
export type CreateDocumentTemplatePayload = {
  __typename?: 'CreateDocumentTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  documentTemplate?: Maybe<DocumentTemplate>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateEmailTemplate */
export type CreateEmailTemplateInput = {
  attachmentFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  attachmentSignedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  body?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  eventTypeNames?: InputMaybe<Array<Scalars['String']['input']>>;
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reminderDays?: InputMaybe<Scalars['Int']['input']>;
  reminderDirection?: InputMaybe<EmailTemplateReminderDirection>;
  reminderEventState?: InputMaybe<Scalars['String']['input']>;
  reminderOccasion?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateEmailTemplate. */
export type CreateEmailTemplatePayload = {
  __typename?: 'CreateEmailTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailTemplate?: Maybe<EmailTemplate>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateEventDiscussionComment */
export type CreateEventDiscussionCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  mentions?: InputMaybe<Array<Scalars['ID']['input']>>;
  message: Scalars['String']['input'];
};

/** Autogenerated return type of CreateEventDiscussionComment. */
export type CreateEventDiscussionCommentPayload = {
  __typename?: 'CreateEventDiscussionCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Comment>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateEventDocument */
export type CreateEventDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
  filename: Scalars['String']['input'];
  signedId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateEventDocument. */
export type CreateEventDocumentPayload = {
  __typename?: 'CreateEventDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateEventFloorPlan */
export type CreateEventFloorPlanInput = {
  backgroundImageSignedId?: InputMaybe<Scalars['String']['input']>;
  basis?: InputMaybe<Scalars['String']['input']>;
  canvasHeight?: InputMaybe<Scalars['Int']['input']>;
  canvasWidth?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  floorPlanTemplateId?: InputMaybe<Scalars['ID']['input']>;
  gridSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objects?: InputMaybe<Scalars['JSON']['input']>;
  snapshotSignedId?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateEventFloorPlan. */
export type CreateEventFloorPlanPayload = {
  __typename?: 'CreateEventFloorPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  eventFloorPlan?: Maybe<EventFloorPlan>;
};

/** Autogenerated input type of CreateEvent */
export type CreateEventInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateTimeRange?: InputMaybe<DateTimeRangeInput>;
  eventTypeName?: InputMaybe<Scalars['String']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageOrigin?: InputMaybe<MessageOrigin>;
  name?: InputMaybe<Scalars['String']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  organizationUserFields?: InputMaybe<Scalars['JSON']['input']>;
  origin?: InputMaybe<EventOrigin>;
  planner?: InputMaybe<PlannerInput>;
  plannerId?: InputMaybe<Scalars['ID']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  sendEmails?: InputMaybe<Scalars['Boolean']['input']>;
  spaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  spaceSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  status: EventStatus;
  stripeTokenId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  venueCollectionUserFields?: InputMaybe<Scalars['JSON']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
  venueSlug?: InputMaybe<Scalars['String']['input']>;
  venueUserFields?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of CreateEvent. */
export type CreateEventPayload = {
  __typename?: 'CreateEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of CreateEventPlan */
export type CreateEventPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endOffset?: InputMaybe<Scalars['Int']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  startOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateEventPlan. */
export type CreateEventPlanPayload = {
  __typename?: 'CreateEventPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventPlan?: Maybe<EventPlan>;
};

/** Autogenerated input type of CreateEventbriteEvent */
export type CreateEventbriteEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  eventbriteOrganizationId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateEventbriteEvent. */
export type CreateEventbriteEventPayload = {
  __typename?: 'CreateEventbriteEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventbriteIntegrationSync?: Maybe<EventIntegrationSync>;
};

/** Autogenerated input type of CreateExpressBookContractItem */
export type CreateExpressBookContractItemInput = {
  addonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  addonQuantities?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  menuItemId: Scalars['ID']['input'];
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  optionQuantities?: InputMaybe<Scalars['JSON']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateExpressBookContractItem. */
export type CreateExpressBookContractItemPayload = {
  __typename?: 'CreateExpressBookContractItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<GuestProposal>;
  contractItem?: Maybe<GuestProposalContractItem>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateFee */
export type CreateFeeInput = {
  applyToMinimum: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  taxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFee. */
export type CreateFeePayload = {
  __typename?: 'CreateFeePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  fee?: Maybe<Fee>;
};

/** Autogenerated input type of CreateFloorPlanObjectLibraryItem */
export type CreateFloorPlanObjectLibraryItemInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  chairs?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fill?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  stroke?: InputMaybe<Scalars['String']['input']>;
  typeName: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
  width: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateFloorPlanObjectLibraryItem. */
export type CreateFloorPlanObjectLibraryItemPayload = {
  __typename?: 'CreateFloorPlanObjectLibraryItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  objectLibraryItem?: Maybe<FloorPlanObjectLibraryItem>;
};

/** Autogenerated input type of CreateFloorPlanTemplate */
export type CreateFloorPlanTemplateInput = {
  backgroundImageSignedId?: InputMaybe<Scalars['String']['input']>;
  basis?: InputMaybe<Scalars['String']['input']>;
  canvasHeight?: InputMaybe<Scalars['Int']['input']>;
  canvasWidth?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gridSize?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  objects?: InputMaybe<Scalars['JSON']['input']>;
  spaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFloorPlanTemplate. */
export type CreateFloorPlanTemplatePayload = {
  __typename?: 'CreateFloorPlanTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  floorPlanTemplate?: Maybe<FloorPlanTemplate>;
};

/** Autogenerated input type of CreateFoodAndBeverageMinimum */
export type CreateFoodAndBeverageMinimumInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFoodAndBeverageMinimum. */
export type CreateFoodAndBeverageMinimumPayload = {
  __typename?: 'CreateFoodAndBeverageMinimumPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  foodAndBeverageMinimum?: Maybe<FoodAndBeverageMinimum>;
};

/** Autogenerated input type of CreateFraudTokenFromReport */
export type CreateFraudTokenFromReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
  tokenType: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Autogenerated return type of CreateFraudTokenFromReport. */
export type CreateFraudTokenFromReportPayload = {
  __typename?: 'CreateFraudTokenFromReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  fraudToken?: Maybe<FraudToken>;
  suspiciousMessageReport?: Maybe<SuspiciousMessageReport>;
};

/** Autogenerated input type of CreateFraudToken */
export type CreateFraudTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  tokenType: FraudTokenTypeEnum;
  value: Scalars['String']['input'];
};

/** Autogenerated return type of CreateFraudToken. */
export type CreateFraudTokenPayload = {
  __typename?: 'CreateFraudTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  fraudToken?: Maybe<FraudToken>;
};

/** Autogenerated input type of CreateGuestMessage */
export type CreateGuestMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  htmlBody: Scalars['String']['input'];
};

/** Autogenerated return type of CreateGuestMessage. */
export type CreateGuestMessagePayload = {
  __typename?: 'CreateGuestMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of CreateMarketplaceEvent */
export type CreateMarketplaceEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateTimeRange: DateTimeRangeInput;
  eventPlanId?: InputMaybe<Scalars['ID']['input']>;
  groupSize: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  origin: EventOrigin;
  planner?: InputMaybe<PlannerInput>;
  spaceSlug: Scalars['String']['input'];
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  venueSlug: Scalars['String']['input'];
  venueUserFields?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of CreateMarketplaceEvent. */
export type CreateMarketplaceEventPayload = {
  __typename?: 'CreateMarketplaceEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<MarketplaceEvent>;
};

/** Autogenerated input type of CreateMenuCategory */
export type CreateMenuCategoryInput = {
  applyTowardMinimum?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  menuId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  salesCategoryId?: InputMaybe<Scalars['ID']['input']>;
  taxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of CreateMenuCategory. */
export type CreateMenuCategoryPayload = {
  __typename?: 'CreateMenuCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
  menuCategory?: Maybe<MenuCategory>;
};

/** Autogenerated input type of CreateMenuItem */
export type CreateMenuItemInput = {
  addons?: InputMaybe<Array<MenuItemAddonInput>>;
  choices?: InputMaybe<Array<MenuItemChoiceInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  displayOnExpressBook?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnGuestMenu: Scalars['Boolean']['input'];
  feeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  internalDetails?: InputMaybe<Scalars['String']['input']>;
  menuCategoryId?: InputMaybe<Scalars['ID']['input']>;
  menuId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  quantitiesEditableByGuest?: InputMaybe<Scalars['Boolean']['input']>;
  quantitiesOnExtrasEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  taxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  unit: Scalars['String']['input'];
};

/** Autogenerated return type of CreateMenuItem. */
export type CreateMenuItemPayload = {
  __typename?: 'CreateMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
  menuItem?: Maybe<MenuItem>;
};

/** Autogenerated input type of CreateMerriEvent */
export type CreateMerriEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateMerriEvent. */
export type CreateMerriEventPayload = {
  __typename?: 'CreateMerriEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of CreateMessage */
export type CreateMessageInput = {
  attachmentFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  attachmentSignedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  cc?: InputMaybe<Array<EmailAddressInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  draftMessageBody?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  eventStatus?: InputMaybe<EventStatus>;
  from?: InputMaybe<EmailAddressInput>;
  htmlBody?: InputMaybe<Scalars['String']['input']>;
  origin: Scalars['String']['input'];
  scheduledSendAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  sender: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Array<EmailAddressInput>>;
};

/** Autogenerated return type of CreateMessage. */
export type CreateMessagePayload = {
  __typename?: 'CreateMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of CreateNoteTemplate */
export type CreateNoteTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateNoteTemplate. */
export type CreateNoteTemplatePayload = {
  __typename?: 'CreateNoteTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  noteTemplate?: Maybe<NoteTemplate>;
};

/** Autogenerated input type of CreateOauthApplication */
export type CreateOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  logoSignedId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  private?: InputMaybe<Scalars['Boolean']['input']>;
  redirectUri: Scalars['String']['input'];
};

/** Autogenerated return type of CreateOauthApplication. */
export type CreateOauthApplicationPayload = {
  __typename?: 'CreateOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  oauthApplication?: Maybe<OauthApplication>;
};

/** Autogenerated input type of CreateOfflineCommunication */
export type CreateOfflineCommunicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  kind: OfflineCommunicationKind;
  note?: InputMaybe<Scalars['String']['input']>;
  occurredAt: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CreateOfflineCommunication. */
export type CreateOfflineCommunicationPayload = {
  __typename?: 'CreateOfflineCommunicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  offlineCommunication?: Maybe<OfflineCommunication>;
};

/** Autogenerated input type of CreateOrganizationDocument */
export type CreateOrganizationDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  filename: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  signedId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOrganizationDocument. */
export type CreateOrganizationDocumentPayload = {
  __typename?: 'CreateOrganizationDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateOrganizationEmailTemplate */
export type CreateOrganizationEmailTemplateInput = {
  attachmentFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  attachmentSignedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  body?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  eventTypeNames?: InputMaybe<Array<Scalars['String']['input']>>;
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  reminderDays?: InputMaybe<Scalars['Int']['input']>;
  reminderDirection?: InputMaybe<EmailTemplateReminderDirection>;
  reminderEventState?: InputMaybe<Scalars['String']['input']>;
  reminderOccasion?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOrganizationEmailTemplate. */
export type CreateOrganizationEmailTemplatePayload = {
  __typename?: 'CreateOrganizationEmailTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailTemplate?: Maybe<EmailTemplate>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateOrganizationMembership */
export type CreateOrganizationMembershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  newLeadsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  newLeadsSms?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  ownerAssignedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  paymentEmails?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  reviewSubmittedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  role: Role;
  teamMessageEmail?: InputMaybe<Scalars['Boolean']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
  weeklyDigestEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateOrganizationMembership. */
export type CreateOrganizationMembershipPayload = {
  __typename?: 'CreateOrganizationMembershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organizationMembership?: Maybe<OrganizationMembership>;
};

/** Autogenerated input type of CreateOrganizationPaymentMethod */
export type CreateOrganizationPaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  setupIntentId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateOrganizationPaymentMethod. */
export type CreateOrganizationPaymentMethodPayload = {
  __typename?: 'CreateOrganizationPaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of CreateOrganizationSetupIntent */
export type CreateOrganizationSetupIntentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateOrganizationSetupIntent. */
export type CreateOrganizationSetupIntentPayload = {
  __typename?: 'CreateOrganizationSetupIntentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  stripeSetupIntentId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreatePayment */
export type CreatePaymentInput = {
  amount: Scalars['Int']['input'];
  attachInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  kind: PaymentKind;
  mechanism: PaymentMechanism;
  name: Scalars['String']['input'];
  offlineMethod?: InputMaybe<Scalars['String']['input']>;
  paidAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  scheduledAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  squareTokenId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreatePayment. */
export type CreatePaymentPayload = {
  __typename?: 'CreatePaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  payment?: Maybe<Payment>;
};

/** Autogenerated input type of CreatePlanner */
export type CreatePlannerInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePlanner. */
export type CreatePlannerPayload = {
  __typename?: 'CreatePlannerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  planner?: Maybe<Planner>;
};

/** Autogenerated input type of CreatePolicySection */
export type CreatePolicySectionInput = {
  body: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePolicySection. */
export type CreatePolicySectionPayload = {
  __typename?: 'CreatePolicySectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  policySection?: Maybe<PolicySection>;
};

/** Autogenerated input type of CreatePrismmIntegration */
export type CreatePrismmIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePrismmIntegration. */
export type CreatePrismmIntegrationPayload = {
  __typename?: 'CreatePrismmIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  prismmIntegration?: Maybe<PrismmIntegration>;
};

/** Autogenerated input type of CreatePrismmOccasion */
export type CreatePrismmOccasionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePrismmOccasion. */
export type CreatePrismmOccasionPayload = {
  __typename?: 'CreatePrismmOccasionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  occasionId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateRecurringEvent */
export type CreateRecurringEventInput = {
  budget?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateTimeRange?: InputMaybe<DateTimeRangeInput>;
  freq?: InputMaybe<Scalars['String']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planner: PlannerInput;
  spaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateRecurringEvent. */
export type CreateRecurringEventPayload = {
  __typename?: 'CreateRecurringEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  recurringEvent?: Maybe<RecurringEvent>;
};

/** Autogenerated input type of CreateReportView */
export type CreateReportViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<ReportColumnInput>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  kind: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateReportView. */
export type CreateReportViewPayload = {
  __typename?: 'CreateReportViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reportView?: Maybe<ReportView>;
};

/** Autogenerated input type of CreateSalesCategory */
export type CreateSalesCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateSalesCategory. */
export type CreateSalesCategoryPayload = {
  __typename?: 'CreateSalesCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
  salesCategory?: Maybe<SalesCategory>;
};

/** Autogenerated input type of CreateSession */
export type CreateSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateTimeRange?: InputMaybe<DateTimeRangeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  spaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of CreateSession. */
export type CreateSessionPayload = {
  __typename?: 'CreateSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
  session?: Maybe<Session>;
};

/** Autogenerated input type of CreateSetupIntent */
export type CreateSetupIntentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mechanism?: InputMaybe<SetupIntentMechanism>;
  plannerId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSetupIntent. */
export type CreateSetupIntentPayload = {
  __typename?: 'CreateSetupIntentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
  stripeSetupIntentId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateSpace */
export type CreateSpaceInput = {
  amenityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  childSpaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayColor?: InputMaybe<Scalars['String']['input']>;
  displayInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  expressBookEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreConflicts?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  imageSignedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  seated?: InputMaybe<Scalars['Int']['input']>;
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
  standing?: InputMaybe<Scalars['Int']['input']>;
  syncToOpentable?: InputMaybe<Scalars['Boolean']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSpace. */
export type CreateSpacePayload = {
  __typename?: 'CreateSpacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  space?: Maybe<Space>;
};

/** Autogenerated input type of CreateSquarePaymentMethod */
export type CreateSquarePaymentMethodInput = {
  cardholderName?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  plannerId: Scalars['ID']['input'];
  squareTokenId: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSquarePaymentMethod. */
export type CreateSquarePaymentMethodPayload = {
  __typename?: 'CreateSquarePaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  paymentMethod?: Maybe<GuestProposalPaymentMethod>;
};

/** Autogenerated input type of CreateStripePaymentMethod */
export type CreateStripePaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  plannerId: Scalars['ID']['input'];
  stripeSetupIntentId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateStripePaymentMethod. */
export type CreateStripePaymentMethodPayload = {
  __typename?: 'CreateStripePaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  paymentMethod?: Maybe<GuestProposalPaymentMethod>;
};

/** Autogenerated input type of CreateTask */
export type CreateTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt: Scalars['ISO8601Date']['input'];
  eventId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateTask. */
export type CreateTaskPayload = {
  __typename?: 'CreateTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  task?: Maybe<Task>;
};

/** Autogenerated input type of CreateTax */
export type CreateTaxInput = {
  applyToMinimum: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateTax. */
export type CreateTaxPayload = {
  __typename?: 'CreateTaxPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  tax?: Maybe<Tax>;
};

/** Autogenerated input type of CreateUserFieldDefinition */
export type CreateUserFieldDefinitionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dataType: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayOnExternalDocs: Scalars['Boolean']['input'];
  displayOnInternalDocs: Scalars['Boolean']['input'];
  entityId: Scalars['ID']['input'];
  entityType: ContactFormEntity;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  ownerType: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  visible: Scalars['Boolean']['input'];
  visibleOnExpressBook: Scalars['Boolean']['input'];
  visibleOnGuestPortal: Scalars['Boolean']['input'];
  visibleOnQuestionnaire: Scalars['Boolean']['input'];
};

/** Autogenerated return type of CreateUserFieldDefinition. */
export type CreateUserFieldDefinitionPayload = {
  __typename?: 'CreateUserFieldDefinitionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  userFieldDefinition?: Maybe<UserFieldDefinition>;
};

/** Autogenerated input type of CreateVenueCollection */
export type CreateVenueCollectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateVenueCollection. */
export type CreateVenueCollectionPayload = {
  __typename?: 'CreateVenueCollectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venueCollection?: Maybe<VenueCollection>;
};

/** Autogenerated input type of CreateVenueDataImport */
export type CreateVenueDataImportInput = {
  accountsCsv?: InputMaybe<Scalars['Upload']['input']>;
  accountsCsvSignedId?: InputMaybe<Scalars['String']['input']>;
  accountsReportCsv?: InputMaybe<Scalars['Upload']['input']>;
  accountsReportCsvSignedId?: InputMaybe<Scalars['String']['input']>;
  beosZip?: InputMaybe<Scalars['Upload']['input']>;
  beosZipSignedId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dashboardEventsCsv?: InputMaybe<Scalars['Upload']['input']>;
  dashboardEventsCsvSignedId?: InputMaybe<Scalars['String']['input']>;
  dashboardLeadsCsv?: InputMaybe<Scalars['Upload']['input']>;
  dashboardLeadsCsvSignedId?: InputMaybe<Scalars['String']['input']>;
  eventPaymentsCsv?: InputMaybe<Scalars['Upload']['input']>;
  eventPaymentsCsvSignedId?: InputMaybe<Scalars['String']['input']>;
  eventsCsv?: InputMaybe<Scalars['Upload']['input']>;
  eventsCsvSignedId?: InputMaybe<Scalars['String']['input']>;
  leadsCsv?: InputMaybe<Scalars['Upload']['input']>;
  leadsCsvSignedId?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  nonTripleseatEventsCsv?: InputMaybe<Scalars['Upload']['input']>;
  nonTripleseatEventsCsvSignedId?: InputMaybe<Scalars['String']['input']>;
  plannersCsv?: InputMaybe<Scalars['Upload']['input']>;
  plannersCsvSignedId?: InputMaybe<Scalars['String']['input']>;
  storageUrl?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateVenueDataImport. */
export type CreateVenueDataImportPayload = {
  __typename?: 'CreateVenueDataImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venueDataImport?: Maybe<VenueDataImport>;
};

/** Autogenerated input type of CreateVenueDocument */
export type CreateVenueDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  filename: Scalars['String']['input'];
  signedId?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateVenueDocument. */
export type CreateVenueDocumentPayload = {
  __typename?: 'CreateVenueDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateVenueEmailTemplate */
export type CreateVenueEmailTemplateInput = {
  attachmentFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  attachmentSignedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  body?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  eventTypeNames?: InputMaybe<Array<Scalars['String']['input']>>;
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  reminderDays?: InputMaybe<Scalars['Int']['input']>;
  reminderDirection?: InputMaybe<EmailTemplateReminderDirection>;
  reminderEventState?: InputMaybe<Scalars['String']['input']>;
  reminderOccasion?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateVenueEmailTemplate. */
export type CreateVenueEmailTemplatePayload = {
  __typename?: 'CreateVenueEmailTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailTemplate?: Maybe<EmailTemplate>;
  errors: Array<Error>;
};

/** Autogenerated input type of CreateVenue */
export type CreateVenueInput = {
  achEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress?: InputMaybe<AddressInput>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numberOfTrialDays?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  planDefinitionId: Scalars['ID']['input'];
  stripeSourceId?: InputMaybe<Scalars['String']['input']>;
  stripeTokenId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateVenue. */
export type CreateVenuePayload = {
  __typename?: 'CreateVenuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of CreateVenuePolicy */
export type CreateVenuePolicyInput = {
  body?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sections?: InputMaybe<Array<VenuePolicySectionInput>>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateVenuePolicy. */
export type CreateVenuePolicyPayload = {
  __typename?: 'CreateVenuePolicyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venuePolicy?: Maybe<VenuePolicy>;
};

/** Autogenerated input type of CreateWebsiteScan */
export type CreateWebsiteScanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  seedUrl?: InputMaybe<Scalars['ID']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateWebsiteScan. */
export type CreateWebsiteScanPayload = {
  __typename?: 'CreateWebsiteScanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  websiteScan?: Maybe<WebsiteScan>;
};

export type CustomGoalView = {
  __typename?: 'CustomGoalView';
  breakdownType: CustomGoalViewBreakdown;
  id: Scalars['ID']['output'];
  interval: CustomGoalViewInterval;
  metric: CustomGoalViewMetric;
  name: Scalars['String']['output'];
  organizationMemberships: Array<OrganizationMembership>;
  venues: Array<Venue>;
  year: Scalars['Int']['output'];
};

export enum CustomGoalViewBreakdown {
  User = 'user',
  Venue = 'venue',
}

export enum CustomGoalViewInterval {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly',
}

export enum CustomGoalViewMetric {
  GrandTotal = 'grand_total',
  NumberOfEvents = 'number_of_events',
  Subtotal = 'subtotal',
}

/** Autogenerated input type of CustomizeContractPolicy */
export type CustomizeContractPolicyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
};

/** Autogenerated return type of CustomizeContractPolicy. */
export type CustomizeContractPolicyPayload = {
  __typename?: 'CustomizeContractPolicyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
};

export type CventIntegration = {
  __typename?: 'CventIntegration';
  canConfigure: AuthorizationResult;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  user: User;
};

export type DateTimeRange = {
  __typename?: 'DateTimeRange';
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
};

/** Start and end date and time to express general range of time */
export type DateTimeRangeInput = {
  /** End Date for the filter */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** End Date offset for the filter */
  endOffset?: InputMaybe<Scalars['Int']['input']>;
  /** Start Date */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Start Date offset for the filter */
  startOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of DeclineEventPlanInvitation */
export type DeclineEventPlanInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeclineEventPlanInvitation. */
export type DeclineEventPlanInvitationPayload = {
  __typename?: 'DeclineEventPlanInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeclineExpressBookRequest */
export type DeclineExpressBookRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeclineExpressBookRequest. */
export type DeclineExpressBookRequestPayload = {
  __typename?: 'DeclineExpressBookRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  expressBookRequest?: Maybe<ExpressBookRequest>;
};

/** Autogenerated input type of DeleteAllowedOrigin */
export type DeleteAllowedOriginInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAllowedOrigin. */
export type DeleteAllowedOriginPayload = {
  __typename?: 'DeleteAllowedOriginPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteContract */
export type DeleteContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteContract. */
export type DeleteContractPayload = {
  __typename?: 'DeleteContractPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteCustomGoalView */
export type DeleteCustomGoalViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCustomGoalView. */
export type DeleteCustomGoalViewPayload = {
  __typename?: 'DeleteCustomGoalViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteEventFloorPlan */
export type DeleteEventFloorPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteEventFloorPlan. */
export type DeleteEventFloorPlanPayload = {
  __typename?: 'DeleteEventFloorPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteEvent */
export type DeleteEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteEvent. */
export type DeleteEventPayload = {
  __typename?: 'DeleteEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of DeleteFloorPlanObjectLibraryItem */
export type DeleteFloorPlanObjectLibraryItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFloorPlanObjectLibraryItem. */
export type DeleteFloorPlanObjectLibraryItemPayload = {
  __typename?: 'DeleteFloorPlanObjectLibraryItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteFloorPlanTemplate */
export type DeleteFloorPlanTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFloorPlanTemplate. */
export type DeleteFloorPlanTemplatePayload = {
  __typename?: 'DeleteFloorPlanTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteFoodAndBeverageMinimum */
export type DeleteFoodAndBeverageMinimumInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFoodAndBeverageMinimum. */
export type DeleteFoodAndBeverageMinimumPayload = {
  __typename?: 'DeleteFoodAndBeverageMinimumPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteFraudToken */
export type DeleteFraudTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFraudToken. */
export type DeleteFraudTokenPayload = {
  __typename?: 'DeleteFraudTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  fraudToken?: Maybe<FraudToken>;
};

/** Autogenerated input type of DeleteMessage */
export type DeleteMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteMessage. */
export type DeleteMessagePayload = {
  __typename?: 'DeleteMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of DeleteMessages */
export type DeleteMessagesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of DeleteMessages. */
export type DeleteMessagesPayload = {
  __typename?: 'DeleteMessagesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedIds: Array<Scalars['ID']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteOauthApplication */
export type DeleteOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteOauthApplication. */
export type DeleteOauthApplicationPayload = {
  __typename?: 'DeleteOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeletePolicySection */
export type DeletePolicySectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePolicySection. */
export type DeletePolicySectionPayload = {
  __typename?: 'DeletePolicySectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  policySection?: Maybe<PolicySection>;
};

/** Autogenerated input type of DeleteVenueFee */
export type DeleteVenueFeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVenueFee. */
export type DeleteVenueFeePayload = {
  __typename?: 'DeleteVenueFeePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteVenuePolicy */
export type DeleteVenuePolicyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVenuePolicy. */
export type DeleteVenuePolicyPayload = {
  __typename?: 'DeleteVenuePolicyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of DeleteVenueTax */
export type DeleteVenueTaxInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVenueTax. */
export type DeleteVenueTaxPayload = {
  __typename?: 'DeleteVenueTaxPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type DirectUpload = {
  __typename?: 'DirectUpload';
  headers: Scalars['JSON']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of DiscardAssistantUpload */
export type DiscardAssistantUploadInput = {
  attachmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['ID']['input'];
};

/** Autogenerated return type of DiscardAssistantUpload. */
export type DiscardAssistantUploadPayload = {
  __typename?: 'DiscardAssistantUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  result?: Maybe<Scalars['JSON']['output']>;
};

/** Autogenerated input type of DiscardPlanner */
export type DiscardPlannerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DiscardPlanner. */
export type DiscardPlannerPayload = {
  __typename?: 'DiscardPlannerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  planner?: Maybe<Planner>;
};

/** Autogenerated input type of DisconnectCventIntegration */
export type DisconnectCventIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DisconnectCventIntegration. */
export type DisconnectCventIntegrationPayload = {
  __typename?: 'DisconnectCventIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DisconnectEventbriteIntegration */
export type DisconnectEventbriteIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DisconnectEventbriteIntegration. */
export type DisconnectEventbriteIntegrationPayload = {
  __typename?: 'DisconnectEventbriteIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DisconnectSevenShiftsIntegration */
export type DisconnectSevenShiftsIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DisconnectSevenShiftsIntegration. */
export type DisconnectSevenShiftsIntegrationPayload = {
  __typename?: 'DisconnectSevenShiftsIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DisconnectStripeAccount */
export type DisconnectStripeAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmation: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of DisconnectStripeAccount. */
export type DisconnectStripeAccountPayload = {
  __typename?: 'DisconnectStripeAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venue?: Maybe<Venue>;
};

export type Discussion = {
  __typename?: 'Discussion';
  id: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DismissSuggestedAction */
export type DismissSuggestedActionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DismissSuggestedAction. */
export type DismissSuggestedActionPayload = {
  __typename?: 'DismissSuggestedActionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  suggestedAction?: Maybe<SuggestedAction>;
};

export type Document = {
  __typename?: 'Document';
  archived?: Maybe<Scalars['Boolean']['output']>;
  byteSize?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  filename: Scalars['String']['output'];
  generated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentTemplate = {
  __typename?: 'DocumentTemplate';
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venue: Venue;
};

/** Autogenerated input type of DuplicateEvent */
export type DuplicateEventInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateTimeRange?: InputMaybe<DateTimeRangeInput>;
  duplicateEventId: Scalars['ID']['input'];
  eventTypeName?: InputMaybe<Scalars['String']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<EventOrigin>;
  planner?: InputMaybe<PlannerInput>;
  plannerId?: InputMaybe<Scalars['ID']['input']>;
  spaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<EventStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of DuplicateEvent. */
export type DuplicateEventPayload = {
  __typename?: 'DuplicateEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of DuplicateFloorPlanTemplate */
export type DuplicateFloorPlanTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of DuplicateFloorPlanTemplate. */
export type DuplicateFloorPlanTemplatePayload = {
  __typename?: 'DuplicateFloorPlanTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  floorPlanTemplate?: Maybe<FloorPlanTemplate>;
};

/** Autogenerated input type of DuplicateMenuItem */
export type DuplicateMenuItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DuplicateMenuItem. */
export type DuplicateMenuItemPayload = {
  __typename?: 'DuplicateMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
  menuItem?: Maybe<MenuItem>;
};

/** Autogenerated input type of DuplicatePolicySection */
export type DuplicatePolicySectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DuplicatePolicySection. */
export type DuplicatePolicySectionPayload = {
  __typename?: 'DuplicatePolicySectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  policySection?: Maybe<PolicySection>;
};

/** Autogenerated input type of DuplicateVenuePolicy */
export type DuplicateVenuePolicyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DuplicateVenuePolicy. */
export type DuplicateVenuePolicyPayload = {
  __typename?: 'DuplicateVenuePolicyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venuePolicy?: Maybe<VenuePolicy>;
};

export type EmailAddress = {
  __typename?: 'EmailAddress';
  address: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  gravatarUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EmailAddressInput = {
  /** Last Name */
  address: Scalars['String']['input'];
  /** Display Name */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Is Invalid */
  isInvalid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  body?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  documents?: Maybe<Array<Document>>;
  enabled: Scalars['Boolean']['output'];
  eventTypeNames: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  reminderDays?: Maybe<Scalars['Int']['output']>;
  reminderDirection?: Maybe<EmailTemplateReminderDirection>;
  reminderEventState?: Maybe<Scalars['String']['output']>;
  reminderOccasion?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum EmailTemplateReminderDirection {
  After = 'after',
  Before = 'before',
}

/** A user-readable error */
export type Error = {
  __typename?: 'Error';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type Event = {
  __typename?: 'Event';
  acceptedContract?: Maybe<Contract>;
  additionalContacts: Array<Planner>;
  amount?: Maybe<Scalars['Int']['output']>;
  /** Whether the event message thread has been archived from the inbox */
  archived: Scalars['Boolean']['output'];
  budget?: Maybe<Scalars['Int']['output']>;
  budgetOrContractAmount?: Maybe<Scalars['Int']['output']>;
  canShowEventBudget: AuthorizationResult;
  canUpdate: AuthorizationResult;
  cancelReason?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  confirmationPath?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  contract?: Maybe<Contract>;
  contracts: Array<Contract>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdAtDate: Scalars['ISO8601Date']['output'];
  createdByGuest?: Maybe<Scalars['Boolean']['output']>;
  customFieldValues: Scalars['JSON']['output'];
  cventIntegrationSync?: Maybe<EventIntegrationSync>;
  cventSyncEligibility: IntegrationSyncEligibility;
  depositAmount?: Maybe<Scalars['Int']['output']>;
  depositPayment?: Maybe<Payment>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  documents: Array<Document>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventFloorPlans: Array<EventFloorPlan>;
  eventType?: Maybe<Scalars['String']['output']>;
  eventTypeName?: Maybe<Scalars['String']['output']>;
  eventbriteIntegrationSync?: Maybe<EventIntegrationSync>;
  eventbriteSyncEligibility: IntegrationSyncEligibility;
  fraudDetections: Array<FraudDetection>;
  groupSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  internalNoteHtml?: Maybe<Scalars['String']['output']>;
  interpolatedInternalNoteHtml?: Maybe<Scalars['String']['output']>;
  interpolatedProposalNoteHtml?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lastEmailedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latestMessage?: Maybe<Message>;
  lostReasonCategories?: Maybe<Array<LostReasonCategory>>;
  markedFraudulentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  merriId?: Maybe<Scalars['Int']['output']>;
  messages: Array<Message>;
  multiDayEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numDays?: Maybe<Scalars['Int']['output']>;
  offlineCommunications: Array<OfflineCommunication>;
  opentableIntegrationSync?: Maybe<EventIntegrationSync>;
  opentableSyncEligibility: IntegrationSyncEligibility;
  origin: EventOrigin;
  otherAmount?: Maybe<Scalars['Int']['output']>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  paymentProvider: PaymentProvider;
  payments: Array<Payment>;
  planner?: Maybe<Planner>;
  prismmId?: Maybe<Scalars['String']['output']>;
  proposalNoteHtml?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Int']['output']>;
  refundedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rehearsalEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  rehearsalEndOffset?: Maybe<Scalars['Int']['output']>;
  rehearsalStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  rehearsalStartOffset?: Maybe<Scalars['Int']['output']>;
  remainingBalanceAmount?: Maybe<Scalars['Int']['output']>;
  remainingBalancePayment?: Maybe<Payment>;
  review?: Maybe<Review>;
  seatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  seniorSpace?: Maybe<Space>;
  sessions: Array<Session>;
  sevenShiftsIntegrationSync?: Maybe<EventIntegrationSync>;
  sevenShiftsSyncEligibility: IntegrationSyncEligibility;
  skipFraudDetection: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  smartFieldValues: Scalars['JSON']['output'];
  spaceAvailability?: Maybe<Scalars['JSON']['output']>;
  spaces: Array<Space>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: EventStatus;
  suggestedActions: SuggestedActionConnection;
  tasks: Array<Task>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
  totalBySalesCategoryName: Scalars['JSON']['output'];
  tourEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  tourEndOffset?: Maybe<Scalars['Int']['output']>;
  tourStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  tourStartOffset?: Maybe<Scalars['Int']['output']>;
  unreadMessageCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  userFields: Scalars['JSON']['output'];
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  valueForReporting?: Maybe<Scalars['Int']['output']>;
  venue: Venue;
};

export type EventSuggestedActionsArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Event. */
export type EventConnection = {
  __typename?: 'EventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Event>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventEdge = {
  __typename?: 'EventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Event>;
};

export type EventFloorPlan = {
  __typename?: 'EventFloorPlan';
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  basis: Scalars['String']['output'];
  canvasHeight: Scalars['Int']['output'];
  canvasWidth: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: Event;
  eventId: Scalars['ID']['output'];
  floorPlanTemplate?: Maybe<FloorPlanTemplate>;
  floorPlanTemplateId?: Maybe<Scalars['ID']['output']>;
  gridSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  objects: Scalars['JSON']['output'];
  snapshotBase64?: Maybe<Scalars['String']['output']>;
  snapshotUrl?: Maybe<Scalars['String']['output']>;
  space?: Maybe<Space>;
  spaceId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venue: Venue;
};

export type EventIntegrationSync = {
  __typename?: 'EventIntegrationSync';
  createdAt: Scalars['ISO8601DateTime']['output'];
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  event: Event;
  eventId?: Maybe<Scalars['ID']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  eventStatus?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalStatus?: Maybe<Scalars['String']['output']>;
  groupSize?: Maybe<Scalars['Int']['output']>;
  guestEmail?: Maybe<Scalars['String']['output']>;
  guestName?: Maybe<Scalars['String']['output']>;
  guestPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  metadata: Scalars['JSON']['output'];
  opentableCustomInstructions?: Maybe<Scalars['String']['output']>;
  opentableRestaurantId?: Maybe<Scalars['String']['output']>;
  spaceNames?: Maybe<Scalars['String']['output']>;
  stale: Scalars['Boolean']['output'];
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venueId?: Maybe<Scalars['ID']['output']>;
  venueName?: Maybe<Scalars['String']['output']>;
};

/** The connection type for EventIntegrationSync. */
export type EventIntegrationSyncConnection = {
  __typename?: 'EventIntegrationSyncConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventIntegrationSyncEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EventIntegrationSync>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventIntegrationSyncEdge = {
  __typename?: 'EventIntegrationSyncEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EventIntegrationSync>;
};

export enum EventOrigin {
  AvailabilityCheck = 'availability_check',
  ConceptContactForm = 'concept_contact_form',
  ContactForm = 'contact_form',
  Dashboard = 'dashboard',
  EmailApi = 'email_api',
  ExpressBook = 'express_book',
  LeadFormApi = 'lead_form_api',
  Migration = 'migration',
  OrganizationContactForm = 'organization_contact_form',
  RestApi = 'rest_api',
}

export type EventPlan = {
  __typename?: 'EventPlan';
  collaborators: Array<Guest>;
  endDate?: Maybe<Scalars['String']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  events: Array<MarketplaceEvent>;
  groupSize?: Maybe<Scalars['Int']['output']>;
  guest: Guest;
  id: Scalars['ID']['output'];
  invitations: Array<EventPlanInvitation>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
};

export type EventPlanInvitation = {
  __typename?: 'EventPlanInvitation';
  createdAt: Scalars['String']['output'];
  eventPlan: EventPlan;
  id: Scalars['ID']['output'];
  inviteeEmail: Scalars['String']['output'];
  inviter: Guest;
  updatedAt: Scalars['String']['output'];
};

export type EventPolicySection = {
  __typename?: 'EventPolicySection';
  body: Scalars['JSON']['output'];
  html: Scalars['String']['output'];
  initialData?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  requiresInitial: Scalars['Boolean']['output'];
};

/** Event Policy Section Input */
export type EventPolicySectionInput = {
  /** Body */
  body: Scalars['JSON']['input'];
  /** Name */
  name: Scalars['String']['input'];
  /** Position */
  position: Scalars['Int']['input'];
  /** Requires Initial */
  requiresInitial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventSearchResult = {
  __typename?: 'EventSearchResult';
  acceptedContract?: Maybe<Contract>;
  additionalContacts: Array<Planner>;
  amount?: Maybe<Scalars['Int']['output']>;
  /** Whether the event message thread has been archived from the inbox */
  archived: Scalars['Boolean']['output'];
  budget?: Maybe<Scalars['Int']['output']>;
  budgetOrContractAmount?: Maybe<Scalars['Int']['output']>;
  canShowEventBudget: AuthorizationResult;
  canUpdate: AuthorizationResult;
  cancelReason?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  confirmationPath?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  contract?: Maybe<Contract>;
  contracts: Array<Contract>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdAtDate: Scalars['ISO8601Date']['output'];
  createdByGuest?: Maybe<Scalars['Boolean']['output']>;
  customFieldValues: Scalars['JSON']['output'];
  cventIntegrationSync?: Maybe<EventIntegrationSync>;
  cventSyncEligibility: IntegrationSyncEligibility;
  depositAmount?: Maybe<Scalars['Int']['output']>;
  depositPayment?: Maybe<Payment>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  documents: Array<Document>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventFloorPlans: Array<EventFloorPlan>;
  eventType?: Maybe<Scalars['String']['output']>;
  eventTypeName?: Maybe<Scalars['String']['output']>;
  eventbriteIntegrationSync?: Maybe<EventIntegrationSync>;
  eventbriteSyncEligibility: IntegrationSyncEligibility;
  fraudDetections: Array<FraudDetection>;
  groupSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  internalNoteHtml?: Maybe<Scalars['String']['output']>;
  interpolatedInternalNoteHtml?: Maybe<Scalars['String']['output']>;
  interpolatedProposalNoteHtml?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lastEmailedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latestMessage?: Maybe<Message>;
  lostReasonCategories?: Maybe<Array<LostReasonCategory>>;
  markedFraudulentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  merriId?: Maybe<Scalars['Int']['output']>;
  messages: Array<Message>;
  multiDayEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numDays?: Maybe<Scalars['Int']['output']>;
  offlineCommunications: Array<OfflineCommunication>;
  opentableIntegrationSync?: Maybe<EventIntegrationSync>;
  opentableSyncEligibility: IntegrationSyncEligibility;
  origin: EventOrigin;
  otherAmount?: Maybe<Scalars['Int']['output']>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  paymentProvider: PaymentProvider;
  payments: Array<Payment>;
  planner?: Maybe<Planner>;
  prismmId?: Maybe<Scalars['String']['output']>;
  proposalNoteHtml?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Int']['output']>;
  refundedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rehearsalEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  rehearsalEndOffset?: Maybe<Scalars['Int']['output']>;
  rehearsalStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  rehearsalStartOffset?: Maybe<Scalars['Int']['output']>;
  remainingBalanceAmount?: Maybe<Scalars['Int']['output']>;
  remainingBalancePayment?: Maybe<Payment>;
  review?: Maybe<Review>;
  seatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  seniorSpace?: Maybe<Space>;
  sessions: Array<Session>;
  sevenShiftsIntegrationSync?: Maybe<EventIntegrationSync>;
  sevenShiftsSyncEligibility: IntegrationSyncEligibility;
  skipFraudDetection: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  smartFieldValues: Scalars['JSON']['output'];
  spaceAvailability?: Maybe<Scalars['JSON']['output']>;
  spaces: Array<Space>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: EventStatus;
  suggestedActions: SuggestedActionConnection;
  tasks: Array<Task>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
  totalBySalesCategoryName: Scalars['JSON']['output'];
  tourEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  tourEndOffset?: Maybe<Scalars['Int']['output']>;
  tourStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  tourStartOffset?: Maybe<Scalars['Int']['output']>;
  unreadMessageCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  userFields: Scalars['JSON']['output'];
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  valueForReporting?: Maybe<Scalars['Int']['output']>;
  venue: Venue;
};

export type EventSearchResultSuggestedActionsArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for EventSearchResult. */
export type EventSearchResultConnection = {
  __typename?: 'EventSearchResultConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EventSearchResultEdge>>>;
  id: Scalars['ID']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EventSearchResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  query: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventSearchResultEdge = {
  __typename?: 'EventSearchResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EventSearchResult>;
};

export enum EventStatus {
  BalanceDue = 'balance_due',
  Canceled = 'canceled',
  Completed = 'completed',
  Confirmed = 'confirmed',
  Lead = 'lead',
  Lost = 'lost',
  Pending = 'pending',
  ProposalSent = 'proposal_sent',
  Qualified = 'qualified',
}

/** Organization-level settings for automatic event status changes */
export type EventStatusAutomationSettings = {
  __typename?: 'EventStatusAutomationSettings';
  /** Mark unpaid tentative events Lost once their event date has passed */
  cancelTentativeEventsAfterEvent: Scalars['Boolean']['output'];
  /** Move fully paid Confirmed events to Completed the day after the event */
  completePaidEventsAfterEvent: Scalars['Boolean']['output'];
  /** Move events to Confirmed when the proposal is signed or a deposit is paid */
  confirmOnSignatureOrDeposit: Scalars['Boolean']['output'];
  /** Move Confirmed events with a remaining balance to Balance Due the day after the event */
  moveToBalanceDueAfterEvent: Scalars['Boolean']['output'];
};

/** Event status automation settings to change. Omitted or null settings are left as they are. */
export type EventStatusAutomationSettingsInput = {
  cancelTentativeEventsAfterEvent?: InputMaybe<Scalars['Boolean']['input']>;
  completePaidEventsAfterEvent?: InputMaybe<Scalars['Boolean']['input']>;
  confirmOnSignatureOrDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  moveToBalanceDueAfterEvent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventType = {
  __typename?: 'EventType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type EventbriteIntegration = {
  __typename?: 'EventbriteIntegration';
  canConfigure: AuthorizationResult;
  eventbriteOrganizations: Array<EventbriteOrganization>;
  id: Scalars['ID']['output'];
  organization: Organization;
  user: User;
};

export type EventbriteOrganization = {
  __typename?: 'EventbriteOrganization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated input type of ExportContactReport */
export type ExportContactReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<ReportColumnInput>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  filtersSummary?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ExportContactReport. */
export type ExportContactReportPayload = {
  __typename?: 'ExportContactReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reportExport?: Maybe<ReportExport>;
};

/** Autogenerated input type of ExportEventReportDocuments */
export type ExportEventReportDocumentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  filtersSummary?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ExportEventReportDocuments. */
export type ExportEventReportDocumentsPayload = {
  __typename?: 'ExportEventReportDocumentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reportExport?: Maybe<ReportExport>;
};

/** Autogenerated input type of ExportEventReport */
export type ExportEventReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<ReportColumnInput>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  filtersSummary?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ExportEventReport. */
export type ExportEventReportPayload = {
  __typename?: 'ExportEventReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reportExport?: Maybe<ReportExport>;
};

/** Autogenerated input type of ExportPaymentReport */
export type ExportPaymentReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<ReportColumnInput>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  filtersSummary?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ExportPaymentReport. */
export type ExportPaymentReportPayload = {
  __typename?: 'ExportPaymentReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reportExport?: Maybe<ReportExport>;
};

/** Autogenerated input type of ExportProposalReport */
export type ExportProposalReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<ReportColumnInput>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  filtersSummary?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ExportProposalReport. */
export type ExportProposalReportPayload = {
  __typename?: 'ExportProposalReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reportExport?: Maybe<ReportExport>;
};

/** Autogenerated input type of ExportVenueReport */
export type ExportVenueReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns: Array<ReportColumnInput>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ExportVenueReport. */
export type ExportVenueReportPayload = {
  __typename?: 'ExportVenueReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type ExpressBookRequest = {
  __typename?: 'ExpressBookRequest';
  deposit?: Maybe<Scalars['Int']['output']>;
  depositRate?: Maybe<Scalars['Float']['output']>;
  event: ActiveEvent;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  status: ExpressBookRequestStatus;
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for ExpressBookRequest. */
export type ExpressBookRequestConnection = {
  __typename?: 'ExpressBookRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ExpressBookRequestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ExpressBookRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ExpressBookRequestEdge = {
  __typename?: 'ExpressBookRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ExpressBookRequest>;
};

export enum ExpressBookRequestStatus {
  Accepted = 'accepted',
  Declined = 'declined',
  Expired = 'expired',
  Incomplete = 'incomplete',
  Pending = 'pending',
}

export type ExpressBookSettings = {
  __typename?: 'ExpressBookSettings';
  acceptanceTimelineHours: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maxEventDurationHours: Scalars['Float']['output'];
  maxLeadTimeDays: Scalars['Int']['output'];
  minBufferTimeHours: Scalars['Float']['output'];
  minEventDurationHours: Scalars['Float']['output'];
  minLeadTimeDays: Scalars['Int']['output'];
  spaceId?: Maybe<Scalars['ID']['output']>;
  venue: Venue;
  venueId: Scalars['ID']['output'];
  venuePolicyId?: Maybe<Scalars['ID']['output']>;
};

export type FailureReasons = {
  __typename?: 'FailureReasons';
  /** JSON-encoded map of reasons */
  details: Scalars['String']['output'];
  /** Human-readable errors */
  fullMessages: Array<Scalars['String']['output']>;
};

export type FeatureScope = {
  __typename?: 'FeatureScope';
  achEnabled: Scalars['Boolean']['output'];
  aiFeaturesEnabled: Scalars['Boolean']['output'];
  basicFeaturesEnabled: Scalars['Boolean']['output'];
  cventIntegration: Scalars['Boolean']['output'];
  enterpriseFeaturesEnabled: Scalars['Boolean']['output'];
  eventbriteIntegration: Scalars['Boolean']['output'];
  floorplanEditorEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  multipleProposalsEnabled: Scalars['Boolean']['output'];
  premiumFeaturesEnabled: Scalars['Boolean']['output'];
  proFeaturesEnabled: Scalars['Boolean']['output'];
};

export type Fee = {
  __typename?: 'Fee';
  applyToMinimum: Scalars['Boolean']['output'];
  canCreate: AuthorizationResult;
  canDelete: AuthorizationResult;
  canIndex: AuthorizationResult;
  canUpdate: AuthorizationResult;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  immutableName: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  taxes: Array<Tax>;
};

/** Autogenerated input type of FinalizeAssistantUpload */
export type FinalizeAssistantUploadInput = {
  attachmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['ID']['input'];
};

/** Autogenerated return type of FinalizeAssistantUpload. */
export type FinalizeAssistantUploadPayload = {
  __typename?: 'FinalizeAssistantUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  result?: Maybe<Scalars['JSON']['output']>;
};

export type FloorPlanObjectLibraryItem = {
  __typename?: 'FloorPlanObjectLibraryItem';
  category: Scalars['String']['output'];
  chairs: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  default: Scalars['Boolean']['output'];
  editable: Scalars['Boolean']['output'];
  fill: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stroke: Scalars['String']['output'];
  typeName: Scalars['String']['output'];
  venue?: Maybe<Venue>;
  venueId?: Maybe<Scalars['ID']['output']>;
  width: Scalars['Int']['output'];
};

export type FloorPlanTemplate = {
  __typename?: 'FloorPlanTemplate';
  backgroundImageUrl?: Maybe<Scalars['String']['output']>;
  basis: Scalars['String']['output'];
  canvasHeight: Scalars['Int']['output'];
  canvasWidth: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  gridSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  objects: Scalars['JSON']['output'];
  space: Space;
  spaceId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  usageCount: Scalars['Int']['output'];
  venue: Venue;
};

export type FoodAndBeverageMinimum = {
  __typename?: 'FoodAndBeverageMinimum';
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  venue: Venue;
};

export type FraudDetection = {
  __typename?: 'FraudDetection';
  createdAt: Scalars['ISO8601DateTime']['output'];
  detectedAt: Scalars['ISO8601DateTime']['output'];
  detectionMethod: Scalars['String']['output'];
  event: Event;
  fraudToken: FraudToken;
  id: Scalars['ID']['output'];
  matchType: FraudTokenTypeEnum;
  matchedValue: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  planner: Planner;
  reviewNotes?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  reviewedBy?: Maybe<User>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FraudToken = {
  __typename?: 'FraudToken';
  active: Scalars['Boolean']['output'];
  coDetectionCount: Scalars['Int']['output'];
  confirmedFraudCount: Scalars['Int']['output'];
  confirmedFraudDetections: Array<FraudDetection>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy?: Maybe<Admin>;
  falsePositiveCount: Scalars['Int']['output'];
  falsePositiveDetections: Array<FraudDetection>;
  fraudDetectionsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  precision?: Maybe<Scalars['Float']['output']>;
  recentDetections: Array<FraudDetection>;
  soloDetectionCount: Scalars['Int']['output'];
  soloDetectionPercentage?: Maybe<Scalars['Float']['output']>;
  tokenType: FraudTokenTypeEnum;
  unknownCount: Scalars['Int']['output'];
  unknownDetections: Array<FraudDetection>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  value: Scalars['String']['output'];
};

export type FraudTokenConfirmedFraudDetectionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type FraudTokenFalsePositiveDetectionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type FraudTokenRecentDetectionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type FraudTokenUnknownDetectionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type FraudTokenDetails = {
  __typename?: 'FraudTokenDetails';
  events: Array<Event>;
  fraudToken: FraudToken;
};

export type FraudTokenPreview = {
  __typename?: 'FraudTokenPreview';
  confirmedFraudCount: Scalars['Int']['output'];
  falsePositiveCount: Scalars['Int']['output'];
  precision?: Maybe<Scalars['Float']['output']>;
  sampleEvents: Array<Event>;
  totalEvents: Scalars['Int']['output'];
  unknownCount: Scalars['Int']['output'];
};

export enum FraudTokenTypeEnum {
  /** Email address token */
  Email = 'email',
  /** Message text pattern token */
  MessageText = 'message_text',
  /** Phone number token */
  Phone = 'phone',
}

/** Autogenerated input type of GenerateEventFloorPlansPdf */
export type GenerateEventFloorPlansPdfInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateEventFloorPlansPdf. */
export type GenerateEventFloorPlansPdfPayload = {
  __typename?: 'GenerateEventFloorPlansPdfPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  filename?: Maybe<Scalars['String']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
};

export type GoalAttainmentDatum = {
  __typename?: 'GoalAttainmentDatum';
  grandTotal: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  numberOfEvents: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  subtotal: Scalars['Int']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
  venueId: Scalars['ID']['output'];
};

export type GooglePlaceInfo = {
  __typename?: 'GooglePlaceInfo';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  mapsUrl?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviewsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Guest = {
  __typename?: 'Guest';
  address?: Maybe<Address>;
  confirmed: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  emailAddress?: Maybe<EmailAddress>;
  eventPlans: Array<EventPlan>;
  favoriteSpaces: Array<MarketplaceSpace>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gravatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  pendingReviews: Array<Review>;
  phone?: Maybe<Scalars['String']['output']>;
  unconfirmedEmail?: Maybe<Scalars['String']['output']>;
};

export type GuestAddonQuantityInput = {
  addonId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type GuestContractItemChangeInput = {
  addonQuantity?: InputMaybe<GuestAddonQuantityInput>;
  optionQuantity?: InputMaybe<GuestOptionQuantityInput>;
  toggleAddonId?: InputMaybe<Scalars['String']['input']>;
  toggleOption?: InputMaybe<GuestToggleOptionInput>;
};

export type GuestOptionQuantityInput = {
  optionId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type GuestProposal = {
  __typename?: 'GuestProposal';
  accepted: Scalars['Boolean']['output'];
  action?: Maybe<Scalars['String']['output']>;
  cardSurchargeRate: Scalars['Float']['output'];
  contractFees: Array<GuestProposalContractFee>;
  contractItems: Array<GuestProposalContractItem>;
  contractTaxes: Array<GuestProposalContractTax>;
  countersignEnabled?: Maybe<Scalars['Boolean']['output']>;
  depositAmount?: Maybe<Scalars['Int']['output']>;
  depositRate?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountEnabled: Scalars['Boolean']['output'];
  discountRate?: Maybe<Scalars['Float']['output']>;
  effectivePolicySections: Array<EventPolicySection>;
  event: GuestProposalEvent;
  expressBookMenuCategories: Array<GuestProposalMenuCategory>;
  expressBookMenuNarrowed: Scalars['Boolean']['output'];
  foodAndBeverageMinimumId?: Maybe<Scalars['ID']['output']>;
  guestPortalFields: Array<UserFieldDefinition>;
  hasEventPolicy: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lockCondition: ContractProposalLockCondition;
  locked: Scalars['Boolean']['output'];
  minimumAmount?: Maybe<Scalars['Int']['output']>;
  minimumEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  otherPaymentAmount?: Maybe<Scalars['Int']['output']>;
  paymentMethodMechanism: PaymentMethodMechanism;
  questionnaireEnabled: Scalars['Boolean']['output'];
  questionnaireFields: Array<UserFieldDefinition>;
  requiresCountersign: Scalars['Boolean']['output'];
  signature?: Maybe<Scalars['String']['output']>;
  signed: Scalars['Boolean']['output'];
  signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  totals: Scalars['JSON']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
  venuePolicy: GuestProposalVenuePolicy;
  venuePolicyHtml?: Maybe<Scalars['String']['output']>;
  venueSignature?: Maybe<Scalars['String']['output']>;
  venueSigned: Scalars['Boolean']['output'];
  venueSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type GuestProposalAccount = {
  __typename?: 'GuestProposalAccount';
  address?: Maybe<Address>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GuestProposalContractFee = {
  __typename?: 'GuestProposalContractFee';
  applyToMinimum: Scalars['Boolean']['output'];
  contractTaxes: Array<GuestProposalContractTax>;
  enabled: Scalars['Boolean']['output'];
  fee: Fee;
  feeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  overrideAmount?: Maybe<Scalars['Int']['output']>;
  rate: Scalars['Float']['output'];
};

export type GuestProposalContractItem = {
  __typename?: 'GuestProposalContractItem';
  addonIds: Scalars['JSON']['output'];
  addonQuantities: Scalars['JSON']['output'];
  addons: Array<GuestProposalMenuAddon>;
  basePrice?: Maybe<Scalars['Int']['output']>;
  choices: Array<GuestProposalMenuChoice>;
  contractFees: Array<GuestProposalContractFee>;
  contractTaxes: Array<GuestProposalContractTax>;
  details?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  discountRate?: Maybe<Scalars['Float']['output']>;
  displayOnGuestMenu: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  menuCategory?: Maybe<GuestProposalMenuCategory>;
  name: Scalars['String']['output'];
  optionIds: Scalars['JSON']['output'];
  optionQuantities: Scalars['JSON']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  quantitiesEditableByGuest: Scalars['Boolean']['output'];
  quantitiesOnExtrasEnabled: Scalars['Boolean']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
  required: Scalars['Boolean']['output'];
  sessionId?: Maybe<Scalars['ID']['output']>;
  total?: Maybe<Scalars['BigInt']['output']>;
  unit: ContractItemUnit;
};

export type GuestProposalContractItemImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type GuestProposalContractTax = {
  __typename?: 'GuestProposalContractTax';
  applyToMinimum: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  overrideAmount?: Maybe<Scalars['Int']['output']>;
  rate: Scalars['Float']['output'];
  tax: Tax;
  taxId: Scalars['ID']['output'];
};

export type GuestProposalEvent = {
  __typename?: 'GuestProposalEvent';
  contracts: Array<GuestProposal>;
  depositPayment?: Maybe<GuestProposalPayment>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventFloorPlans: Array<GuestProposalFloorPlan>;
  eventTypeName?: Maybe<Scalars['String']['output']>;
  groupSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  interpolatedProposalNoteHtml?: Maybe<Scalars['String']['output']>;
  merriId?: Maybe<Scalars['Int']['output']>;
  multiDayEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  origin: EventOrigin;
  paymentMethods?: Maybe<Array<GuestProposalPaymentMethod>>;
  paymentProvider: PaymentProvider;
  payments: Array<GuestProposalPayment>;
  planner?: Maybe<GuestProposalPlanner>;
  prismmId?: Maybe<Scalars['String']['output']>;
  proposalNoteHtml?: Maybe<Scalars['String']['output']>;
  rehearsalEndOffset?: Maybe<Scalars['Int']['output']>;
  rehearsalStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  rehearsalStartOffset?: Maybe<Scalars['Int']['output']>;
  remainingBalancePayment?: Maybe<GuestProposalPayment>;
  sessions: Array<GuestProposalSession>;
  spaces: Array<GuestProposalSpace>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: EventStatus;
  tourEndOffset?: Maybe<Scalars['Int']['output']>;
  tourStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  tourStartOffset?: Maybe<Scalars['Int']['output']>;
  userFields: Scalars['JSON']['output'];
  venue: GuestProposalVenue;
};

export type GuestProposalFeatureScope = {
  __typename?: 'GuestProposalFeatureScope';
  achEnabled: Scalars['Boolean']['output'];
  enterpriseFeaturesEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  multipleProposalsEnabled: Scalars['Boolean']['output'];
};

export type GuestProposalFloorPlan = {
  __typename?: 'GuestProposalFloorPlan';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  snapshotBase64?: Maybe<Scalars['String']['output']>;
  snapshotUrl?: Maybe<Scalars['String']['output']>;
};

export type GuestProposalMenuAddon = {
  __typename?: 'GuestProposalMenuAddon';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

export type GuestProposalMenuCategory = {
  __typename?: 'GuestProposalMenuCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type GuestProposalMenuChoice = {
  __typename?: 'GuestProposalMenuChoice';
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options: Array<GuestProposalMenuOption>;
};

export type GuestProposalMenuOption = {
  __typename?: 'GuestProposalMenuOption';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

export type GuestProposalPayment = {
  __typename?: 'GuestProposalPayment';
  amount: Scalars['Int']['output'];
  amountMinusRefundAmount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  kind: PaymentKind;
  name: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  paymentReportTypeLabel: Scalars['String']['output'];
  refundAmount?: Maybe<Scalars['Int']['output']>;
  refunds: Array<Refund>;
  scheduledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  state: Scalars['String']['output'];
  surchargeAmount: Scalars['Int']['output'];
};

export type GuestProposalPaymentMethod = {
  __typename?: 'GuestProposalPaymentMethod';
  brand?: Maybe<Scalars['String']['output']>;
  displayLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  mechanism: PaymentMethodMechanism;
  paymentProvider?: Maybe<PaymentProvider>;
  type: PaymentMethodType;
};

export type GuestProposalPlanner = {
  __typename?: 'GuestProposalPlanner';
  account?: Maybe<GuestProposalAccount>;
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  paymentMethods: Array<GuestProposalPaymentMethod>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type GuestProposalSession = {
  __typename?: 'GuestProposalSession';
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  spaces: Array<GuestProposalSpace>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type GuestProposalSpace = {
  __typename?: 'GuestProposalSpace';
  displayColor: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ignoreConflicts: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type GuestProposalVenue = {
  __typename?: 'GuestProposalVenue';
  banner?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  featureFlags: Scalars['JSON']['output'];
  featureScope: GuestProposalFeatureScope;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  squareLocationId?: Maybe<Scalars['String']['output']>;
};

export type GuestProposalVenuePolicy = {
  __typename?: 'GuestProposalVenuePolicy';
  body?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentPolicy?: Maybe<GuestProposalVenuePolicy>;
};

export type GuestToggleOptionInput = {
  choiceId: Scalars['String']['input'];
  optionId: Scalars['String']['input'];
};

/** Autogenerated input type of GuestUpdateContractItem */
export type GuestUpdateContractItemInput = {
  change: GuestContractItemChangeInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractUuid: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of GuestUpdateContractItem. */
export type GuestUpdateContractItemPayload = {
  __typename?: 'GuestUpdateContractItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<GuestProposal>;
  contractItem?: Maybe<GuestProposalContractItem>;
  errors: Array<Error>;
};

export type HoursOfOperation = {
  __typename?: 'HoursOfOperation';
  dayOfWeek: Scalars['String']['output'];
  endTime: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isOpen: Scalars['Boolean']['output'];
  startTime: Scalars['Int']['output'];
  venueId: Scalars['ID']['output'];
};

export type HubspotOwner = {
  __typename?: 'HubspotOwner';
  admin?: Maybe<Admin>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hubspotOwnerId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type HubspotOwnersInfo = {
  __typename?: 'HubspotOwnersInfo';
  accountManagementOwner?: Maybe<HubspotOwner>;
  companyOwner?: Maybe<HubspotOwner>;
  dealOwner?: Maybe<HubspotOwner>;
  error?: Maybe<Scalars['String']['output']>;
  onboardingOwner?: Maybe<HubspotOwner>;
};

/** Autogenerated input type of IgnoreSuspiciousMessageReport */
export type IgnoreSuspiciousMessageReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of IgnoreSuspiciousMessageReport. */
export type IgnoreSuspiciousMessageReportPayload = {
  __typename?: 'IgnoreSuspiciousMessageReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  suspiciousMessageReport?: Maybe<SuspiciousMessageReport>;
};

export type Image = {
  __typename?: 'Image';
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InboxEvent = {
  __typename?: 'InboxEvent';
  acceptedContract?: Maybe<Contract>;
  additionalContacts: Array<Planner>;
  amount?: Maybe<Scalars['Int']['output']>;
  /** Whether the event message thread has been archived from the inbox */
  archived: Scalars['Boolean']['output'];
  budget?: Maybe<Scalars['Int']['output']>;
  budgetOrContractAmount?: Maybe<Scalars['Int']['output']>;
  canShowEventBudget: AuthorizationResult;
  canUpdate: AuthorizationResult;
  cancelReason?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  confirmationPath?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  contract?: Maybe<Contract>;
  contracts: Array<Contract>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdAtDate: Scalars['ISO8601Date']['output'];
  createdByGuest?: Maybe<Scalars['Boolean']['output']>;
  customFieldValues: Scalars['JSON']['output'];
  cventIntegrationSync?: Maybe<EventIntegrationSync>;
  cventSyncEligibility: IntegrationSyncEligibility;
  depositAmount?: Maybe<Scalars['Int']['output']>;
  depositPayment?: Maybe<Payment>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  documents: Array<Document>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventFloorPlans: Array<EventFloorPlan>;
  eventType?: Maybe<Scalars['String']['output']>;
  eventTypeName?: Maybe<Scalars['String']['output']>;
  eventbriteIntegrationSync?: Maybe<EventIntegrationSync>;
  eventbriteSyncEligibility: IntegrationSyncEligibility;
  fraudDetections: Array<FraudDetection>;
  groupSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  internalNoteHtml?: Maybe<Scalars['String']['output']>;
  interpolatedInternalNoteHtml?: Maybe<Scalars['String']['output']>;
  interpolatedProposalNoteHtml?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lastEmailedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Newest sent or received message on the event, used for the inbox row preview */
  lastSentMessage?: Maybe<MessagePreview>;
  latestMessage?: Maybe<Message>;
  /** @deprecated Use lastSentMessage, which reads the cached pointer and only loads preview columns */
  latestMessageBatched?: Maybe<Array<Message>>;
  lostReasonCategories?: Maybe<Array<LostReasonCategory>>;
  markedFraudulentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  merriId?: Maybe<Scalars['Int']['output']>;
  messages: Array<Message>;
  multiDayEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numDays?: Maybe<Scalars['Int']['output']>;
  offlineCommunications: Array<OfflineCommunication>;
  opentableIntegrationSync?: Maybe<EventIntegrationSync>;
  opentableSyncEligibility: IntegrationSyncEligibility;
  origin: EventOrigin;
  otherAmount?: Maybe<Scalars['Int']['output']>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  paymentProvider: PaymentProvider;
  payments: Array<Payment>;
  planner?: Maybe<Planner>;
  prismmId?: Maybe<Scalars['String']['output']>;
  proposalNoteHtml?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Int']['output']>;
  refundedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rehearsalEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  rehearsalEndOffset?: Maybe<Scalars['Int']['output']>;
  rehearsalStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  rehearsalStartOffset?: Maybe<Scalars['Int']['output']>;
  remainingBalanceAmount?: Maybe<Scalars['Int']['output']>;
  remainingBalancePayment?: Maybe<Payment>;
  review?: Maybe<Review>;
  seatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  seniorSpace?: Maybe<Space>;
  sessions: Array<Session>;
  sevenShiftsIntegrationSync?: Maybe<EventIntegrationSync>;
  sevenShiftsSyncEligibility: IntegrationSyncEligibility;
  skipFraudDetection: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  smartFieldValues: Scalars['JSON']['output'];
  spaceAvailability?: Maybe<Scalars['JSON']['output']>;
  spaces: Array<Space>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: EventStatus;
  suggestedActions: SuggestedActionConnection;
  tasks: Array<Task>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
  totalBySalesCategoryName: Scalars['JSON']['output'];
  tourEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  tourEndOffset?: Maybe<Scalars['Int']['output']>;
  tourStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  tourStartOffset?: Maybe<Scalars['Int']['output']>;
  unreadMessageCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  userFields: Scalars['JSON']['output'];
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
  valueForReporting?: Maybe<Scalars['Int']['output']>;
  venue: Venue;
};

export type InboxEventSuggestedActionsArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for InboxEvent. */
export type InboxEventConnection = {
  __typename?: 'InboxEventConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InboxEventEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InboxEvent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InboxEventEdge = {
  __typename?: 'InboxEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<InboxEvent>;
};

/** Autogenerated input type of InitialContractPolicySection */
export type InitialContractPolicySectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  initials: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated return type of InitialContractPolicySection. */
export type InitialContractPolicySectionPayload = {
  __typename?: 'InitialContractPolicySectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<GuestProposal>;
  errors: Array<Error>;
};

/** Autogenerated input type of InitializeAssistantUpload */
export type InitializeAssistantUploadInput = {
  byteSize: Scalars['Int']['input'];
  checksum: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  conversationId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
};

/** Autogenerated return type of InitializeAssistantUpload. */
export type InitializeAssistantUploadPayload = {
  __typename?: 'InitializeAssistantUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  result?: Maybe<Scalars['JSON']['output']>;
};

export type IntegrationSyncBlockingReason = {
  __typename?: 'IntegrationSyncBlockingReason';
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type IntegrationSyncEligibility = {
  __typename?: 'IntegrationSyncEligibility';
  blockingReasons: Array<IntegrationSyncBlockingReason>;
  eligible: Scalars['Boolean']['output'];
};

/** Autogenerated input type of LinkMerriEvent */
export type LinkMerriEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  merriEventId: Scalars['ID']['input'];
};

/** Autogenerated return type of LinkMerriEvent. */
export type LinkMerriEventPayload = {
  __typename?: 'LinkMerriEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of LinkPrismmOccasion */
export type LinkPrismmOccasionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  prismmOccasionId: Scalars['ID']['input'];
};

/** Autogenerated return type of LinkPrismmOccasion. */
export type LinkPrismmOccasionPayload = {
  __typename?: 'LinkPrismmOccasionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

export type LocationSearch = {
  __typename?: 'LocationSearch';
  bounds?: Maybe<Bounds>;
  id: Scalars['ID']['output'];
  locationQuery: Scalars['String']['output'];
};

export enum LostReasonCategory {
  Canceled = 'canceled',
  ChoseAnotherVenue = 'chose_another_venue',
  GroupTooLarge = 'group_too_large',
  GroupTooSmall = 'group_too_small',
  NotAvailable = 'not_available',
  Other = 'other',
  Price = 'price',
  Unresponsive = 'unresponsive',
}

/** Autogenerated input type of MarkEventAsSafe */
export type MarkEventAsSafeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MarkEventAsSafe. */
export type MarkEventAsSafePayload = {
  __typename?: 'MarkEventAsSafePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
  fraudDetection?: Maybe<FraudDetection>;
};

/** Autogenerated input type of MarkMessageSuggestionShown */
export type MarkMessageSuggestionShownInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkMessageSuggestionShown. */
export type MarkMessageSuggestionShownPayload = {
  __typename?: 'MarkMessageSuggestionShownPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  messageSuggestion?: Maybe<MessageSuggestion>;
};

export type MarketplaceBreadcrumb = {
  __typename?: 'MarketplaceBreadcrumb';
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationSlug?: Maybe<Scalars['String']['output']>;
  spaceName?: Maybe<Scalars['String']['output']>;
  spaceSlug?: Maybe<Scalars['String']['output']>;
  venueCity?: Maybe<Scalars['String']['output']>;
  venueName?: Maybe<Scalars['String']['output']>;
  venueSlug?: Maybe<Scalars['String']['output']>;
  venueState?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceEvent = {
  __typename?: 'MarketplaceEvent';
  contract?: Maybe<GuestProposal>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  eventPlan?: Maybe<EventPlan>;
  expressBookRequest?: Maybe<MarketplaceExpressBookRequest>;
  groupSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  inquiryStatus?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  paymentProvider?: Maybe<PaymentProvider>;
  planner?: Maybe<MarketplacePlanner>;
  review?: Maybe<Review>;
  slug: Scalars['String']['output'];
  spaces?: Maybe<Array<MarketplaceSpace>>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  venue: MarketplaceVenue;
  venueRespondedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type MarketplaceExpressBookRequest = {
  __typename?: 'MarketplaceExpressBookRequest';
  deposit?: Maybe<Scalars['Int']['output']>;
  depositRate?: Maybe<Scalars['Float']['output']>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  paymentMethod?: Maybe<GuestProposalPaymentMethod>;
  status: ExpressBookRequestStatus;
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type MarketplaceExpressBookSettings = {
  __typename?: 'MarketplaceExpressBookSettings';
  acceptanceTimelineHours: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maxEventDurationHours: Scalars['Float']['output'];
  maxLeadTimeDays: Scalars['Int']['output'];
  minBufferTimeHours: Scalars['Float']['output'];
  minEventDurationHours: Scalars['Float']['output'];
  minLeadTimeDays: Scalars['Int']['output'];
  spaceId?: Maybe<Scalars['ID']['output']>;
  venueId: Scalars['ID']['output'];
  venuePolicyId?: Maybe<Scalars['ID']['output']>;
};

export type MarketplaceOrganization = {
  __typename?: 'MarketplaceOrganization';
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  spaces?: Maybe<Array<MarketplaceSpace>>;
  venues?: Maybe<Array<MarketplaceVenue>>;
};

export type MarketplacePlanner = {
  __typename?: 'MarketplacePlanner';
  email?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<EmailAddress>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceReview = {
  __typename?: 'MarketplaceReview';
  eventDate?: Maybe<Scalars['ISO8601Date']['output']>;
  eventTypeName?: Maybe<Scalars['String']['output']>;
  guestCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  publicFeedback?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  reviewerFirstName?: Maybe<Scalars['String']['output']>;
  reviewerGravatarUrl?: Maybe<Scalars['String']['output']>;
  spaceNames: Array<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  venue: MarketplaceVenue;
};

export type MarketplaceSearch = {
  __typename?: 'MarketplaceSearch';
  id: Scalars['ID']['output'];
  neLat?: Maybe<Scalars['Float']['output']>;
  neLng?: Maybe<Scalars['Float']['output']>;
  paginatedSpaces: MarketplaceSpaceConnection;
  spaces: Array<MarketplaceSpace>;
  swLat?: Maybe<Scalars['Float']['output']>;
  swLng?: Maybe<Scalars['Float']['output']>;
};

export type MarketplaceSearchPaginatedSpacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketplaceSpace = {
  __typename?: 'MarketplaceSpace';
  amenities: Array<Amenity>;
  bookingWindows: Array<BookingWindow>;
  description?: Maybe<Scalars['String']['output']>;
  displayColor: Scalars['String']['output'];
  displayInDirectory: Scalars['Boolean']['output'];
  effectiveExpressBookSettings: MarketplaceExpressBookSettings;
  expressBookEnabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  ignoreConflicts: Scalars['Boolean']['output'];
  images: Array<Image>;
  name: Scalars['String']['output'];
  pathname: Scalars['String']['output'];
  seated?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  standing?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unavailableTimeSlots: Array<TimeSlot>;
  venue: MarketplaceVenue;
};

export type MarketplaceSpaceImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketplaceSpaceUnavailableTimeSlotsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for MarketplaceSpace. */
export type MarketplaceSpaceConnection = {
  __typename?: 'MarketplaceSpaceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MarketplaceSpaceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MarketplaceSpace>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MarketplaceSpaceEdge = {
  __typename?: 'MarketplaceSpaceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MarketplaceSpace>;
};

export type MarketplaceVenue = {
  __typename?: 'MarketplaceVenue';
  address?: Maybe<Address>;
  availabilityEnabled: Scalars['Boolean']['output'];
  averageResponseTime?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  defaultPaymentProvider?: Maybe<PaymentProvider>;
  description?: Maybe<Scalars['String']['output']>;
  expressBookSettings: MarketplaceExpressBookSettings;
  fees?: Maybe<Array<Fee>>;
  googlePlaceInfo?: Maybe<GooglePlaceInfo>;
  helloLeadFormUrl: Scalars['String']['output'];
  hoursOfOperation: Array<HoursOfOperation>;
  id: Scalars['ID']['output'];
  images: Array<Image>;
  liveAvailability: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  maxEventDurationHours: Scalars['Int']['output'];
  maxLeadTimeDays: Scalars['Int']['output'];
  menu: Menu;
  minEventDurationHours: Scalars['Int']['output'];
  minGroupSize?: Maybe<Scalars['Int']['output']>;
  minLeadTimeDays: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pathname: Scalars['String']['output'];
  priceCategory: Scalars['String']['output'];
  profileBanner?: Maybe<Scalars['String']['output']>;
  reviews: Array<MarketplaceReview>;
  slug: Scalars['String']['output'];
  spaces?: Maybe<Array<MarketplaceSpace>>;
  squareLocationId?: Maybe<Scalars['String']['output']>;
  stripeAccount?: Maybe<StripeAccount>;
  taxes?: Maybe<Array<Tax>>;
  timezone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userFieldDefinitions: Array<UserFieldDefinition>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type MarketplaceVenueImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** A mention of a user in an event discussion comment */
export type Mention = {
  __typename?: 'Mention';
  /** The teammate who wrote the comment */
  author?: Maybe<User>;
  /** When the comment was written, which is the date and time a Team Messages row shows */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The event the comment sits on */
  event?: Maybe<Event>;
  id: Scalars['ID']['output'];
  /** The comment read as plain text, with mentions as first names and long text truncated */
  previewText?: Maybe<Scalars['String']['output']>;
  readByMentionedUserAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** The connection type for Mention. */
export type MentionConnection = {
  __typename?: 'MentionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MentionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Mention>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MentionEdge = {
  __typename?: 'MentionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Mention>;
};

export type Menu = {
  __typename?: 'Menu';
  id: Scalars['ID']['output'];
  menuCategories: Array<MenuCategory>;
  menuItems: Array<MenuItem>;
  name: Scalars['String']['output'];
  pdf?: Maybe<Scalars['String']['output']>;
  previewMenuItems: Array<MenuItem>;
  salesCategories: Array<SalesCategory>;
};

export type MenuMenuItemsArgs = {
  displayOnExpressBook?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuPreviewMenuItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuCategory = {
  __typename?: 'MenuCategory';
  applyTowardMinimum: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fees?: Maybe<Array<Fee>>;
  id: Scalars['ID']['output'];
  menu: Array<Menu>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  salesCategory?: Maybe<SalesCategory>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  taxes?: Maybe<Array<Tax>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MenuItem = {
  __typename?: 'MenuItem';
  addons: Array<MenuItemAddon>;
  category?: Maybe<Scalars['String']['output']>;
  choices: Array<MenuItemChoice>;
  details?: Maybe<Scalars['String']['output']>;
  detailsHtml?: Maybe<Scalars['String']['output']>;
  displayOnExpressBook: Scalars['Boolean']['output'];
  displayOnGuestMenu: Scalars['Boolean']['output'];
  fees: Array<Fee>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  internalDetails?: Maybe<Scalars['String']['output']>;
  menu: Menu;
  menuCategory?: Maybe<MenuCategory>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  quantitiesEditableByGuest: Scalars['Boolean']['output'];
  quantitiesOnExtrasEnabled: Scalars['Boolean']['output'];
  searchableName: Scalars['String']['output'];
  sub?: Maybe<Scalars['String']['output']>;
  taxes: Array<Tax>;
  unit: Scalars['String']['output'];
};

export type MenuItemImageArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemAddon = {
  __typename?: 'MenuItemAddon';
  id: Scalars['ID']['output'];
  menuItem: MenuItem;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** Addon for menu item */
export type MenuItemAddonInput = {
  /** ID of Addon */
  id: Scalars['ID']['input'];
  /** Name of Addon */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Price of Addon */
  price?: InputMaybe<Scalars['Int']['input']>;
};

export type MenuItemChoice = {
  __typename?: 'MenuItemChoice';
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  menuItem: MenuItem;
  name?: Maybe<Scalars['String']['output']>;
  options: Array<MenuItemOption>;
};

/** Choice for menu item */
export type MenuItemChoiceInput = {
  /** ID of Choice */
  id: Scalars['ID']['input'];
  /** Num of Choice */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Name of Choice */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Options */
  options?: InputMaybe<Array<MenuItemOptionInput>>;
};

export type MenuItemOption = {
  __typename?: 'MenuItemOption';
  id: Scalars['ID']['output'];
  menuItemChoice: MenuItemChoice;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

/** Option for menu item choice */
export type MenuItemOptionInput = {
  /** ID of Option */
  id: Scalars['ID']['input'];
  /** Name of Option */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Price of Option */
  price?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of MergePlanners */
export type MergePlannersInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  duplicatePlannerIds: Array<Scalars['ID']['input']>;
  primaryPlannerId: Scalars['ID']['input'];
};

/** Autogenerated return type of MergePlanners. */
export type MergePlannersPayload = {
  __typename?: 'MergePlannersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  duplicatePlannerIds: Array<Scalars['ID']['output']>;
  errors: Array<Error>;
  planner?: Maybe<Planner>;
};

export type MerriEvent = {
  __typename?: 'MerriEvent';
  archived?: Maybe<Scalars['Boolean']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
};

export type Message = {
  __typename?: 'Message';
  canUndoSend: Scalars['Boolean']['output'];
  ccEmailAddresses: Array<EmailAddress>;
  clickCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deliveryState: MessageDeliveryState;
  documents: Array<Document>;
  draft: Scalars['Boolean']['output'];
  draftMessageBody?: Maybe<Scalars['JSON']['output']>;
  draftRevision: Scalars['String']['output'];
  event: Event;
  firstReadByUserAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fromEmailAddress: EmailAddress;
  id: Scalars['ID']['output'];
  messagePreviewText?: Maybe<Scalars['String']['output']>;
  notDeliveredEvents?: Maybe<Scalars['JSON']['output']>;
  occurredAt: Scalars['ISO8601DateTime']['output'];
  openCount: Scalars['Int']['output'];
  plainTextFromHtml: Scalars['String']['output'];
  plainTextWithoutSignature: Scalars['String']['output'];
  sanitizedFullHtml: Scalars['String']['output'];
  sanitizedTrimmedHtml: Scalars['String']['output'];
  scheduledSendAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sender: MessageSender;
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  toEmailAddresses: Array<EmailAddress>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

/** How far a message got on its way out */
export enum MessageDeliveryState {
  Draft = 'draft',
  Failed = 'failed',
  Retrying = 'retrying',
  Scheduled = 'scheduled',
  Sending = 'sending',
  Sent = 'sent',
  Unsent = 'unsent',
}

export enum MessageOrigin {
  AiAutoReply = 'ai_auto_reply',
  AvailabilityCheck = 'availability_check',
  ContactForm = 'contact_form',
  Dashboard = 'dashboard',
  EmailApi = 'email_api',
  ExpressBook = 'express_book',
  External = 'external',
  Proposal = 'proposal',
  RestApi = 'rest_api',
  System = 'system',
  Unknown = 'unknown',
}

/** Minimal message shape for list previews, backed by cached columns only */
export type MessagePreview = {
  __typename?: 'MessagePreview';
  id: Scalars['ID']['output'];
  messagePreviewText?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum MessageSender {
  Planner = 'planner',
  Venue = 'venue',
}

export type MessageSuggestion = {
  __typename?: 'MessageSuggestion';
  aiReplySession?: Maybe<AiReplySession>;
  aiReplySessionId?: Maybe<Scalars['ID']['output']>;
  approved: Scalars['Boolean']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  rephrasePrompt?: Maybe<Scalars['String']['output']>;
  shownAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type MonthlyGoal = {
  __typename?: 'MonthlyGoal';
  amount?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  month: Scalars['ISO8601Date']['output'];
  subtotalAmount?: Maybe<Scalars['Int']['output']>;
};

export type MonthlyGoalRow = {
  __typename?: 'MonthlyGoalRow';
  grandTotal: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  month: Scalars['Int']['output'];
  numberOfEvents: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  trackableId: Scalars['ID']['output'];
  trackableType: Scalars['String']['output'];
};

export type MonthlyGoalValueInput = {
  month: Scalars['ISO8601Date']['input'];
  value: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept an event plan invitation */
  acceptEventPlanInvitation?: Maybe<AcceptEventPlanInvitationPayload>;
  acceptExpressBookRequest?: Maybe<AcceptExpressBookRequestPayload>;
  /** Accept a suggested action, authorizing and applying its action */
  acceptSuggestedAction?: Maybe<AcceptSuggestedActionPayload>;
  addContractPolicySection?: Maybe<AddContractPolicySectionPayload>;
  addGuestSpaceFavorite?: Maybe<AddGuestSpaceFavoritePayload>;
  adminCancelPlanTierTrial?: Maybe<AdminCancelPlanTierTrialPayload>;
  adminCancelVenueSubscriptions?: Maybe<AdminCancelVenueSubscriptionsPayload>;
  adminCreateOauthApplication?: Maybe<AdminCreateOauthApplicationPayload>;
  adminDeleteOauthApplication?: Maybe<AdminDeleteOauthApplicationPayload>;
  adminDeleteOrganizationAiFeeAgreement?: Maybe<AdminDeleteOrganizationAiFeeAgreementPayload>;
  adminDeletePlanTierTrial?: Maybe<AdminDeletePlanTierTrialPayload>;
  adminExtendPlanTierTrial?: Maybe<AdminExtendPlanTierTrialPayload>;
  adminExtendVenueSubscription?: Maybe<AdminExtendVenueSubscriptionPayload>;
  /** Mark an OpenTable integration sync as complete (for manual sync workflow) */
  adminMarkOpentableSyncComplete?: Maybe<AdminMarkOpentableSyncCompletePayload>;
  adminStartPlanTierTrial?: Maybe<AdminStartPlanTierTrialPayload>;
  adminUpdateOauthApplication?: Maybe<AdminUpdateOauthApplicationPayload>;
  adminUpdateOrganization?: Maybe<AdminUpdateOrganizationPayload>;
  adminUpdateVenue?: Maybe<AdminUpdateVenuePayload>;
  adminUpsertOrganizationAiFeeAgreement?: Maybe<AdminUpsertOrganizationAiFeeAgreementPayload>;
  applyAssistantDraft?: Maybe<ApplyAssistantDraftPayload>;
  approveVenueDataImport?: Maybe<ApproveVenueDataImportPayload>;
  archiveDocument?: Maybe<ArchiveDocumentPayload>;
  archiveEvents?: Maybe<ArchiveEventsPayload>;
  archivePlanner?: Maybe<ArchivePlannerPayload>;
  archiveVenueEvents?: Maybe<ArchiveVenueEventsPayload>;
  assistantCommand?: Maybe<AssistantCommandPayload>;
  bulkUpdateEvents?: Maybe<BulkUpdateEventsPayload>;
  cancelAddOn?: Maybe<CancelAddOnPayload>;
  cancelEvent?: Maybe<CancelEventPayload>;
  cancelPlanTierTrial?: Maybe<CancelPlanTierTrialPayload>;
  cancelReportExport?: Maybe<CancelReportExportPayload>;
  cancelScheduledMessage?: Maybe<CancelScheduledMessagePayload>;
  cloneMerriEvent?: Maybe<CloneMerriEventPayload>;
  contactSales?: Maybe<ContactSalesPayload>;
  convertMessageToDraft?: Maybe<ConvertMessageToDraftPayload>;
  countersignContract?: Maybe<CountersignContractPayload>;
  createAccount?: Maybe<CreateAccountPayload>;
  createAdditionalContact?: Maybe<CreateAdditionalContactPayload>;
  createAllowedOrigin?: Maybe<CreateAllowedOriginPayload>;
  createAssistantConversation?: Maybe<CreateAssistantConversationPayload>;
  /** Create an automatic task template */
  createAutomaticTaskTemplate?: Maybe<CreateAutomaticTaskTemplatePayload>;
  createAvailabilityBlock?: Maybe<CreateAvailabilityBlockPayload>;
  createContract?: Maybe<CreateContractPayload>;
  createContractItem?: Maybe<CreateContractItemPayload>;
  createContractVenuePolicy?: Maybe<CreateContractVenuePolicyPayload>;
  createCustomEventTypeName?: Maybe<CreateCustomEventTypeNamePayload>;
  createCustomGoalView?: Maybe<CreateCustomGoalViewPayload>;
  createCventEvent?: Maybe<CreateCventEventPayload>;
  createCventIntegration?: Maybe<CreateCventIntegrationPayload>;
  /** Generate a pre-signed URL and headers for direct upload via Active Storage */
  createDirectUpload?: Maybe<CreateDirectUploadPayload>;
  /** Create a document template */
  createDocumentTemplate?: Maybe<CreateDocumentTemplatePayload>;
  createEmailTemplate?: Maybe<CreateEmailTemplatePayload>;
  createEvent?: Maybe<CreateEventPayload>;
  createEventDiscussionComment?: Maybe<CreateEventDiscussionCommentPayload>;
  createEventDocument?: Maybe<CreateEventDocumentPayload>;
  createEventFloorPlan?: Maybe<CreateEventFloorPlanPayload>;
  createEventPlan?: Maybe<CreateEventPlanPayload>;
  createEventbriteEvent?: Maybe<CreateEventbriteEventPayload>;
  createExpressBookContractItem?: Maybe<CreateExpressBookContractItemPayload>;
  createFee?: Maybe<CreateFeePayload>;
  createFloorPlanObjectLibraryItem?: Maybe<CreateFloorPlanObjectLibraryItemPayload>;
  createFloorPlanTemplate?: Maybe<CreateFloorPlanTemplatePayload>;
  createFoodAndBeverageMinimum?: Maybe<CreateFoodAndBeverageMinimumPayload>;
  /** Create a fraud token */
  createFraudToken?: Maybe<CreateFraudTokenPayload>;
  createFraudTokenFromReport?: Maybe<CreateFraudTokenFromReportPayload>;
  createGuestMessage?: Maybe<CreateGuestMessagePayload>;
  createMarketplaceEvent?: Maybe<CreateMarketplaceEventPayload>;
  createMenuCategory?: Maybe<CreateMenuCategoryPayload>;
  createMenuItem?: Maybe<CreateMenuItemPayload>;
  createMerriEvent?: Maybe<CreateMerriEventPayload>;
  createMessage?: Maybe<CreateMessagePayload>;
  /** Create a note template */
  createNoteTemplate?: Maybe<CreateNoteTemplatePayload>;
  createOauthApplication?: Maybe<CreateOauthApplicationPayload>;
  createOfflineCommunication?: Maybe<CreateOfflineCommunicationPayload>;
  createOrganizationDocument?: Maybe<CreateOrganizationDocumentPayload>;
  createOrganizationEmailTemplate?: Maybe<CreateOrganizationEmailTemplatePayload>;
  createOrganizationMembership?: Maybe<CreateOrganizationMembershipPayload>;
  createOrganizationPaymentMethod?: Maybe<CreateOrganizationPaymentMethodPayload>;
  createOrganizationSetupIntent?: Maybe<CreateOrganizationSetupIntentPayload>;
  createPayment?: Maybe<CreatePaymentPayload>;
  createPlanner?: Maybe<CreatePlannerPayload>;
  createPolicySection?: Maybe<CreatePolicySectionPayload>;
  createPrismmIntegration?: Maybe<CreatePrismmIntegrationPayload>;
  createPrismmOccasion?: Maybe<CreatePrismmOccasionPayload>;
  createRecurringEvent?: Maybe<CreateRecurringEventPayload>;
  createReportView?: Maybe<CreateReportViewPayload>;
  createSalesCategory?: Maybe<CreateSalesCategoryPayload>;
  createSession?: Maybe<CreateSessionPayload>;
  createSetupIntent?: Maybe<CreateSetupIntentPayload>;
  createSpace?: Maybe<CreateSpacePayload>;
  createSquarePaymentMethod?: Maybe<CreateSquarePaymentMethodPayload>;
  createStripePaymentMethod?: Maybe<CreateStripePaymentMethodPayload>;
  createTask?: Maybe<CreateTaskPayload>;
  createTax?: Maybe<CreateTaxPayload>;
  createUserFieldDefinition?: Maybe<CreateUserFieldDefinitionPayload>;
  createVenue?: Maybe<CreateVenuePayload>;
  createVenueCollection?: Maybe<CreateVenueCollectionPayload>;
  createVenueDataImport?: Maybe<CreateVenueDataImportPayload>;
  createVenueDocument?: Maybe<CreateVenueDocumentPayload>;
  createVenueEmailTemplate?: Maybe<CreateVenueEmailTemplatePayload>;
  createVenuePolicy?: Maybe<CreateVenuePolicyPayload>;
  createWebsiteScan?: Maybe<CreateWebsiteScanPayload>;
  customizeContractPolicy?: Maybe<CustomizeContractPolicyPayload>;
  /** Decline an event plan invitation */
  declineEventPlanInvitation?: Maybe<DeclineEventPlanInvitationPayload>;
  declineExpressBookRequest?: Maybe<DeclineExpressBookRequestPayload>;
  deleteAllowedOrigin?: Maybe<DeleteAllowedOriginPayload>;
  deleteContract?: Maybe<DeleteContractPayload>;
  deleteCustomGoalView?: Maybe<DeleteCustomGoalViewPayload>;
  deleteEvent?: Maybe<DeleteEventPayload>;
  deleteEventFloorPlan?: Maybe<DeleteEventFloorPlanPayload>;
  deleteFloorPlanObjectLibraryItem?: Maybe<DeleteFloorPlanObjectLibraryItemPayload>;
  deleteFloorPlanTemplate?: Maybe<DeleteFloorPlanTemplatePayload>;
  deleteFoodAndBeverageMinimum?: Maybe<DeleteFoodAndBeverageMinimumPayload>;
  /** Delete a fraud token */
  deleteFraudToken?: Maybe<DeleteFraudTokenPayload>;
  deleteMessage?: Maybe<DeleteMessagePayload>;
  /** Bulk-delete draft messages owned by the current user */
  deleteMessages?: Maybe<DeleteMessagesPayload>;
  deleteOauthApplication?: Maybe<DeleteOauthApplicationPayload>;
  deletePolicySection?: Maybe<DeletePolicySectionPayload>;
  deleteVenueFee?: Maybe<DeleteVenueFeePayload>;
  deleteVenuePolicy?: Maybe<DeleteVenuePolicyPayload>;
  deleteVenueTax?: Maybe<DeleteVenueTaxPayload>;
  discardAssistantUpload?: Maybe<DiscardAssistantUploadPayload>;
  discardPlanner?: Maybe<DiscardPlannerPayload>;
  disconnectCventIntegration?: Maybe<DisconnectCventIntegrationPayload>;
  disconnectEventbriteIntegration?: Maybe<DisconnectEventbriteIntegrationPayload>;
  disconnectSevenShiftsIntegration?: Maybe<DisconnectSevenShiftsIntegrationPayload>;
  disconnectStripeAccount?: Maybe<DisconnectStripeAccountPayload>;
  /** Dismiss a suggested action */
  dismissSuggestedAction?: Maybe<DismissSuggestedActionPayload>;
  duplicateEvent?: Maybe<DuplicateEventPayload>;
  duplicateFloorPlanTemplate?: Maybe<DuplicateFloorPlanTemplatePayload>;
  duplicateMenuItem?: Maybe<DuplicateMenuItemPayload>;
  duplicatePolicySection?: Maybe<DuplicatePolicySectionPayload>;
  duplicateVenuePolicy?: Maybe<DuplicateVenuePolicyPayload>;
  exportContactReport?: Maybe<ExportContactReportPayload>;
  exportEventReport?: Maybe<ExportEventReportPayload>;
  exportEventReportDocuments?: Maybe<ExportEventReportDocumentsPayload>;
  exportPaymentReport?: Maybe<ExportPaymentReportPayload>;
  exportProposalReport?: Maybe<ExportProposalReportPayload>;
  exportVenueReport?: Maybe<ExportVenueReportPayload>;
  finalizeAssistantUpload?: Maybe<FinalizeAssistantUploadPayload>;
  generateEventFloorPlansPdf?: Maybe<GenerateEventFloorPlansPdfPayload>;
  guestUpdateContractItem?: Maybe<GuestUpdateContractItemPayload>;
  ignoreSuspiciousMessageReport?: Maybe<IgnoreSuspiciousMessageReportPayload>;
  initialContractPolicySection?: Maybe<InitialContractPolicySectionPayload>;
  initializeAssistantUpload?: Maybe<InitializeAssistantUploadPayload>;
  linkMerriEvent?: Maybe<LinkMerriEventPayload>;
  linkPrismmOccasion?: Maybe<LinkPrismmOccasionPayload>;
  markEventAsSafe?: Maybe<MarkEventAsSafePayload>;
  /** Record the timestamp when a message suggestion is first shown to a user */
  markMessageSuggestionShown?: Maybe<MarkMessageSuggestionShownPayload>;
  mergePlanners?: Maybe<MergePlannersPayload>;
  payContract?: Maybe<PayContractPayload>;
  purchaseAddOn?: Maybe<PurchaseAddOnPayload>;
  readAllEventMessages?: Maybe<ReadAllEventMessagesPayload>;
  readAllVenueEventMessages?: Maybe<ReadAllVenueEventMessagesPayload>;
  readEventDiscussion?: Maybe<ReadEventDiscussionPayload>;
  readMention?: Maybe<ReadMentionPayload>;
  refundPayment?: Maybe<RefundPaymentPayload>;
  removeAccount?: Maybe<RemoveAccountPayload>;
  removeAdditionalContact?: Maybe<RemoveAdditionalContactPayload>;
  /** Remove an automatic task template */
  removeAutomaticTaskTemplate?: Maybe<RemoveAutomaticTaskTemplatePayload>;
  removeAvailabilityBlock?: Maybe<RemoveAvailabilityBlockPayload>;
  removeContractItem?: Maybe<RemoveContractItemPayload>;
  removeContractPolicySection?: Maybe<RemoveContractPolicySectionPayload>;
  removeCustomEventTypeName?: Maybe<RemoveCustomEventTypeNamePayload>;
  /** Remove a document template */
  removeDocumentTemplate?: Maybe<RemoveDocumentTemplatePayload>;
  removeEmailTemplate?: Maybe<RemoveEmailTemplatePayload>;
  removeEventRehearsal?: Maybe<RemoveEventRehearsalPayload>;
  removeEventTour?: Maybe<RemoveEventTourPayload>;
  removeExpressBookItem?: Maybe<RemoveExpressBookItemPayload>;
  removeGoogleCalendar?: Maybe<RemoveGoogleCalendarPayload>;
  removeGuestSpaceFavorite?: Maybe<RemoveGuestSpaceFavoritePayload>;
  removeImage?: Maybe<RemoveImagePayload>;
  removeMenuCategory?: Maybe<RemoveMenuCategoryPayload>;
  removeMenuItem?: Maybe<RemoveMenuItemPayload>;
  /** Remove a note template */
  removeNoteTemplate?: Maybe<RemoveNoteTemplatePayload>;
  removeOfflineCommunication?: Maybe<RemoveOfflineCommunicationPayload>;
  removeOrganizationMembership?: Maybe<RemoveOrganizationMembershipPayload>;
  removeOrganizationPaymentMethod?: Maybe<RemoveOrganizationPaymentMethodPayload>;
  removePayment?: Maybe<RemovePaymentPayload>;
  removePlannerPaymentMethod?: Maybe<RemovePlannerPaymentMethodPayload>;
  removeRecurringEvent?: Maybe<RemoveRecurringEventPayload>;
  removeReportExport?: Maybe<RemoveReportExportPayload>;
  removeReportView?: Maybe<RemoveReportViewPayload>;
  removeSalesCategory?: Maybe<RemoveSalesCategoryPayload>;
  removeSession?: Maybe<RemoveSessionPayload>;
  removeSpace?: Maybe<RemoveSpacePayload>;
  removeTask?: Maybe<RemoveTaskPayload>;
  removeUserFieldDefinition?: Maybe<RemoveUserFieldDefinitionPayload>;
  removeVenue?: Maybe<RemoveVenuePayload>;
  removeVenueCollection?: Maybe<RemoveVenueCollectionPayload>;
  removeVenueOpentableCredentials?: Maybe<RemoveVenueOpentableCredentialsPayload>;
  reorderContractPolicySections?: Maybe<ReorderContractPolicySectionsPayload>;
  reorderEmailTemplates?: Maybe<ReorderEmailTemplatesPayload>;
  reorderMenuCategories?: Maybe<ReorderMenuCategoriesPayload>;
  reorderMenuItems?: Maybe<ReorderMenuItemsPayload>;
  reorderOrganizationEmailTemplates?: Maybe<ReorderOrganizationEmailTemplatesPayload>;
  reorderUserFieldDefinitions?: Maybe<ReorderUserFieldDefinitionsPayload>;
  reportSuspiciousMessage?: Maybe<ReportSuspiciousMessagePayload>;
  resendReviewRequest?: Maybe<ResendReviewRequestPayload>;
  resetContractTaxesAndFees?: Maybe<ResetContractTaxesAndFeesPayload>;
  retrySendMessage?: Maybe<RetrySendMessagePayload>;
  revertContractPolicy?: Maybe<RevertContractPolicyPayload>;
  revertContractVenuePolicy?: Maybe<RevertContractVenuePolicyPayload>;
  revokeSquareAccount?: Maybe<RevokeSquareAccountPayload>;
  rollbackVenueDataImport?: Maybe<RollbackVenueDataImportPayload>;
  /** Send an event plan invitation to an invitee */
  sendEventPlanInvitation?: Maybe<SendEventPlanInvitationPayload>;
  sendExpressBookRequest?: Maybe<SendExpressBookRequestPayload>;
  sendResetPasswordEmail?: Maybe<SendResetPasswordEmailPayload>;
  setMonthlyGoals?: Maybe<SetMonthlyGoalsPayload>;
  setSpaceBookingWindows?: Maybe<SetSpaceBookingWindowsPayload>;
  setVenueOpentableCredentials?: Maybe<SetVenueOpentableCredentialsPayload>;
  setVenueOpentableCustomInstructions?: Maybe<SetVenueOpentableCustomInstructionsPayload>;
  setVenueOpentableSyncTriggerStatus?: Maybe<SetVenueOpentableSyncTriggerStatusPayload>;
  skipMenuSelectionForExpressBook?: Maybe<SkipMenuSelectionForExpressBookPayload>;
  startAddOnTrial?: Maybe<StartAddOnTrialPayload>;
  startPlanTierTrial?: Maybe<StartPlanTierTrialPayload>;
  submitQuestionnaireAnswers?: Maybe<SubmitQuestionnaireAnswersPayload>;
  toggleContractItemAddon?: Maybe<ToggleContractItemAddonPayload>;
  toggleContractItemOption?: Maybe<ToggleContractItemOptionPayload>;
  unarchiveEvents?: Maybe<UnarchiveEventsPayload>;
  unarchiveVenueEvents?: Maybe<UnarchiveVenueEventsPayload>;
  undeleteEvent?: Maybe<UndeleteEventPayload>;
  unlinkMerriEvent?: Maybe<UnlinkMerriEventPayload>;
  unreadLatestEventMessages?: Maybe<UnreadLatestEventMessagesPayload>;
  unreadLatestVenueEventMessages?: Maybe<UnreadLatestVenueEventMessagesPayload>;
  unreadMention?: Maybe<UnreadMentionPayload>;
  unreadMessage?: Maybe<UnreadMessagePayload>;
  updateAccount?: Maybe<UpdateAccountPayload>;
  /** Update an automatic task template */
  updateAutomaticTaskTemplate?: Maybe<UpdateAutomaticTaskTemplatePayload>;
  updateAvailabilityBlock?: Maybe<UpdateAvailabilityBlockPayload>;
  updateBeoCustomization?: Maybe<UpdateBeoCustomizationPayload>;
  updateContactFormSettings?: Maybe<UpdateContactFormSettingsPayload>;
  updateContract?: Maybe<UpdateContractPayload>;
  updateContractItem?: Maybe<UpdateContractItemPayload>;
  updateContractItemAddon?: Maybe<UpdateContractItemAddonPayload>;
  updateContractItemOption?: Maybe<UpdateContractItemOptionPayload>;
  updateContractPolicySection?: Maybe<UpdateContractPolicySectionPayload>;
  updateCurrentGuest?: Maybe<UpdateCurrentGuestPayload>;
  updateCustomEventTypeName?: Maybe<UpdateCustomEventTypeNamePayload>;
  /** Update a document template */
  updateDocumentTemplate?: Maybe<UpdateDocumentTemplatePayload>;
  updateEmailTemplate?: Maybe<UpdateEmailTemplatePayload>;
  updateEvent?: Maybe<UpdateEventPayload>;
  updateEventFloorPlan?: Maybe<UpdateEventFloorPlanPayload>;
  updateEventPlan?: Maybe<UpdateEventPlanPayload>;
  updateEventStatusAutomationSettings?: Maybe<UpdateEventStatusAutomationSettingsPayload>;
  updateEventbriteOrganizations?: Maybe<UpdateEventbriteOrganizationsPayload>;
  updateExpressBookItem?: Maybe<UpdateExpressBookItemPayload>;
  updateExpressBookSettings?: Maybe<UpdateExpressBookSettingsPayload>;
  updateFee?: Maybe<UpdateFeePayload>;
  updateFloorPlanObjectLibraryItem?: Maybe<UpdateFloorPlanObjectLibraryItemPayload>;
  updateFloorPlanTemplate?: Maybe<UpdateFloorPlanTemplatePayload>;
  updateFoodAndBeverageMinimum?: Maybe<UpdateFoodAndBeverageMinimumPayload>;
  /** Update a fraud token */
  updateFraudToken?: Maybe<UpdateFraudTokenPayload>;
  updateHoursOfOperation?: Maybe<UpdateHoursOfOperationPayload>;
  updateMenuCategory?: Maybe<UpdateMenuCategoryPayload>;
  updateMenuItem?: Maybe<UpdateMenuItemPayload>;
  updateMessage?: Maybe<UpdateMessagePayload>;
  /** Update a message suggestion */
  updateMessageSuggestion?: Maybe<UpdateMessageSuggestionPayload>;
  updateMonthlyGoal?: Maybe<UpdateMonthlyGoalPayload>;
  /** Update a note template */
  updateNoteTemplate?: Maybe<UpdateNoteTemplatePayload>;
  updateNotificationSettings?: Maybe<UpdateNotificationSettingsPayload>;
  updateOauthApplication?: Maybe<UpdateOauthApplicationPayload>;
  updateOfflineCommunication?: Maybe<UpdateOfflineCommunicationPayload>;
  updateOnboarding?: Maybe<UpdateOnboardingPayload>;
  updateOrganization?: Maybe<UpdateOrganizationPayload>;
  updateOrganizationMembership?: Maybe<UpdateOrganizationMembershipPayload>;
  updatePayment?: Maybe<UpdatePaymentPayload>;
  updatePlanner?: Maybe<UpdatePlannerPayload>;
  updatePolicySection?: Maybe<UpdatePolicySectionPayload>;
  updateRecurringEvent?: Maybe<UpdateRecurringEventPayload>;
  updateReportView?: Maybe<UpdateReportViewPayload>;
  updateReview?: Maybe<UpdateReviewPayload>;
  updateSalesCategory?: Maybe<UpdateSalesCategoryPayload>;
  updateSession?: Maybe<UpdateSessionPayload>;
  updateSpace?: Maybe<UpdateSpacePayload>;
  updateSpaceExpressBookSettings?: Maybe<UpdateSpaceExpressBookSettingsPayload>;
  updateSpacesCventRoomId?: Maybe<UpdateSpacesCventRoomIdPayload>;
  updateTask?: Maybe<UpdateTaskPayload>;
  updateTax?: Maybe<UpdateTaxPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserFieldDefinition?: Maybe<UpdateUserFieldDefinitionPayload>;
  updateVacationReply?: Maybe<UpdateVacationReplyPayload>;
  updateVenue?: Maybe<UpdateVenuePayload>;
  updateVenueCollection?: Maybe<UpdateVenueCollectionPayload>;
  updateVenuePlan?: Maybe<UpdateVenuePlanPayload>;
  updateVenuePolicy?: Maybe<UpdateVenuePolicyPayload>;
  updateVenueSetup?: Maybe<UpdateVenueSetupPayload>;
  updateVenueSubscriptionPaymentMethod?: Maybe<UpdateVenueSubscriptionPaymentMethodPayload>;
  updateVenuesCventPropertyId?: Maybe<UpdateVenuesCventPropertyIdPayload>;
  updateVenuesMerriId?: Maybe<UpdateVenuesMerriIdPayload>;
  updateVenuesPrismmId?: Maybe<UpdateVenuesPrismmIdPayload>;
  updateVenuesSevenShiftsId?: Maybe<UpdateVenuesSevenShiftsIdPayload>;
  uploadNotesImage?: Maybe<UploadNotesImagePayload>;
  uploadSignatureBlockImage?: Maybe<UploadSignatureBlockImagePayload>;
  upsertVenueAiReplyInstruction?: Maybe<UpsertVenueAiReplyInstructionPayload>;
};

export type MutationAcceptEventPlanInvitationArgs = {
  input: AcceptEventPlanInvitationInput;
};

export type MutationAcceptExpressBookRequestArgs = {
  input: AcceptExpressBookRequestInput;
};

export type MutationAcceptSuggestedActionArgs = {
  input: AcceptSuggestedActionInput;
};

export type MutationAddContractPolicySectionArgs = {
  input: AddContractPolicySectionInput;
};

export type MutationAddGuestSpaceFavoriteArgs = {
  input: AddGuestSpaceFavoriteInput;
};

export type MutationAdminCancelPlanTierTrialArgs = {
  input: AdminCancelPlanTierTrialInput;
};

export type MutationAdminCancelVenueSubscriptionsArgs = {
  input: AdminCancelVenueSubscriptionsInput;
};

export type MutationAdminCreateOauthApplicationArgs = {
  input: AdminCreateOauthApplicationInput;
};

export type MutationAdminDeleteOauthApplicationArgs = {
  input: AdminDeleteOauthApplicationInput;
};

export type MutationAdminDeleteOrganizationAiFeeAgreementArgs = {
  input: AdminDeleteOrganizationAiFeeAgreementInput;
};

export type MutationAdminDeletePlanTierTrialArgs = {
  input: AdminDeletePlanTierTrialInput;
};

export type MutationAdminExtendPlanTierTrialArgs = {
  input: AdminExtendPlanTierTrialInput;
};

export type MutationAdminExtendVenueSubscriptionArgs = {
  input: AdminExtendVenueSubscriptionInput;
};

export type MutationAdminMarkOpentableSyncCompleteArgs = {
  input: AdminMarkOpentableSyncCompleteInput;
};

export type MutationAdminStartPlanTierTrialArgs = {
  input: AdminStartPlanTierTrialInput;
};

export type MutationAdminUpdateOauthApplicationArgs = {
  input: AdminUpdateOauthApplicationInput;
};

export type MutationAdminUpdateOrganizationArgs = {
  input: AdminUpdateOrganizationInput;
};

export type MutationAdminUpdateVenueArgs = {
  input: AdminUpdateVenueInput;
};

export type MutationAdminUpsertOrganizationAiFeeAgreementArgs = {
  input: AdminUpsertOrganizationAiFeeAgreementInput;
};

export type MutationApplyAssistantDraftArgs = {
  input: ApplyAssistantDraftInput;
};

export type MutationApproveVenueDataImportArgs = {
  input: ApproveVenueDataImportInput;
};

export type MutationArchiveDocumentArgs = {
  input: ArchiveDocumentInput;
};

export type MutationArchiveEventsArgs = {
  input: ArchiveEventsInput;
};

export type MutationArchivePlannerArgs = {
  input: ArchivePlannerInput;
};

export type MutationArchiveVenueEventsArgs = {
  input: ArchiveVenueEventsInput;
};

export type MutationAssistantCommandArgs = {
  input: AssistantCommandInput;
};

export type MutationBulkUpdateEventsArgs = {
  input: BulkUpdateEventsInput;
};

export type MutationCancelAddOnArgs = {
  input: CancelAddOnInput;
};

export type MutationCancelEventArgs = {
  input: CancelEventInput;
};

export type MutationCancelPlanTierTrialArgs = {
  input: CancelPlanTierTrialInput;
};

export type MutationCancelReportExportArgs = {
  input: CancelReportExportInput;
};

export type MutationCancelScheduledMessageArgs = {
  input: CancelScheduledMessageInput;
};

export type MutationCloneMerriEventArgs = {
  input: CloneMerriEventInput;
};

export type MutationContactSalesArgs = {
  input: ContactSalesInput;
};

export type MutationConvertMessageToDraftArgs = {
  input: ConvertMessageToDraftInput;
};

export type MutationCountersignContractArgs = {
  input: CountersignContractInput;
};

export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};

export type MutationCreateAdditionalContactArgs = {
  input: CreateAdditionalContactInput;
};

export type MutationCreateAllowedOriginArgs = {
  input: CreateAllowedOriginInput;
};

export type MutationCreateAssistantConversationArgs = {
  input: CreateAssistantConversationInput;
};

export type MutationCreateAutomaticTaskTemplateArgs = {
  input: CreateAutomaticTaskTemplateInput;
};

export type MutationCreateAvailabilityBlockArgs = {
  input: CreateAvailabilityBlockInput;
};

export type MutationCreateContractArgs = {
  input: CreateContractInput;
};

export type MutationCreateContractItemArgs = {
  input: CreateContractItemInput;
};

export type MutationCreateContractVenuePolicyArgs = {
  input: CreateContractVenuePolicyInput;
};

export type MutationCreateCustomEventTypeNameArgs = {
  input: CreateCustomEventTypeNameInput;
};

export type MutationCreateCustomGoalViewArgs = {
  input: CreateCustomGoalViewInput;
};

export type MutationCreateCventEventArgs = {
  input: CreateCventEventInput;
};

export type MutationCreateCventIntegrationArgs = {
  input: CreateCventIntegrationInput;
};

export type MutationCreateDirectUploadArgs = {
  input: CreateDirectUploadInput;
};

export type MutationCreateDocumentTemplateArgs = {
  input: CreateDocumentTemplateInput;
};

export type MutationCreateEmailTemplateArgs = {
  input: CreateEmailTemplateInput;
};

export type MutationCreateEventArgs = {
  input: CreateEventInput;
};

export type MutationCreateEventDiscussionCommentArgs = {
  input: CreateEventDiscussionCommentInput;
};

export type MutationCreateEventDocumentArgs = {
  input: CreateEventDocumentInput;
};

export type MutationCreateEventFloorPlanArgs = {
  input: CreateEventFloorPlanInput;
};

export type MutationCreateEventPlanArgs = {
  input: CreateEventPlanInput;
};

export type MutationCreateEventbriteEventArgs = {
  input: CreateEventbriteEventInput;
};

export type MutationCreateExpressBookContractItemArgs = {
  input: CreateExpressBookContractItemInput;
};

export type MutationCreateFeeArgs = {
  input: CreateFeeInput;
};

export type MutationCreateFloorPlanObjectLibraryItemArgs = {
  input: CreateFloorPlanObjectLibraryItemInput;
};

export type MutationCreateFloorPlanTemplateArgs = {
  input: CreateFloorPlanTemplateInput;
};

export type MutationCreateFoodAndBeverageMinimumArgs = {
  input: CreateFoodAndBeverageMinimumInput;
};

export type MutationCreateFraudTokenArgs = {
  input: CreateFraudTokenInput;
};

export type MutationCreateFraudTokenFromReportArgs = {
  input: CreateFraudTokenFromReportInput;
};

export type MutationCreateGuestMessageArgs = {
  input: CreateGuestMessageInput;
};

export type MutationCreateMarketplaceEventArgs = {
  input: CreateMarketplaceEventInput;
};

export type MutationCreateMenuCategoryArgs = {
  input: CreateMenuCategoryInput;
};

export type MutationCreateMenuItemArgs = {
  input: CreateMenuItemInput;
};

export type MutationCreateMerriEventArgs = {
  input: CreateMerriEventInput;
};

export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};

export type MutationCreateNoteTemplateArgs = {
  input: CreateNoteTemplateInput;
};

export type MutationCreateOauthApplicationArgs = {
  input: CreateOauthApplicationInput;
};

export type MutationCreateOfflineCommunicationArgs = {
  input: CreateOfflineCommunicationInput;
};

export type MutationCreateOrganizationDocumentArgs = {
  input: CreateOrganizationDocumentInput;
};

export type MutationCreateOrganizationEmailTemplateArgs = {
  input: CreateOrganizationEmailTemplateInput;
};

export type MutationCreateOrganizationMembershipArgs = {
  input: CreateOrganizationMembershipInput;
};

export type MutationCreateOrganizationPaymentMethodArgs = {
  input: CreateOrganizationPaymentMethodInput;
};

export type MutationCreateOrganizationSetupIntentArgs = {
  input: CreateOrganizationSetupIntentInput;
};

export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};

export type MutationCreatePlannerArgs = {
  input: CreatePlannerInput;
};

export type MutationCreatePolicySectionArgs = {
  input: CreatePolicySectionInput;
};

export type MutationCreatePrismmIntegrationArgs = {
  input: CreatePrismmIntegrationInput;
};

export type MutationCreatePrismmOccasionArgs = {
  input: CreatePrismmOccasionInput;
};

export type MutationCreateRecurringEventArgs = {
  input: CreateRecurringEventInput;
};

export type MutationCreateReportViewArgs = {
  input: CreateReportViewInput;
};

export type MutationCreateSalesCategoryArgs = {
  input: CreateSalesCategoryInput;
};

export type MutationCreateSessionArgs = {
  input: CreateSessionInput;
};

export type MutationCreateSetupIntentArgs = {
  input: CreateSetupIntentInput;
};

export type MutationCreateSpaceArgs = {
  input: CreateSpaceInput;
};

export type MutationCreateSquarePaymentMethodArgs = {
  input: CreateSquarePaymentMethodInput;
};

export type MutationCreateStripePaymentMethodArgs = {
  input: CreateStripePaymentMethodInput;
};

export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};

export type MutationCreateTaxArgs = {
  input: CreateTaxInput;
};

export type MutationCreateUserFieldDefinitionArgs = {
  input: CreateUserFieldDefinitionInput;
};

export type MutationCreateVenueArgs = {
  input: CreateVenueInput;
};

export type MutationCreateVenueCollectionArgs = {
  input: CreateVenueCollectionInput;
};

export type MutationCreateVenueDataImportArgs = {
  input: CreateVenueDataImportInput;
};

export type MutationCreateVenueDocumentArgs = {
  input: CreateVenueDocumentInput;
};

export type MutationCreateVenueEmailTemplateArgs = {
  input: CreateVenueEmailTemplateInput;
};

export type MutationCreateVenuePolicyArgs = {
  input: CreateVenuePolicyInput;
};

export type MutationCreateWebsiteScanArgs = {
  input: CreateWebsiteScanInput;
};

export type MutationCustomizeContractPolicyArgs = {
  input: CustomizeContractPolicyInput;
};

export type MutationDeclineEventPlanInvitationArgs = {
  input: DeclineEventPlanInvitationInput;
};

export type MutationDeclineExpressBookRequestArgs = {
  input: DeclineExpressBookRequestInput;
};

export type MutationDeleteAllowedOriginArgs = {
  input: DeleteAllowedOriginInput;
};

export type MutationDeleteContractArgs = {
  input: DeleteContractInput;
};

export type MutationDeleteCustomGoalViewArgs = {
  input: DeleteCustomGoalViewInput;
};

export type MutationDeleteEventArgs = {
  input: DeleteEventInput;
};

export type MutationDeleteEventFloorPlanArgs = {
  input: DeleteEventFloorPlanInput;
};

export type MutationDeleteFloorPlanObjectLibraryItemArgs = {
  input: DeleteFloorPlanObjectLibraryItemInput;
};

export type MutationDeleteFloorPlanTemplateArgs = {
  input: DeleteFloorPlanTemplateInput;
};

export type MutationDeleteFoodAndBeverageMinimumArgs = {
  input: DeleteFoodAndBeverageMinimumInput;
};

export type MutationDeleteFraudTokenArgs = {
  input: DeleteFraudTokenInput;
};

export type MutationDeleteMessageArgs = {
  input: DeleteMessageInput;
};

export type MutationDeleteMessagesArgs = {
  input: DeleteMessagesInput;
};

export type MutationDeleteOauthApplicationArgs = {
  input: DeleteOauthApplicationInput;
};

export type MutationDeletePolicySectionArgs = {
  input: DeletePolicySectionInput;
};

export type MutationDeleteVenueFeeArgs = {
  input: DeleteVenueFeeInput;
};

export type MutationDeleteVenuePolicyArgs = {
  input: DeleteVenuePolicyInput;
};

export type MutationDeleteVenueTaxArgs = {
  input: DeleteVenueTaxInput;
};

export type MutationDiscardAssistantUploadArgs = {
  input: DiscardAssistantUploadInput;
};

export type MutationDiscardPlannerArgs = {
  input: DiscardPlannerInput;
};

export type MutationDisconnectCventIntegrationArgs = {
  input: DisconnectCventIntegrationInput;
};

export type MutationDisconnectEventbriteIntegrationArgs = {
  input: DisconnectEventbriteIntegrationInput;
};

export type MutationDisconnectSevenShiftsIntegrationArgs = {
  input: DisconnectSevenShiftsIntegrationInput;
};

export type MutationDisconnectStripeAccountArgs = {
  input: DisconnectStripeAccountInput;
};

export type MutationDismissSuggestedActionArgs = {
  input: DismissSuggestedActionInput;
};

export type MutationDuplicateEventArgs = {
  input: DuplicateEventInput;
};

export type MutationDuplicateFloorPlanTemplateArgs = {
  input: DuplicateFloorPlanTemplateInput;
};

export type MutationDuplicateMenuItemArgs = {
  input: DuplicateMenuItemInput;
};

export type MutationDuplicatePolicySectionArgs = {
  input: DuplicatePolicySectionInput;
};

export type MutationDuplicateVenuePolicyArgs = {
  input: DuplicateVenuePolicyInput;
};

export type MutationExportContactReportArgs = {
  input: ExportContactReportInput;
};

export type MutationExportEventReportArgs = {
  input: ExportEventReportInput;
};

export type MutationExportEventReportDocumentsArgs = {
  input: ExportEventReportDocumentsInput;
};

export type MutationExportPaymentReportArgs = {
  input: ExportPaymentReportInput;
};

export type MutationExportProposalReportArgs = {
  input: ExportProposalReportInput;
};

export type MutationExportVenueReportArgs = {
  input: ExportVenueReportInput;
};

export type MutationFinalizeAssistantUploadArgs = {
  input: FinalizeAssistantUploadInput;
};

export type MutationGenerateEventFloorPlansPdfArgs = {
  input: GenerateEventFloorPlansPdfInput;
};

export type MutationGuestUpdateContractItemArgs = {
  input: GuestUpdateContractItemInput;
};

export type MutationIgnoreSuspiciousMessageReportArgs = {
  input: IgnoreSuspiciousMessageReportInput;
};

export type MutationInitialContractPolicySectionArgs = {
  input: InitialContractPolicySectionInput;
};

export type MutationInitializeAssistantUploadArgs = {
  input: InitializeAssistantUploadInput;
};

export type MutationLinkMerriEventArgs = {
  input: LinkMerriEventInput;
};

export type MutationLinkPrismmOccasionArgs = {
  input: LinkPrismmOccasionInput;
};

export type MutationMarkEventAsSafeArgs = {
  input: MarkEventAsSafeInput;
};

export type MutationMarkMessageSuggestionShownArgs = {
  input: MarkMessageSuggestionShownInput;
};

export type MutationMergePlannersArgs = {
  input: MergePlannersInput;
};

export type MutationPayContractArgs = {
  input: PayContractInput;
};

export type MutationPurchaseAddOnArgs = {
  input: PurchaseAddOnInput;
};

export type MutationReadAllEventMessagesArgs = {
  input: ReadAllEventMessagesInput;
};

export type MutationReadAllVenueEventMessagesArgs = {
  input: ReadAllVenueEventMessagesInput;
};

export type MutationReadEventDiscussionArgs = {
  input: ReadEventDiscussionInput;
};

export type MutationReadMentionArgs = {
  input: ReadMentionInput;
};

export type MutationRefundPaymentArgs = {
  input: RefundPaymentInput;
};

export type MutationRemoveAccountArgs = {
  input: RemoveAccountInput;
};

export type MutationRemoveAdditionalContactArgs = {
  input: RemoveAdditionalContactInput;
};

export type MutationRemoveAutomaticTaskTemplateArgs = {
  input: RemoveAutomaticTaskTemplateInput;
};

export type MutationRemoveAvailabilityBlockArgs = {
  input: RemoveAvailabilityBlockInput;
};

export type MutationRemoveContractItemArgs = {
  input: RemoveContractItemInput;
};

export type MutationRemoveContractPolicySectionArgs = {
  input: RemoveContractPolicySectionInput;
};

export type MutationRemoveCustomEventTypeNameArgs = {
  input: RemoveCustomEventTypeNameInput;
};

export type MutationRemoveDocumentTemplateArgs = {
  input: RemoveDocumentTemplateInput;
};

export type MutationRemoveEmailTemplateArgs = {
  input: RemoveEmailTemplateInput;
};

export type MutationRemoveEventRehearsalArgs = {
  input: RemoveEventRehearsalInput;
};

export type MutationRemoveEventTourArgs = {
  input: RemoveEventTourInput;
};

export type MutationRemoveExpressBookItemArgs = {
  input: RemoveExpressBookItemInput;
};

export type MutationRemoveGoogleCalendarArgs = {
  input: RemoveGoogleCalendarInput;
};

export type MutationRemoveGuestSpaceFavoriteArgs = {
  input: RemoveGuestSpaceFavoriteInput;
};

export type MutationRemoveImageArgs = {
  input: RemoveImageInput;
};

export type MutationRemoveMenuCategoryArgs = {
  input: RemoveMenuCategoryInput;
};

export type MutationRemoveMenuItemArgs = {
  input: RemoveMenuItemInput;
};

export type MutationRemoveNoteTemplateArgs = {
  input: RemoveNoteTemplateInput;
};

export type MutationRemoveOfflineCommunicationArgs = {
  input: RemoveOfflineCommunicationInput;
};

export type MutationRemoveOrganizationMembershipArgs = {
  input: RemoveOrganizationMembershipInput;
};

export type MutationRemoveOrganizationPaymentMethodArgs = {
  input: RemoveOrganizationPaymentMethodInput;
};

export type MutationRemovePaymentArgs = {
  input: RemovePaymentInput;
};

export type MutationRemovePlannerPaymentMethodArgs = {
  input: RemovePlannerPaymentMethodInput;
};

export type MutationRemoveRecurringEventArgs = {
  input: RemoveRecurringEventInput;
};

export type MutationRemoveReportExportArgs = {
  input: RemoveReportExportInput;
};

export type MutationRemoveReportViewArgs = {
  input: RemoveReportViewInput;
};

export type MutationRemoveSalesCategoryArgs = {
  input: RemoveSalesCategoryInput;
};

export type MutationRemoveSessionArgs = {
  input: RemoveSessionInput;
};

export type MutationRemoveSpaceArgs = {
  input: RemoveSpaceInput;
};

export type MutationRemoveTaskArgs = {
  input: RemoveTaskInput;
};

export type MutationRemoveUserFieldDefinitionArgs = {
  input: RemoveUserFieldDefinitionInput;
};

export type MutationRemoveVenueArgs = {
  input: RemoveVenueInput;
};

export type MutationRemoveVenueCollectionArgs = {
  input: RemoveVenueCollectionInput;
};

export type MutationRemoveVenueOpentableCredentialsArgs = {
  input: RemoveVenueOpentableCredentialsInput;
};

export type MutationReorderContractPolicySectionsArgs = {
  input: ReorderContractPolicySectionsInput;
};

export type MutationReorderEmailTemplatesArgs = {
  input: ReorderEmailTemplatesInput;
};

export type MutationReorderMenuCategoriesArgs = {
  input: ReorderMenuCategoriesInput;
};

export type MutationReorderMenuItemsArgs = {
  input: ReorderMenuItemsInput;
};

export type MutationReorderOrganizationEmailTemplatesArgs = {
  input: ReorderOrganizationEmailTemplatesInput;
};

export type MutationReorderUserFieldDefinitionsArgs = {
  input: ReorderUserFieldDefinitionsInput;
};

export type MutationReportSuspiciousMessageArgs = {
  input: ReportSuspiciousMessageInput;
};

export type MutationResendReviewRequestArgs = {
  input: ResendReviewRequestInput;
};

export type MutationResetContractTaxesAndFeesArgs = {
  input: ResetContractTaxesAndFeesInput;
};

export type MutationRetrySendMessageArgs = {
  input: RetrySendMessageInput;
};

export type MutationRevertContractPolicyArgs = {
  input: RevertContractPolicyInput;
};

export type MutationRevertContractVenuePolicyArgs = {
  input: RevertContractVenuePolicyInput;
};

export type MutationRevokeSquareAccountArgs = {
  input: RevokeSquareAccountInput;
};

export type MutationRollbackVenueDataImportArgs = {
  input: RollbackVenueDataImportInput;
};

export type MutationSendEventPlanInvitationArgs = {
  input: SendEventPlanInvitationInput;
};

export type MutationSendExpressBookRequestArgs = {
  input: SendExpressBookRequestInput;
};

export type MutationSendResetPasswordEmailArgs = {
  input: SendResetPasswordEmailInput;
};

export type MutationSetMonthlyGoalsArgs = {
  input: SetMonthlyGoalsInput;
};

export type MutationSetSpaceBookingWindowsArgs = {
  input: SetSpaceBookingWindowsInput;
};

export type MutationSetVenueOpentableCredentialsArgs = {
  input: SetVenueOpentableCredentialsInput;
};

export type MutationSetVenueOpentableCustomInstructionsArgs = {
  input: SetVenueOpentableCustomInstructionsInput;
};

export type MutationSetVenueOpentableSyncTriggerStatusArgs = {
  input: SetVenueOpentableSyncTriggerStatusInput;
};

export type MutationSkipMenuSelectionForExpressBookArgs = {
  input: SkipMenuSelectionForExpressBookInput;
};

export type MutationStartAddOnTrialArgs = {
  input: StartAddOnTrialInput;
};

export type MutationStartPlanTierTrialArgs = {
  input: StartPlanTierTrialInput;
};

export type MutationSubmitQuestionnaireAnswersArgs = {
  input: SubmitQuestionnaireAnswersInput;
};

export type MutationToggleContractItemAddonArgs = {
  input: ToggleContractItemAddonInput;
};

export type MutationToggleContractItemOptionArgs = {
  input: ToggleContractItemOptionInput;
};

export type MutationUnarchiveEventsArgs = {
  input: UnarchiveEventsInput;
};

export type MutationUnarchiveVenueEventsArgs = {
  input: UnarchiveVenueEventsInput;
};

export type MutationUndeleteEventArgs = {
  input: UndeleteEventInput;
};

export type MutationUnlinkMerriEventArgs = {
  input: UnlinkMerriEventInput;
};

export type MutationUnreadLatestEventMessagesArgs = {
  input: UnreadLatestEventMessagesInput;
};

export type MutationUnreadLatestVenueEventMessagesArgs = {
  input: UnreadLatestVenueEventMessagesInput;
};

export type MutationUnreadMentionArgs = {
  input: UnreadMentionInput;
};

export type MutationUnreadMessageArgs = {
  input: UnreadMessageInput;
};

export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};

export type MutationUpdateAutomaticTaskTemplateArgs = {
  input: UpdateAutomaticTaskTemplateInput;
};

export type MutationUpdateAvailabilityBlockArgs = {
  input: UpdateAvailabilityBlockInput;
};

export type MutationUpdateBeoCustomizationArgs = {
  input: UpdateBeoCustomizationInput;
};

export type MutationUpdateContactFormSettingsArgs = {
  input: UpdateContactFormSettingsInput;
};

export type MutationUpdateContractArgs = {
  input: UpdateContractInput;
};

export type MutationUpdateContractItemArgs = {
  input: UpdateContractItemInput;
};

export type MutationUpdateContractItemAddonArgs = {
  input: UpdateContractItemAddonInput;
};

export type MutationUpdateContractItemOptionArgs = {
  input: UpdateContractItemOptionInput;
};

export type MutationUpdateContractPolicySectionArgs = {
  input: UpdateContractPolicySectionInput;
};

export type MutationUpdateCurrentGuestArgs = {
  input: UpdateCurrentGuestInput;
};

export type MutationUpdateCustomEventTypeNameArgs = {
  input: UpdateCustomEventTypeNameInput;
};

export type MutationUpdateDocumentTemplateArgs = {
  input: UpdateDocumentTemplateInput;
};

export type MutationUpdateEmailTemplateArgs = {
  input: UpdateEmailTemplateInput;
};

export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};

export type MutationUpdateEventFloorPlanArgs = {
  input: UpdateEventFloorPlanInput;
};

export type MutationUpdateEventPlanArgs = {
  input: UpdateEventPlanInput;
};

export type MutationUpdateEventStatusAutomationSettingsArgs = {
  input: UpdateEventStatusAutomationSettingsInput;
};

export type MutationUpdateEventbriteOrganizationsArgs = {
  input: UpdateEventbriteOrganizationsInput;
};

export type MutationUpdateExpressBookItemArgs = {
  input: UpdateExpressBookItemInput;
};

export type MutationUpdateExpressBookSettingsArgs = {
  input: UpdateExpressBookSettingsInput;
};

export type MutationUpdateFeeArgs = {
  input: UpdateFeeInput;
};

export type MutationUpdateFloorPlanObjectLibraryItemArgs = {
  input: UpdateFloorPlanObjectLibraryItemInput;
};

export type MutationUpdateFloorPlanTemplateArgs = {
  input: UpdateFloorPlanTemplateInput;
};

export type MutationUpdateFoodAndBeverageMinimumArgs = {
  input: UpdateFoodAndBeverageMinimumInput;
};

export type MutationUpdateFraudTokenArgs = {
  input: UpdateFraudTokenInput;
};

export type MutationUpdateHoursOfOperationArgs = {
  input: UpdateHoursOfOperationInput;
};

export type MutationUpdateMenuCategoryArgs = {
  input: UpdateMenuCategoryInput;
};

export type MutationUpdateMenuItemArgs = {
  input: UpdateMenuItemInput;
};

export type MutationUpdateMessageArgs = {
  input: UpdateMessageInput;
};

export type MutationUpdateMessageSuggestionArgs = {
  input: UpdateMessageSuggestionInput;
};

export type MutationUpdateMonthlyGoalArgs = {
  input: UpdateMonthlyGoalInput;
};

export type MutationUpdateNoteTemplateArgs = {
  input: UpdateNoteTemplateInput;
};

export type MutationUpdateNotificationSettingsArgs = {
  input: UpdateNotificationSettingsInput;
};

export type MutationUpdateOauthApplicationArgs = {
  input: UpdateOauthApplicationInput;
};

export type MutationUpdateOfflineCommunicationArgs = {
  input: UpdateOfflineCommunicationInput;
};

export type MutationUpdateOnboardingArgs = {
  input: UpdateOnboardingInput;
};

export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};

export type MutationUpdateOrganizationMembershipArgs = {
  input: UpdateOrganizationMembershipInput;
};

export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};

export type MutationUpdatePlannerArgs = {
  input: UpdatePlannerInput;
};

export type MutationUpdatePolicySectionArgs = {
  input: UpdatePolicySectionInput;
};

export type MutationUpdateRecurringEventArgs = {
  input: UpdateRecurringEventInput;
};

export type MutationUpdateReportViewArgs = {
  input: UpdateReportViewInput;
};

export type MutationUpdateReviewArgs = {
  input: UpdateReviewInput;
};

export type MutationUpdateSalesCategoryArgs = {
  input: UpdateSalesCategoryInput;
};

export type MutationUpdateSessionArgs = {
  input: UpdateSessionInput;
};

export type MutationUpdateSpaceArgs = {
  input: UpdateSpaceInput;
};

export type MutationUpdateSpaceExpressBookSettingsArgs = {
  input: UpdateSpaceExpressBookSettingsInput;
};

export type MutationUpdateSpacesCventRoomIdArgs = {
  input: UpdateSpacesCventRoomIdInput;
};

export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};

export type MutationUpdateTaxArgs = {
  input: UpdateTaxInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationUpdateUserFieldDefinitionArgs = {
  input: UpdateUserFieldDefinitionInput;
};

export type MutationUpdateVacationReplyArgs = {
  input: UpdateVacationReplyInput;
};

export type MutationUpdateVenueArgs = {
  input: UpdateVenueInput;
};

export type MutationUpdateVenueCollectionArgs = {
  input: UpdateVenueCollectionInput;
};

export type MutationUpdateVenuePlanArgs = {
  input: UpdateVenuePlanInput;
};

export type MutationUpdateVenuePolicyArgs = {
  input: UpdateVenuePolicyInput;
};

export type MutationUpdateVenueSetupArgs = {
  input: UpdateVenueSetupInput;
};

export type MutationUpdateVenueSubscriptionPaymentMethodArgs = {
  input: UpdateVenueSubscriptionPaymentMethodInput;
};

export type MutationUpdateVenuesCventPropertyIdArgs = {
  input: UpdateVenuesCventPropertyIdInput;
};

export type MutationUpdateVenuesMerriIdArgs = {
  input: UpdateVenuesMerriIdInput;
};

export type MutationUpdateVenuesPrismmIdArgs = {
  input: UpdateVenuesPrismmIdInput;
};

export type MutationUpdateVenuesSevenShiftsIdArgs = {
  input: UpdateVenuesSevenShiftsIdInput;
};

export type MutationUploadNotesImageArgs = {
  input: UploadNotesImageInput;
};

export type MutationUploadSignatureBlockImageArgs = {
  input: UploadSignatureBlockImageInput;
};

export type MutationUpsertVenueAiReplyInstructionArgs = {
  input: UpsertVenueAiReplyInstructionInput;
};

export type NoteTemplate = {
  __typename?: 'NoteTemplate';
  automatic: Scalars['Boolean']['output'];
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventType?: Maybe<Scalars['String']['output']>;
  eventTypeFormatted?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venueId: Scalars['Int']['output'];
};

export type OauthApplication = {
  __typename?: 'OauthApplication';
  awaitingReview: Scalars['Boolean']['output'];
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  confidential: Scalars['Boolean']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  lastTokenIssuedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  private: Scalars['Boolean']['output'];
  published: Scalars['Boolean']['output'];
  redirectUri: Scalars['String']['output'];
  scopes: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for OauthApplication. */
export type OauthApplicationConnection = {
  __typename?: 'OauthApplicationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OauthApplicationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OauthApplication>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OauthApplicationEdge = {
  __typename?: 'OauthApplicationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OauthApplication>;
};

export type OfflineCommunication = {
  __typename?: 'OfflineCommunication';
  event: Event;
  id: Scalars['ID']['output'];
  kind: OfflineCommunicationKind;
  note?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['ISO8601DateTime']['output'];
  planner?: Maybe<Planner>;
  user: User;
};

export enum OfflineCommunicationKind {
  Email = 'email',
  Meeting = 'meeting',
  Other = 'other',
  Phone = 'phone',
  Sms = 'sms',
}

export type Organization = {
  __typename?: 'Organization';
  accounts: Array<Account>;
  activeVenues?: Maybe<Array<Venue>>;
  addOnDiscount?: Maybe<Scalars['Float']['output']>;
  aiFeeAgreement?: Maybe<OrganizationAiFeeAgreement>;
  banner?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Address>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  calendarWeekStart: Scalars['Int']['output'];
  canCancelEvents: AuthorizationResult;
  canCreateOrganizationMembership: AuthorizationResult;
  canManageBilling: AuthorizationResult;
  canManageExpressBookRequests: AuthorizationResult;
  canUpdate: AuthorizationResult;
  contactFormBackgroundColor: Scalars['String']['output'];
  contactFormBanner?: Maybe<Scalars['String']['output']>;
  contactFormButtonColor: Scalars['String']['output'];
  contactFormSettings: ContactFormSettings;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customFieldDefinitions: Scalars['JSON']['output'];
  cventIntegration?: Maybe<CventIntegration>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  documents: Array<Document>;
  emailTemplates: Array<EmailTemplate>;
  eventStatusAutomationSettings: EventStatusAutomationSettings;
  eventTypes: Array<EventType>;
  eventbriteIntegration?: Maybe<EventbriteIntegration>;
  featureFlags: Scalars['JSON']['output'];
  freeTrialEndsAt?: Maybe<Scalars['ISO8601Date']['output']>;
  gtmId?: Maybe<Scalars['String']['output']>;
  helloLeadFormPath: Scalars['String']['output'];
  helloLeadFormUrl: Scalars['String']['output'];
  hubspotDealId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lastInvoiceNumber: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  monthlyRecurringRevenue?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Visible to organization admins only */
  oauthApplications: Array<OauthApplication>;
  organizationMemberships?: Maybe<Array<OrganizationMembership>>;
  paymentMethods: Array<OrganizationPaymentMethod>;
  planSet?: Maybe<PlanSet>;
  publicId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  spaces?: Maybe<Array<Space>>;
  stripeCardDetail?: Maybe<Scalars['JSON']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  useSubtotalForReporting: Scalars['Boolean']['output'];
  userFieldDefinitions: Array<UserFieldDefinition>;
  users?: Maybe<Array<User>>;
  venueCollections: Array<VenueCollection>;
  venues?: Maybe<Array<Venue>>;
  widgetContactFormRedirectUrl?: Maybe<Scalars['String']['output']>;
  widgetInstanceId: Scalars['String']['output'];
};

export type OrganizationAiFeeAgreement = {
  __typename?: 'OrganizationAiFeeAgreement';
  accepted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  rate: Scalars['Float']['output'];
  startsOn: Scalars['ISO8601Date']['output'];
  state: OrganizationAiFeeAgreementState;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedByAdmin?: Maybe<Admin>;
};

export enum OrganizationAiFeeAgreementState {
  /** Accepted and started; the AI fee is added to online payments */
  Active = 'active',
  /** Declined and started; AI features are disabled */
  Canceled = 'canceled',
  /** starts_on has not arrived; AI features are free until then */
  Trial = 'trial',
}

/** The connection type for Organization. */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organization>;
};

export type OrganizationMembership = {
  __typename?: 'OrganizationMembership';
  canDestroy: AuthorizationResult;
  canUpdate: AuthorizationResult;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  initialMember: Scalars['Boolean']['output'];
  newLeadsEmail: Scalars['Boolean']['output'];
  newLeadsSms: Scalars['Boolean']['output'];
  organization: Organization;
  ownerAssignedEmail: Scalars['Boolean']['output'];
  paymentEmails: Scalars['Boolean']['output'];
  reviewSubmittedEmail: Scalars['Boolean']['output'];
  role: Role;
  teamMessageEmail: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  weeklyDigestEmail: Scalars['Boolean']['output'];
};

export type OrganizationPaymentMethod = {
  __typename?: 'OrganizationPaymentMethod';
  brand?: Maybe<Scalars['String']['output']>;
  cardholderName?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['String']['output']>;
  expYear?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  paymentMethodType: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PayContract */
export type PayContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gratuityRate?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  payMode?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  squarePlaidPayload?: InputMaybe<PlaidPayloadInput>;
};

/** Autogenerated return type of PayContract. */
export type PayContractPayload = {
  __typename?: 'PayContractPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<GuestProposal>;
  errors: Array<Error>;
  paymentIntentClientSecret?: Maybe<Scalars['String']['output']>;
  paymentIntentStripeAccountId?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Int']['output'];
  amountMinusRefundAmount: Scalars['Int']['output'];
  chargedOnProcessorAccountId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: Event;
  feeAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  kind: PaymentKind;
  mechanism: PaymentMechanism;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  offlineMethod?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentProvider?: Maybe<PaymentProvider>;
  paymentReportTypeLabel: Scalars['String']['output'];
  payoutId?: Maybe<Scalars['ID']['output']>;
  processorPaymentId?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Int']['output']>;
  refundState?: Maybe<Scalars['String']['output']>;
  refunded: Scalars['Boolean']['output'];
  refunds: Array<Refund>;
  scheduledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  state: Scalars['String']['output'];
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  surchargeAmount: Scalars['Int']['output'];
  type: PaymentType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venue: Venue;
};

/** The connection type for Payment. */
export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Payment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Payment>;
};

export enum PaymentKind {
  Deposit = 'deposit',
  Other = 'other',
  RemainingBalance = 'remaining_balance',
}

export enum PaymentMechanism {
  Ach = 'ach',
  Card = 'card',
  Offline = 'offline',
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brand?: Maybe<Scalars['String']['output']>;
  cardholderName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  mechanism: PaymentMethodMechanism;
  paymentProvider?: Maybe<PaymentProvider>;
  planner: Planner;
  type: PaymentMethodType;
};

export enum PaymentMethodMechanism {
  Ach = 'ach',
  Card = 'card',
  GuestChoice = 'guest_choice',
  GuestChoiceWithSurcharge = 'guest_choice_with_surcharge',
}

export enum PaymentMethodType {
  FinixBankAccount = 'FinixBankAccount',
  FinixCard = 'FinixCard',
  SquarePaymentMethod = 'SquarePaymentMethod',
  StripeBankAccount = 'StripeBankAccount',
  StripeCard = 'StripeCard',
  StripePaymentMethod = 'StripePaymentMethod',
}

export enum PaymentProvider {
  Finix = 'finix',
  Square = 'square',
  Stripe = 'stripe',
}

export enum PaymentType {
  FinixAchCharge = 'FinixAchCharge',
  FinixCardCharge = 'FinixCardCharge',
  Offline = 'Offline',
  SquarePayment = 'SquarePayment',
  StripeAchCharge = 'StripeAchCharge',
  StripeAchPaymentIntent = 'StripeAchPaymentIntent',
  StripeCardCharge = 'StripeCardCharge',
  StripeCardPaymentIntent = 'StripeCardPaymentIntent',
  StripePaymentIntent = 'StripePaymentIntent',
}

export type PlaidPayloadInput = {
  /** Plaid Account */
  account: Scalars['JSON']['input'];
  /** Plaid Public Token */
  publicToken: Scalars['String']['input'];
};

export type PlanDefinition = {
  __typename?: 'PlanDefinition';
  achApplicationFeeRate?: Maybe<Scalars['Float']['output']>;
  active: Scalars['Boolean']['output'];
  billingInterval: BillingInterval;
  cardApplicationFeeRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  monthlyRate: Scalars['Int']['output'];
  planName: Scalars['String']['output'];
  stripePriceId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  tier: Tier;
};

export type PlanSet = {
  __typename?: 'PlanSet';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  planDefinitions: Array<PlanDefinition>;
};

export type Planner = {
  __typename?: 'Planner';
  account?: Maybe<Account>;
  additionalEvents: Array<Event>;
  additionalPlannerCount: Scalars['Int']['output'];
  address?: Maybe<Address>;
  averageSpend: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<EmailAddress>;
  events: Array<Event>;
  eventsCount: Scalars['Int']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gravatarUrl?: Maybe<Scalars['String']['output']>;
  guest?: Maybe<Guest>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  org?: Maybe<Scalars['String']['output']>;
  pastEventCount: Scalars['Int']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethods: Array<PaymentMethod>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalSpend: Scalars['Int']['output'];
  upcomingEventCount: Scalars['Int']['output'];
  venue: Venue;
  venueName: Scalars['String']['output'];
};

export type PlannerAdditionalEventsArgs = {
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PlannerEventsArgs = {
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The connection type for Planner. */
export type PlannerConnection = {
  __typename?: 'PlannerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlannerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Planner>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PlannerEdge = {
  __typename?: 'PlannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Planner>;
};

export type PlannerFraudAnalysis = {
  __typename?: 'PlannerFraudAnalysis';
  eventsWithMatchingEmail: Array<Event>;
  eventsWithMatchingPhone: Array<Event>;
  planner: Planner;
};

/** Planner Input */
export type PlannerInput = {
  /** Account Name */
  accountName?: InputMaybe<Scalars['String']['input']>;
  /** Attempt to match to existing planner via email match */
  attemptMatchByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First Name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Guest public_id */
  guestId?: InputMaybe<Scalars['ID']['input']>;
  /** Last Name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Org */
  org?: InputMaybe<Scalars['String']['input']>;
  /** Phone */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type PlannerSearchResult = {
  __typename?: 'PlannerSearchResult';
  account?: Maybe<Account>;
  additionalEvents: Array<Event>;
  additionalPlannerCount: Scalars['Int']['output'];
  address?: Maybe<Address>;
  averageSpend: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<EmailAddress>;
  events: Array<Event>;
  eventsCount: Scalars['Int']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gravatarUrl?: Maybe<Scalars['String']['output']>;
  guest?: Maybe<Guest>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  org?: Maybe<Scalars['String']['output']>;
  pastEventCount: Scalars['Int']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethods: Array<PaymentMethod>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalSpend: Scalars['Int']['output'];
  upcomingEventCount: Scalars['Int']['output'];
  venue: Venue;
  venueName: Scalars['String']['output'];
};

export type PlannerSearchResultAdditionalEventsArgs = {
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PlannerSearchResultEventsArgs = {
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The connection type for PlannerSearchResult. */
export type PlannerSearchResultConnection = {
  __typename?: 'PlannerSearchResultConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PlannerSearchResultEdge>>>;
  id: Scalars['ID']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PlannerSearchResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  query: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PlannerSearchResultEdge = {
  __typename?: 'PlannerSearchResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PlannerSearchResult>;
};

export type PolicySection = {
  __typename?: 'PolicySection';
  body: Scalars['JSON']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venue: Venue;
};

export type PrismmCreatedBy = {
  __typename?: 'PrismmCreatedBy';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PrismmIntegration = {
  __typename?: 'PrismmIntegration';
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  user: User;
};

export type PrismmOccasion = {
  __typename?: 'PrismmOccasion';
  createdBy?: Maybe<PrismmCreatedBy>;
  date: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PrismmOccasionLink = {
  __typename?: 'PrismmOccasionLink';
  occasionLink?: Maybe<Scalars['String']['output']>;
};

export enum ProposalLockCondition {
  LockContractOneWeekBeforeEvent = 'lock_contract_one_week_before_event',
  LockContractThreeWeeksBeforeEvent = 'lock_contract_three_weeks_before_event',
  LockContractTwoWeeksBeforeEvent = 'lock_contract_two_weeks_before_event',
  LockContractWhenSigned = 'lock_contract_when_signed',
  NeverLockContract = 'never_lock_contract',
}

/** Autogenerated input type of PurchaseAddOn */
export type PurchaseAddOnInput = {
  addOnDefinitionId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of PurchaseAddOn. */
export type PurchaseAddOnPayload = {
  __typename?: 'PurchaseAddOnPayload';
  addOnPlan?: Maybe<AddOnPlan>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  /** Paginated account events data */
  accountEvents: EventConnection;
  /** Paginated account report data */
  accountReport: AccountConnection;
  /** Active events - events that are not canceled */
  activeEvents: ActiveEventConnection;
  addOnDefinitions: Array<AddOnDefinition>;
  addresses: Array<Address>;
  adminAiReplySession: AiReplySession;
  adminAssistantConversations: Scalars['JSON']['output'];
  adminOauthApplication: OauthApplication;
  /** Paginated list of OAuth applications for admin panel */
  adminOauthApplications: OauthApplicationConnection;
  /** Paginated list of pending, syncing, and failed OpenTable integration syncs for admin panel */
  adminOpentableSyncs: EventIntegrationSyncConnection;
  /** Paginated list of organizations for admin panel */
  adminOrganizations: OrganizationConnection;
  /** Paginated list of payments for admin panel */
  adminPayments: PaymentConnection;
  adminPlanDefinitions: Array<PlanDefinition>;
  adminPlanSets: Array<PlanSet>;
  /** Admin search across Users, Venues, and Organizations */
  adminSearch: AdminSearch;
  /** Paginated list of users for admin panel */
  adminUsers: UserConnection;
  adminValidTimezones: Array<Scalars['String']['output']>;
  adminVenue: AdminVenue;
  /** Paginated list of venues for admin panel */
  adminVenues: AdminVenueConnection;
  /** Returns all available amenities */
  amenities: Array<Amenity>;
  analyticsData: Array<AnalyticsDatum>;
  assistantConversation: Scalars['JSON']['output'];
  assistantConversations: Scalars['JSON']['output'];
  assistantEmailDrafts: Scalars['JSON']['output'];
  /** find authenticated admin */
  authenticatedAdmin?: Maybe<Admin>;
  /** find authenticated guest */
  authenticatedGuest?: Maybe<Guest>;
  /** find authenticated user */
  authenticatedUser?: Maybe<User>;
  /** Automatic task options for a venue */
  automaticTaskOptions: AutomaticTaskOption;
  /** Automatic task templates for a venue */
  automaticTaskTemplates?: Maybe<Array<AutomaticTaskTemplate>>;
  /** Queries available spaces for marketplace pages */
  availableSpaces: Array<MarketplaceSpace>;
  /** Events for specified venues with optional date filtering */
  calendarEvents: Array<Event>;
  /** Queries contact form settings */
  contactFormSettings?: Maybe<ContactFormSettings>;
  /** Paginated contact report data */
  contactReport: PlannerConnection;
  contract?: Maybe<Contract>;
  conversionRateAnalyticsByUser: Array<ConversionRateAnalytics>;
  conversionRateAnalyticsByVenue: Array<ConversionRateAnalytics>;
  conversionRateAnalyticsOverview: ConversionRateAnalytics;
  currentRemoteRefreshToken?: Maybe<RemoteRefreshToken>;
  customGoalViews: Array<CustomGoalView>;
  /** Get a document template by ID */
  documentTemplate?: Maybe<DocumentTemplate>;
  /** Document templates for a venue */
  documentTemplates?: Maybe<Array<DocumentTemplate>>;
  /** Draft messages for the current user, scoped to given venues */
  draftMessages: Array<Message>;
  emailTemplates: Array<EmailTemplate>;
  event?: Maybe<Event>;
  /** Paginated discussion comments */
  eventDiscussion?: Maybe<Discussion>;
  /** Paginated discussion comments */
  eventDiscussionComments: CommentConnection;
  eventFloorPlan?: Maybe<EventFloorPlan>;
  eventFloorPlans: Array<EventFloorPlan>;
  /** Event plan invitations where the current guest is the invitee */
  eventPlanInvitations: Array<EventPlanInvitation>;
  /** Event plans for current guest */
  eventPlans: Array<EventPlan>;
  /** Paginated event report data */
  eventReport: EventConnection;
  /** Search for events by venue id and query */
  eventSearch: EventSearchResultConnection;
  /** Tasks for an event */
  eventTasks: TaskConnection;
  floorPlanObjectLibrary: Array<FloorPlanObjectLibraryItem>;
  floorPlanTemplate: FloorPlanTemplate;
  floorPlanTemplates: Array<FloorPlanTemplate>;
  /** food and bev minimums for a venue */
  foodAndBeverageMinimums: Array<FoodAndBeverageMinimum>;
  /** Get fraud detections for analytics */
  fraudDetections: Array<FraudDetection>;
  /** Get a single fraud token by ID */
  fraudToken: FraudToken;
  /** Get details about a fraud token including matching planners and events */
  fraudTokenDetails: FraudTokenDetails;
  /** List all fraud tokens for admin panel */
  fraudTokens: Array<FraudToken>;
  /** Contract proposal for the guest proposal page, looked up by contract UUID */
  guestProposal?: Maybe<GuestProposal>;
  /** Fetch HubSpot owner information for an organization */
  hubspotOwners: HubspotOwnersInfo;
  /** Inbox events - events with messages, sorted by most recent message */
  inboxEvents: InboxEventConnection;
  /** Location search */
  locationSearch: LocationSearch;
  marketplaceBreadcrumb: MarketplaceBreadcrumb;
  marketplaceEvent?: Maybe<MarketplaceEvent>;
  /** Organization profile for marketplace */
  marketplaceOrganization?: Maybe<MarketplaceOrganization>;
  marketplaceSearch: MarketplaceSearch;
  marketplaceSpace?: Maybe<MarketplaceSpace>;
  /** Spaces near a location query that have met our criteria for being listed in search results */
  marketplaceSpaceSearch: MarketplaceSearch;
  marketplaceVenue?: Maybe<MarketplaceVenue>;
  /** Search for marketplace venues by name */
  marketplaceVenueSearch: Array<MarketplaceVenue>;
  /** Merri events - events that have been created in Merri and reside in the Merri database */
  merriEvents?: Maybe<Array<MerriEvent>>;
  message?: Maybe<Message>;
  /** AI generated message suggestion */
  messageSuggestion?: Maybe<MessageSuggestion>;
  messages: Array<Message>;
  /** Note templates for a venue */
  noteTemplates?: Maybe<Array<NoteTemplate>>;
  organization?: Maybe<Organization>;
  organizations: Array<Organization>;
  /** Paginated payment report data */
  paymentReport: PaymentConnection;
  payments: Array<Payment>;
  /** Express book requests that have a pending status */
  pendingExpressBookRequests: ExpressBookRequestConnection;
  planner?: Maybe<Planner>;
  /** Analyze a planner for potential fraud by checking their event history */
  plannerFraudAnalysis: PlannerFraudAnalysis;
  /** Search for planners by organization and query */
  plannerSearch: PlannerSearchResultConnection;
  planners: Array<Planner>;
  /** Preview statistics for a potential fraud token before creating it */
  previewFraudToken: FraudTokenPreview;
  /** Get Prismm occasion link for a given event */
  prismmOccasionLink?: Maybe<PrismmOccasionLink>;
  /** Get shareable Prismm occasion link for a given contract */
  prismmOccasionShareableLink?: Maybe<PrismmOccasionLink>;
  /** Get Prismm occasions for a given user */
  prismmOccasions?: Maybe<Array<PrismmOccasion>>;
  /** Paginated proposal report data */
  proposalReport: ContractItemConnection;
  recurringEvents: Array<RecurringEvent>;
  /** Report exports for the current user */
  reportExports: ReportExportConnection;
  /** Saved report views by kind */
  reportViews?: Maybe<Array<ReportView>>;
  salesReport: Array<Scalars['JSON']['output']>;
  /** Returns a single active event ID for the given venues (used for onboarding) */
  sampleEventId?: Maybe<Scalars['ID']['output']>;
  /** Messages the current user has scheduled to send later, scoped to given venues */
  scheduledMessages: Array<Message>;
  space?: Maybe<Space>;
  spaceAvailability?: Maybe<Scalars['JSON']['output']>;
  /** Gets available end times for an event given its offset. */
  spaceBookableEndTimes: SpaceBookableTimes;
  /** Gets available start times for an event in a space. */
  spaceBookableTimes: SpaceBookableTimes;
  /** All available space types */
  spaceTypes: Array<SpaceType>;
  spaces: Array<Space>;
  squareLocations?: Maybe<Array<SquareLocation>>;
  subscriptionHistory: Array<SubscriptionPlan>;
  /** Get all suspicious message reports */
  suspiciousMessageReports: Array<SuspiciousMessageReport>;
  tasks: Array<Task>;
  /** Comments where a teammate mentioned the signed in user, most recent first */
  teamMessageMentions: MentionConnection;
  /** Messages the current user sent that are stuck retrying, failed to deliver, or never sent, scoped to given venues */
  unsentMessages: Array<Message>;
  user?: Maybe<User>;
  userFieldDefinitions: Array<UserFieldDefinition>;
  /** User needs onboarding */
  userNeedsOnboarding: Scalars['Boolean']['output'];
  /** Look up the vacation reply of the current user */
  userVacationReply?: Maybe<VacationReply>;
  users: Array<User>;
  venue?: Maybe<Venue>;
  venueCollection?: Maybe<VenueCollection>;
  venueCollections: Array<VenueCollection>;
  venueCustomerPlanDefinitions: Array<PlanDefinition>;
  /** Venue Data Imports */
  venueDataImports: Array<VenueDataImport>;
  venueGoalsData: VenueGoalsData;
  /** Analytics for venue tasks */
  venueTaskAnalytics: VenueTaskAnalytics;
  /** Tasks for venue(s) */
  venueTasks: TaskConnection;
  /** All available venue types */
  venueTypes: Array<VenueType>;
  /** Look up the vacation reply for a venue */
  venueVacationReply?: Maybe<VacationReply>;
  /** find multiple venues */
  venues: Array<Venue>;
  /** fetch events summary for venues */
  venuesEventsSummary: Array<Venue>;
  websiteScans: Array<WebsiteScan>;
};

export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAccountEventsArgs = {
  accountId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryAccountReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryActiveEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryAdminAiReplySessionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAdminAssistantConversationsArgs = {
  assistantKey?: InputMaybe<Scalars['String']['input']>;
  beforeId?: InputMaybe<Scalars['ID']['input']>;
  beforeRunId?: InputMaybe<Scalars['ID']['input']>;
  beforeSequence?: InputMaybe<Scalars['Int']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  failed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  since?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  untilTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAdminOauthApplicationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAdminOauthApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  awaitingReview?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAdminOpentableSyncsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAdminOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAdminPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAdminSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAdminUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAdminVenueArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAdminVenuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryAnalyticsDataArgs = {
  endMonth: Scalars['ISO8601Date']['input'];
  metric: Scalars['String']['input'];
  startMonth: Scalars['ISO8601Date']['input'];
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryAssistantConversationArgs = {
  beforeSequence?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};

export type QueryAssistantConversationsArgs = {
  assistantKey?: InputMaybe<Scalars['String']['input']>;
  beforeId?: InputMaybe<Scalars['ID']['input']>;
  contextId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryAssistantEmailDraftsArgs = {
  conversationId: Scalars['ID']['input'];
};

export type QueryAutomaticTaskOptionsArgs = {
  venueId: Scalars['ID']['input'];
};

export type QueryAutomaticTaskTemplatesArgs = {
  venueId: Scalars['ID']['input'];
};

export type QueryAvailableSpacesArgs = {
  endOffset?: InputMaybe<Scalars['Int']['input']>;
  organizationSlug?: InputMaybe<Scalars['String']['input']>;
  seated?: InputMaybe<Array<Scalars['Int']['input']>>;
  standing?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startOffset?: InputMaybe<Scalars['Int']['input']>;
  venueSlug?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCalendarEventsArgs = {
  dateTimeRange: DateTimeRangeInput;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryContactFormSettingsArgs = {
  entityId: Scalars['String']['input'];
  entityType: ContactFormEntity;
};

export type QueryContactReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryContractArgs = {
  id: Scalars['ID']['input'];
};

export type QueryConversionRateAnalyticsByUserArgs = {
  comparisonEndDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  comparisonStartDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryConversionRateAnalyticsByVenueArgs = {
  comparisonEndDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  comparisonStartDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryConversionRateAnalyticsOverviewArgs = {
  comparisonEndDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  comparisonStartDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endDate: Scalars['ISO8601DateTime']['input'];
  startDate: Scalars['ISO8601DateTime']['input'];
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDocumentTemplatesArgs = {
  venueId: Scalars['ID']['input'];
};

export type QueryDraftMessagesArgs = {
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryEmailTemplatesArgs = {
  venueId: Scalars['ID']['input'];
};

export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};

export type QueryEventDiscussionArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryEventDiscussionCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryEventFloorPlanArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryEventFloorPlansArgs = {
  eventId: Scalars['ID']['input'];
  spaceId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryEventReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryEventSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryEventTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryFloorPlanObjectLibraryArgs = {
  venueId: Scalars['ID']['input'];
};

export type QueryFloorPlanTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFloorPlanTemplatesArgs = {
  spaceId?: InputMaybe<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
};

export type QueryFoodAndBeverageMinimumsArgs = {
  venueId: Scalars['ID']['input'];
};

export type QueryFraudDetectionsArgs = {
  fraudTokenId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFraudTokenArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFraudTokenDetailsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFraudTokensArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  tokenType?: InputMaybe<FraudTokenTypeEnum>;
};

export type QueryGuestProposalArgs = {
  id: Scalars['ID']['input'];
};

export type QueryHubspotOwnersArgs = {
  organizationId: Scalars['ID']['input'];
};

export type QueryInboxEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryLocationSearchArgs = {
  query: Scalars['String']['input'];
};

export type QueryMarketplaceBreadcrumbArgs = {
  spaceSlug?: InputMaybe<Scalars['String']['input']>;
  venueSlug: Scalars['String']['input'];
};

export type QueryMarketplaceEventArgs = {
  slug: Scalars['String']['input'];
};

export type QueryMarketplaceOrganizationArgs = {
  slug: Scalars['String']['input'];
};

export type QueryMarketplaceSearchArgs = {
  query: Scalars['String']['input'];
};

export type QueryMarketplaceSpaceArgs = {
  slug: Scalars['String']['input'];
};

export type QueryMarketplaceSpaceSearchArgs = {
  neLat?: InputMaybe<Scalars['Float']['input']>;
  neLng?: InputMaybe<Scalars['Float']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  swLat?: InputMaybe<Scalars['Float']['input']>;
  swLng?: InputMaybe<Scalars['Float']['input']>;
};

export type QueryMarketplaceVenueArgs = {
  slug: Scalars['String']['input'];
};

export type QueryMarketplaceVenueSearchArgs = {
  query: Scalars['String']['input'];
};

export type QueryMessageArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMessageSuggestionArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryMessagesArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryNoteTemplatesArgs = {
  venueId: Scalars['ID']['input'];
};

export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPaymentReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryPaymentsArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryPendingExpressBookRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryPlannerArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryPlannerFraudAnalysisArgs = {
  plannerId: Scalars['ID']['input'];
};

export type QueryPlannerSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPlannersArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryPreviewFraudTokenArgs = {
  tokenType: FraudTokenTypeEnum;
  value: Scalars['String']['input'];
};

export type QueryPrismmOccasionLinkArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryPrismmOccasionShareableLinkArgs = {
  contractId: Scalars['ID']['input'];
};

export type QueryPrismmOccasionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  venueId: Scalars['ID']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryProposalReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryRecurringEventsArgs = {
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryReportExportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type QueryReportViewsArgs = {
  kind: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type QuerySalesReportArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QuerySampleEventIdArgs = {
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryScheduledMessagesArgs = {
  venueIds: Array<Scalars['ID']['input']>;
};

export type QuerySpaceArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySpaceAvailabilityArgs = {
  dateTimeRange: DateTimeRangeInput;
  venueId: Scalars['ID']['input'];
};

export type QuerySpaceBookableEndTimesArgs = {
  eventDate: Scalars['ISO8601Date']['input'];
  spaceSlug: Scalars['String']['input'];
  startOffset: Scalars['Int']['input'];
  venueSlug: Scalars['String']['input'];
};

export type QuerySpaceBookableTimesArgs = {
  eventDate: Scalars['ISO8601Date']['input'];
  spaceSlug: Scalars['String']['input'];
  venueSlug: Scalars['String']['input'];
};

export type QuerySpacesArgs = {
  venueId?: InputMaybe<Scalars['ID']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QuerySquareLocationsArgs = {
  venueId: Scalars['ID']['input'];
};

export type QuerySubscriptionHistoryArgs = {
  venueId: Scalars['ID']['input'];
};

export type QuerySuspiciousMessageReportsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTasksArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryTeamMessageMentionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryUnsentMessagesArgs = {
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUserFieldDefinitionsArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<ContactFormEntity>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryVenueArgs = {
  id: Scalars['ID']['input'];
};

export type QueryVenueCollectionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryVenueCustomerPlanDefinitionsArgs = {
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryVenueDataImportsArgs = {
  venueId: Scalars['ID']['input'];
};

export type QueryVenueGoalsDataArgs = {
  year: Scalars['Int']['input'];
};

export type QueryVenueTaskAnalyticsArgs = {
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryVenueTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIds: Array<Scalars['ID']['input']>;
};

export type QueryVenueVacationReplyArgs = {
  venueId: Scalars['ID']['input'];
};

export type QueryVenuesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryVenuesEventsSummaryArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryWebsiteScansArgs = {
  venueId: Scalars['ID']['input'];
};

/** Autogenerated input type of ReadAllEventMessages */
export type ReadAllEventMessagesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ReadAllEventMessages. */
export type ReadAllEventMessagesPayload = {
  __typename?: 'ReadAllEventMessagesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  events: Array<Event>;
};

/** Autogenerated input type of ReadAllVenueEventMessages */
export type ReadAllVenueEventMessagesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ReadAllVenueEventMessages. */
export type ReadAllVenueEventMessagesPayload = {
  __typename?: 'ReadAllVenueEventMessagesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of ReadEventDiscussion */
export type ReadEventDiscussionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReadEventDiscussion. */
export type ReadEventDiscussionPayload = {
  __typename?: 'ReadEventDiscussionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of ReadMention */
export type ReadMentionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ReadMention. */
export type ReadMentionPayload = {
  __typename?: 'ReadMentionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  mention?: Maybe<Mention>;
};

export type RecurringEvent = {
  __typename?: 'RecurringEvent';
  budget?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  endOffset?: Maybe<Scalars['Int']['output']>;
  freq?: Maybe<Scalars['String']['output']>;
  groupSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  planner?: Maybe<Planner>;
  recurringDateTimeRanges: Array<DateTimeRange>;
  spaces?: Maybe<Array<Space>>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venue: Venue;
};

export type Refund = {
  __typename?: 'Refund';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RefundPayment */
export type RefundPaymentInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

/** Autogenerated return type of RefundPayment. */
export type RefundPaymentPayload = {
  __typename?: 'RefundPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  payment?: Maybe<Payment>;
};

export type RemoteRefreshToken = {
  __typename?: 'RemoteRefreshToken';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of RemoveAccount */
export type RemoveAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAccount. */
export type RemoveAccountPayload = {
  __typename?: 'RemoveAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of RemoveAdditionalContact */
export type RemoveAdditionalContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  plannerId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAdditionalContact. */
export type RemoveAdditionalContactPayload = {
  __typename?: 'RemoveAdditionalContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
  planner?: Maybe<Planner>;
};

/** Autogenerated input type of RemoveAutomaticTaskTemplate */
export type RemoveAutomaticTaskTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAutomaticTaskTemplate. */
export type RemoveAutomaticTaskTemplatePayload = {
  __typename?: 'RemoveAutomaticTaskTemplatePayload';
  automaticTaskTemplate?: Maybe<AutomaticTaskTemplate>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of RemoveAvailabilityBlock */
export type RemoveAvailabilityBlockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveAvailabilityBlock. */
export type RemoveAvailabilityBlockPayload = {
  __typename?: 'RemoveAvailabilityBlockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of RemoveContractItem */
export type RemoveContractItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveContractItem. */
export type RemoveContractItemPayload = {
  __typename?: 'RemoveContractItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
};

/** Autogenerated input type of RemoveContractPolicySection */
export type RemoveContractPolicySectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveContractPolicySection. */
export type RemoveContractPolicySectionPayload = {
  __typename?: 'RemoveContractPolicySectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
};

/** Autogenerated input type of RemoveCustomEventTypeName */
export type RemoveCustomEventTypeNameInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveCustomEventTypeName. */
export type RemoveCustomEventTypeNamePayload = {
  __typename?: 'RemoveCustomEventTypeNamePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventType?: Maybe<EventType>;
};

/** Autogenerated input type of RemoveDocumentTemplate */
export type RemoveDocumentTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveDocumentTemplate. */
export type RemoveDocumentTemplatePayload = {
  __typename?: 'RemoveDocumentTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  documentTemplate?: Maybe<DocumentTemplate>;
  errors: Array<Error>;
};

/** Autogenerated input type of RemoveEmailTemplate */
export type RemoveEmailTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveEmailTemplate. */
export type RemoveEmailTemplatePayload = {
  __typename?: 'RemoveEmailTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailTemplate?: Maybe<EmailTemplate>;
  errors: Array<Error>;
};

/** Autogenerated input type of RemoveEventRehearsal */
export type RemoveEventRehearsalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveEventRehearsal. */
export type RemoveEventRehearsalPayload = {
  __typename?: 'RemoveEventRehearsalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of RemoveEventTour */
export type RemoveEventTourInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveEventTour. */
export type RemoveEventTourPayload = {
  __typename?: 'RemoveEventTourPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of RemoveExpressBookItem */
export type RemoveExpressBookItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveExpressBookItem. */
export type RemoveExpressBookItemPayload = {
  __typename?: 'RemoveExpressBookItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<GuestProposal>;
  errors: Array<Error>;
};

/** Autogenerated input type of RemoveGoogleCalendar */
export type RemoveGoogleCalendarInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of RemoveGoogleCalendar. */
export type RemoveGoogleCalendarPayload = {
  __typename?: 'RemoveGoogleCalendarPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user?: Maybe<User>;
};

/** Autogenerated input type of RemoveGuestSpaceFavorite */
export type RemoveGuestSpaceFavoriteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  spaceSlug: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveGuestSpaceFavorite. */
export type RemoveGuestSpaceFavoritePayload = {
  __typename?: 'RemoveGuestSpaceFavoritePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  space?: Maybe<MarketplaceSpace>;
};

/** Autogenerated input type of RemoveImage */
export type RemoveImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  spaceId?: InputMaybe<Scalars['ID']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of RemoveImage. */
export type RemoveImagePayload = {
  __typename?: 'RemoveImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  space?: Maybe<Space>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of RemoveMenuCategory */
export type RemoveMenuCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveMenuCategory. */
export type RemoveMenuCategoryPayload = {
  __typename?: 'RemoveMenuCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
};

/** Autogenerated input type of RemoveMenuItem */
export type RemoveMenuItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveMenuItem. */
export type RemoveMenuItemPayload = {
  __typename?: 'RemoveMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
};

/** Autogenerated input type of RemoveNoteTemplate */
export type RemoveNoteTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveNoteTemplate. */
export type RemoveNoteTemplatePayload = {
  __typename?: 'RemoveNoteTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  noteTemplate?: Maybe<NoteTemplate>;
};

/** Autogenerated input type of RemoveOfflineCommunication */
export type RemoveOfflineCommunicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveOfflineCommunication. */
export type RemoveOfflineCommunicationPayload = {
  __typename?: 'RemoveOfflineCommunicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  offlineCommunication?: Maybe<OfflineCommunication>;
};

/** Autogenerated input type of RemoveOrganizationMembership */
export type RemoveOrganizationMembershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveOrganizationMembership. */
export type RemoveOrganizationMembershipPayload = {
  __typename?: 'RemoveOrganizationMembershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organizationMembership?: Maybe<OrganizationMembership>;
};

/** Autogenerated input type of RemoveOrganizationPaymentMethod */
export type RemoveOrganizationPaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  stripeSourceId: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveOrganizationPaymentMethod. */
export type RemoveOrganizationPaymentMethodPayload = {
  __typename?: 'RemoveOrganizationPaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organization: Organization;
};

/** Autogenerated input type of RemovePayment */
export type RemovePaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemovePayment. */
export type RemovePaymentPayload = {
  __typename?: 'RemovePaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  payment?: Maybe<Payment>;
};

/** Autogenerated input type of RemovePlannerPaymentMethod */
export type RemovePlannerPaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemovePlannerPaymentMethod. */
export type RemovePlannerPaymentMethodPayload = {
  __typename?: 'RemovePlannerPaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of RemoveRecurringEvent */
export type RemoveRecurringEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveRecurringEvent. */
export type RemoveRecurringEventPayload = {
  __typename?: 'RemoveRecurringEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  recurringEvent?: Maybe<RecurringEvent>;
};

/** Autogenerated input type of RemoveReportExport */
export type RemoveReportExportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportExportId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveReportExport. */
export type RemoveReportExportPayload = {
  __typename?: 'RemoveReportExportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reportExport?: Maybe<ReportExport>;
};

/** Autogenerated input type of RemoveReportView */
export type RemoveReportViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportViewId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveReportView. */
export type RemoveReportViewPayload = {
  __typename?: 'RemoveReportViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of RemoveSalesCategory */
export type RemoveSalesCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveSalesCategory. */
export type RemoveSalesCategoryPayload = {
  __typename?: 'RemoveSalesCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
};

/** Autogenerated input type of RemoveSession */
export type RemoveSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveSession. */
export type RemoveSessionPayload = {
  __typename?: 'RemoveSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
  session?: Maybe<Session>;
};

/** Autogenerated input type of RemoveSpace */
export type RemoveSpaceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveSpace. */
export type RemoveSpacePayload = {
  __typename?: 'RemoveSpacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  space?: Maybe<Space>;
};

/** Autogenerated input type of RemoveTask */
export type RemoveTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveTask. */
export type RemoveTaskPayload = {
  __typename?: 'RemoveTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  task?: Maybe<Task>;
};

/** Autogenerated input type of RemoveUserFieldDefinition */
export type RemoveUserFieldDefinitionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveUserFieldDefinition. */
export type RemoveUserFieldDefinitionPayload = {
  __typename?: 'RemoveUserFieldDefinitionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  userFieldDefinition?: Maybe<UserFieldDefinition>;
};

/** Autogenerated input type of RemoveVenueCollection */
export type RemoveVenueCollectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveVenueCollection. */
export type RemoveVenueCollectionPayload = {
  __typename?: 'RemoveVenueCollectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  venueCollection?: Maybe<VenueCollection>;
};

/** Autogenerated input type of RemoveVenue */
export type RemoveVenueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirmation: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of RemoveVenueOpentableCredentials */
export type RemoveVenueOpentableCredentialsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveVenueOpentableCredentials. */
export type RemoveVenueOpentableCredentialsPayload = {
  __typename?: 'RemoveVenueOpentableCredentialsPayload';
  adminVenue?: Maybe<AdminVenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated return type of RemoveVenue. */
export type RemoveVenuePayload = {
  __typename?: 'RemoveVenuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of ReorderContractPolicySections */
export type ReorderContractPolicySectionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  sectionPositions: Array<Scalars['Int']['input']>;
};

/** Autogenerated return type of ReorderContractPolicySections. */
export type ReorderContractPolicySectionsPayload = {
  __typename?: 'ReorderContractPolicySectionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
};

/** Autogenerated input type of ReorderEmailTemplates */
export type ReorderEmailTemplatesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailTemplateIds: Array<Scalars['ID']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReorderEmailTemplates. */
export type ReorderEmailTemplatesPayload = {
  __typename?: 'ReorderEmailTemplatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of ReorderMenuCategories */
export type ReorderMenuCategoriesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuCategoryIds: Array<Scalars['ID']['input']>;
  menuId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReorderMenuCategories. */
export type ReorderMenuCategoriesPayload = {
  __typename?: 'ReorderMenuCategoriesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
};

/** Autogenerated input type of ReorderMenuItems */
export type ReorderMenuItemsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  menuCategoryId: Scalars['ID']['input'];
  menuItemIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ReorderMenuItems. */
export type ReorderMenuItemsPayload = {
  __typename?: 'ReorderMenuItemsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
};

/** Autogenerated input type of ReorderOrganizationEmailTemplates */
export type ReorderOrganizationEmailTemplatesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailTemplateIds: Array<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReorderOrganizationEmailTemplates. */
export type ReorderOrganizationEmailTemplatesPayload = {
  __typename?: 'ReorderOrganizationEmailTemplatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of ReorderUserFieldDefinitions */
export type ReorderUserFieldDefinitionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['String']['input'];
  entityType: ContactFormEntity;
  userFieldDefinitionIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ReorderUserFieldDefinitions. */
export type ReorderUserFieldDefinitionsPayload = {
  __typename?: 'ReorderUserFieldDefinitionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  userFieldDefinitions?: Maybe<Array<UserFieldDefinition>>;
};

export type ReportColumn = {
  __typename?: 'ReportColumn';
  dynamicType?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  header: Scalars['String']['output'];
};

export type ReportColumnInput = {
  dynamicType?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  header: Scalars['String']['input'];
};

export type ReportExport = {
  __typename?: 'ReportExport';
  canCancel: Scalars['Boolean']['output'];
  canDelete: Scalars['Boolean']['output'];
  columns?: Maybe<Scalars['JSON']['output']>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['BigInt']['output']>;
  filters?: Maybe<Scalars['JSON']['output']>;
  filtersSummary?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  order?: Maybe<Scalars['String']['output']>;
  orderBy?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venueIds: Scalars['JSON']['output'];
};

/** The connection type for ReportExport. */
export type ReportExportConnection = {
  __typename?: 'ReportExportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReportExportEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReportExport>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ReportExportEdge = {
  __typename?: 'ReportExportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ReportExport>;
};

export type ReportFilter = {
  __typename?: 'ReportFilter';
  field: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value: Scalars['JSON']['output'];
};

export type ReportFilterInput = {
  field: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['JSON']['input'];
};

/** Autogenerated input type of ReportSuspiciousMessage */
export type ReportSuspiciousMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ReportSuspiciousMessage. */
export type ReportSuspiciousMessagePayload = {
  __typename?: 'ReportSuspiciousMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export type ReportView = {
  __typename?: 'ReportView';
  columns?: Maybe<Array<ReportColumn>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  filters?: Maybe<Array<ReportFilter>>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  orderBy?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of ResendReviewRequest */
export type ResendReviewRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResendReviewRequest. */
export type ResendReviewRequestPayload = {
  __typename?: 'ResendReviewRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of ResetContractTaxesAndFees */
export type ResetContractTaxesAndFeesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ResetContractTaxesAndFees. */
export type ResetContractTaxesAndFeesPayload = {
  __typename?: 'ResetContractTaxesAndFeesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract: Contract;
  errors: Array<Error>;
};

/** Autogenerated input type of RetrySendMessage */
export type RetrySendMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RetrySendMessage. */
export type RetrySendMessagePayload = {
  __typename?: 'RetrySendMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of RevertContractPolicy */
export type RevertContractPolicyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
};

/** Autogenerated return type of RevertContractPolicy. */
export type RevertContractPolicyPayload = {
  __typename?: 'RevertContractPolicyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
};

/** Autogenerated input type of RevertContractVenuePolicy */
export type RevertContractVenuePolicyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RevertContractVenuePolicy. */
export type RevertContractVenuePolicyPayload = {
  __typename?: 'RevertContractVenuePolicyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
  venuePolicy?: Maybe<VenuePolicy>;
};

export type Review = {
  __typename?: 'Review';
  event: MarketplaceEvent;
  guest: Guest;
  id: Scalars['ID']['output'];
  privateFeedback?: Maybe<Scalars['String']['output']>;
  publicFeedback?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  venue: MarketplaceVenue;
};

/** Autogenerated input type of RevokeSquareAccount */
export type RevokeSquareAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of RevokeSquareAccount. */
export type RevokeSquareAccountPayload = {
  __typename?: 'RevokeSquareAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export enum Role {
  Admin = 'admin',
  Editor = 'editor',
  LimitedView = 'limited_view',
  Viewer = 'viewer',
}

/** Autogenerated input type of RollbackVenueDataImport */
export type RollbackVenueDataImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RollbackVenueDataImport. */
export type RollbackVenueDataImportPayload = {
  __typename?: 'RollbackVenueDataImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venueDataImport: VenueDataImport;
};

export type SalesCategory = {
  __typename?: 'SalesCategory';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  menu: Array<Menu>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Objects which may be returned to data grid */
export type Searchable = Event | Organization | User | Venue;

/** An edge in a connection. */
export type SearchableEdge = {
  __typename?: 'SearchableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Searchable>;
};

export type SelectOption = {
  __typename?: 'SelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Autogenerated input type of SendEventPlanInvitation */
export type SendEventPlanInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventPlanId: Scalars['ID']['input'];
  inviteeEmail: Scalars['String']['input'];
};

/** Autogenerated return type of SendEventPlanInvitation. */
export type SendEventPlanInvitationPayload = {
  __typename?: 'SendEventPlanInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventPlanInvitation?: Maybe<EventPlanInvitation>;
};

/** Autogenerated input type of SendExpressBookRequest */
export type SendExpressBookRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventSlug: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};

/** Autogenerated return type of SendExpressBookRequest. */
export type SendExpressBookRequestPayload = {
  __typename?: 'SendExpressBookRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  expressBookRequest?: Maybe<MarketplaceExpressBookRequest>;
};

/** Autogenerated input type of SendResetPasswordEmail */
export type SendResetPasswordEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendResetPasswordEmail. */
export type SendResetPasswordEmailPayload = {
  __typename?: 'SendResetPasswordEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user?: Maybe<User>;
};

export type Session = {
  __typename?: 'Session';
  contractItems: Array<ContractItem>;
  dateTimeRange?: Maybe<DateTimeRange>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endOffset?: Maybe<Scalars['Int']['output']>;
  endsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  spaces: Array<Space>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startOffset?: Maybe<Scalars['Int']['output']>;
  startsAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of SetMonthlyGoals */
export type SetMonthlyGoalsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  metric: CustomGoalViewMetric;
  trackableId: Scalars['ID']['input'];
  trackableType: Scalars['String']['input'];
  values: Array<MonthlyGoalValueInput>;
  year: Scalars['Int']['input'];
};

/** Autogenerated return type of SetMonthlyGoals. */
export type SetMonthlyGoalsPayload = {
  __typename?: 'SetMonthlyGoalsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  monthlyGoals?: Maybe<Array<MonthlyGoal>>;
};

/** Autogenerated input type of SetSpaceBookingWindows */
export type SetSpaceBookingWindowsInput = {
  bookingWindows: Array<BookingWindowInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetSpaceBookingWindows. */
export type SetSpaceBookingWindowsPayload = {
  __typename?: 'SetSpaceBookingWindowsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  space?: Maybe<Space>;
};

/** Autogenerated input type of SetVenueOpentableCredentials */
export type SetVenueOpentableCredentialsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  restaurantId: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetVenueOpentableCredentials. */
export type SetVenueOpentableCredentialsPayload = {
  __typename?: 'SetVenueOpentableCredentialsPayload';
  adminVenue?: Maybe<AdminVenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SetVenueOpentableCustomInstructions */
export type SetVenueOpentableCustomInstructionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customInstructions?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetVenueOpentableCustomInstructions. */
export type SetVenueOpentableCustomInstructionsPayload = {
  __typename?: 'SetVenueOpentableCustomInstructionsPayload';
  adminVenue?: Maybe<AdminVenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of SetVenueOpentableSyncTriggerStatus */
export type SetVenueOpentableSyncTriggerStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  triggerStatus: EventStatus;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetVenueOpentableSyncTriggerStatus. */
export type SetVenueOpentableSyncTriggerStatusPayload = {
  __typename?: 'SetVenueOpentableSyncTriggerStatusPayload';
  adminVenue?: Maybe<AdminVenue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

export enum SetupIntentMechanism {
  Ach = 'ach',
  Card = 'card',
  CardOrUsBankAccount = 'card_or_us_bank_account',
}

/** Autogenerated input type of SkipMenuSelectionForExpressBook */
export type SkipMenuSelectionForExpressBookInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventSlug: Scalars['String']['input'];
};

/** Autogenerated return type of SkipMenuSelectionForExpressBook. */
export type SkipMenuSelectionForExpressBookPayload = {
  __typename?: 'SkipMenuSelectionForExpressBookPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<MarketplaceEvent>;
};

export type Space = {
  __typename?: 'Space';
  amenities?: Maybe<Array<Amenity>>;
  bookingWindows: Array<BookingWindow>;
  cventRoomId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayColor: Scalars['String']['output'];
  displayInDirectory: Scalars['Boolean']['output'];
  effectiveExpressBookSettings: ExpressBookSettings;
  expressBookEnabled?: Maybe<Scalars['Boolean']['output']>;
  expressBookSettings?: Maybe<ExpressBookSettings>;
  id: Scalars['ID']['output'];
  ignoreConflicts: Scalars['Boolean']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Image>>;
  name: Scalars['String']['output'];
  seated?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  spaceType?: Maybe<SpaceType>;
  standing?: Maybe<Scalars['Int']['output']>;
  syncToOpentable: Scalars['Boolean']['output'];
  venue: Venue;
};

export type SpaceBookableTimes = {
  __typename?: 'SpaceBookableTimes';
  availability: Array<BookableTime>;
  spaceSlug: Scalars['String']['output'];
  venueSlug: Scalars['String']['output'];
};

export type SpaceType = {
  __typename?: 'SpaceType';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type SquareAccount = {
  __typename?: 'SquareAccount';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  squareMerchantId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SquareLocation = {
  __typename?: 'SquareLocation';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetAddress1: Scalars['String']['output'];
  streetAddress2?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

/** Autogenerated input type of StartAddOnTrial */
export type StartAddOnTrialInput = {
  addOnDefinitionId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  trialDays?: InputMaybe<Scalars['Int']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartAddOnTrial. */
export type StartAddOnTrialPayload = {
  __typename?: 'StartAddOnTrialPayload';
  addOnPlan?: Maybe<AddOnPlan>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of StartPlanTierTrial */
export type StartPlanTierTrialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  trialTier: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartPlanTierTrial. */
export type StartPlanTierTrialPayload = {
  __typename?: 'StartPlanTierTrialPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venue?: Maybe<Venue>;
};

export type StripeAccount = {
  __typename?: 'StripeAccount';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  stripeAccountId: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of SubmitQuestionnaireAnswers */
export type SubmitQuestionnaireAnswersInput = {
  /** JSON object mapping user_field_key to value */
  answers: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitQuestionnaireAnswers. */
export type SubmitQuestionnaireAnswersPayload = {
  __typename?: 'SubmitQuestionnaireAnswersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<GuestProposalEvent>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  achApplicationFeeRate?: Maybe<Scalars['Float']['output']>;
  basicFeaturesEnabled: Scalars['Boolean']['output'];
  billingInterval: BillingInterval;
  cardApplicationFeeRate?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discount: Scalars['Float']['output'];
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  lockOut: Scalars['Boolean']['output'];
  monthlyRate: Scalars['Int']['output'];
  nextBillingDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  planDefinitionId: Scalars['ID']['output'];
  planName: Scalars['String']['output'];
  premiumFeaturesEnabled: Scalars['Boolean']['output'];
  proFeaturesEnabled: Scalars['Boolean']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  status?: Maybe<SubscriptionStatus>;
  stripeScheduleId?: Maybe<Scalars['String']['output']>;
  stripeSourceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  tier: Tier;
  upcomingSubscription?: Maybe<SubscriptionPlan>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum SubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Scheduled = 'scheduled',
  Trialing = 'trialing',
  Unpaid = 'unpaid',
}

export type SuggestedAction = {
  __typename?: 'SuggestedAction';
  action: Scalars['String']['output'];
  displaySurface: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payload: Scalars['JSON']['output'];
  reason: Scalars['String']['output'];
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** The connection type for SuggestedAction. */
export type SuggestedActionConnection = {
  __typename?: 'SuggestedActionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SuggestedActionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SuggestedAction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SuggestedActionEdge = {
  __typename?: 'SuggestedActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SuggestedAction>;
};

export type SuspiciousMessageReport = {
  __typename?: 'SuspiciousMessageReport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: Event;
  fraudToken?: Maybe<FraudToken>;
  id: Scalars['ID']['output'];
  message: Message;
  notes?: Maybe<Scalars['String']['output']>;
  reportedBy: User;
  status: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Task = {
  __typename?: 'Task';
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dueAt?: Maybe<Scalars['ISO8601Date']['output']>;
  event: Event;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  venue: Venue;
};

/** The connection type for Task. */
export type TaskConnection = {
  __typename?: 'TaskConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TaskEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Task>>>;
  overdueCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TaskEdge = {
  __typename?: 'TaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Task>;
};

export type Tax = {
  __typename?: 'Tax';
  applyToMinimum: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
};

export enum Tier {
  Basic = 'basic',
  Enterprise = 'enterprise',
  Premium = 'premium',
  Professional = 'professional',
  Starter = 'starter',
  Trial = 'trial',
}

export type TimeSlot = {
  __typename?: 'TimeSlot';
  date: Scalars['ISO8601Date']['output'];
  endOffset: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  startOffset: Scalars['Int']['output'];
};

/** Autogenerated input type of ToggleContractItemAddon */
export type ToggleContractItemAddonInput = {
  addonId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of ToggleContractItemAddon. */
export type ToggleContractItemAddonPayload = {
  __typename?: 'ToggleContractItemAddonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  contractItem?: Maybe<ContractItem>;
  errors: Array<Error>;
};

/** Autogenerated input type of ToggleContractItemOption */
export type ToggleContractItemOptionInput = {
  choiceId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractItemId: Scalars['ID']['input'];
  optionId: Scalars['String']['input'];
};

/** Autogenerated return type of ToggleContractItemOption. */
export type ToggleContractItemOptionPayload = {
  __typename?: 'ToggleContractItemOptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  contractItem?: Maybe<ContractItem>;
  errors: Array<Error>;
};

/** Autogenerated input type of UnarchiveEvents */
export type UnarchiveEventsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UnarchiveEvents. */
export type UnarchiveEventsPayload = {
  __typename?: 'UnarchiveEventsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  events: Array<Event>;
};

/** Autogenerated input type of UnarchiveVenueEvents */
export type UnarchiveVenueEventsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UnarchiveVenueEvents. */
export type UnarchiveVenueEventsPayload = {
  __typename?: 'UnarchiveVenueEventsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UndeleteEvent */
export type UndeleteEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UndeleteEvent. */
export type UndeleteEventPayload = {
  __typename?: 'UndeleteEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of UnlinkMerriEvent */
export type UnlinkMerriEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlinkMerriEvent. */
export type UnlinkMerriEventPayload = {
  __typename?: 'UnlinkMerriEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of UnreadLatestEventMessages */
export type UnreadLatestEventMessagesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UnreadLatestEventMessages. */
export type UnreadLatestEventMessagesPayload = {
  __typename?: 'UnreadLatestEventMessagesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  events: Array<Event>;
};

/** Autogenerated input type of UnreadLatestVenueEventMessages */
export type UnreadLatestVenueEventMessagesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UnreadLatestVenueEventMessages. */
export type UnreadLatestVenueEventMessagesPayload = {
  __typename?: 'UnreadLatestVenueEventMessagesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UnreadMention */
export type UnreadMentionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnreadMention. */
export type UnreadMentionPayload = {
  __typename?: 'UnreadMentionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  mention?: Maybe<Mention>;
};

/** Autogenerated input type of UnreadMessage */
export type UnreadMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnreadMessage. */
export type UnreadMessagePayload = {
  __typename?: 'UnreadMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of UpdateAccount */
export type UpdateAccountInput = {
  address?: InputMaybe<AddressInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateAccount. */
export type UpdateAccountPayload = {
  __typename?: 'UpdateAccountPayload';
  account?: Maybe<Account>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateAutomaticTaskTemplate */
export type UpdateAutomaticTaskTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventTypeName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
  taskDescription?: InputMaybe<Scalars['String']['input']>;
  taskDueDateOffsetAnchor: Scalars['String']['input'];
  taskDueDateOffsetDays: Scalars['String']['input'];
  taskDueDateOffsetDirection: Scalars['String']['input'];
  taskName: Scalars['String']['input'];
  taskOwnerId?: InputMaybe<Scalars['String']['input']>;
  trigger: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateAutomaticTaskTemplate. */
export type UpdateAutomaticTaskTemplatePayload = {
  __typename?: 'UpdateAutomaticTaskTemplatePayload';
  automaticTaskTemplate?: Maybe<AutomaticTaskTemplate>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateAvailabilityBlock */
export type UpdateAvailabilityBlockInput = {
  blocks?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endOffset?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  spaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startOffset?: InputMaybe<Scalars['Int']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateAvailabilityBlock. */
export type UpdateAvailabilityBlockPayload = {
  __typename?: 'UpdateAvailabilityBlockPayload';
  availabilityBlock?: Maybe<AvailabilityBlock>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateBeoCustomization */
export type UpdateBeoCustomizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  showItemDetailsOnBeo?: InputMaybe<Scalars['Boolean']['input']>;
  showItemDetailsOnStaffBeo?: InputMaybe<Scalars['Boolean']['input']>;
  showItemInternalDetailsOnBeo?: InputMaybe<Scalars['Boolean']['input']>;
  showItemInternalDetailsOnStaffBeo?: InputMaybe<Scalars['Boolean']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateBeoCustomization. */
export type UpdateBeoCustomizationPayload = {
  __typename?: 'UpdateBeoCustomizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of UpdateContactFormSettings */
export type UpdateContactFormSettingsInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['Upload']['input']>;
  bannerSignedId?: InputMaybe<Scalars['String']['input']>;
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
  gtmId?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  logoSignedId?: InputMaybe<Scalars['String']['input']>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateContactFormSettings. */
export type UpdateContactFormSettingsPayload = {
  __typename?: 'UpdateContactFormSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contactFormSettings: ContactFormSettings;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateContract */
export type UpdateContractInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractFees?: InputMaybe<Array<ContractFeeInput>>;
  contractItems?: InputMaybe<Array<ContractItemInput>>;
  contractTaxes?: InputMaybe<Array<ContractTaxInput>>;
  countersignEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  depositAmount?: InputMaybe<Scalars['Int']['input']>;
  depositRate?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  discountEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  eventPolicySections?: InputMaybe<Array<EventPolicySectionInput>>;
  foodAndBeverageMinimumId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  minimumAmount?: InputMaybe<Scalars['Int']['input']>;
  minimumEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherPaymentAmount?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodMechanism?: InputMaybe<PaymentMethodMechanism>;
  proposalLockCondition?: InputMaybe<ContractProposalLockCondition>;
  venuePolicyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of UpdateContractItemAddon */
export type UpdateContractItemAddonInput = {
  addonId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractItemId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateContractItemAddon. */
export type UpdateContractItemAddonPayload = {
  __typename?: 'UpdateContractItemAddonPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  contractItem?: Maybe<ContractItem>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateContractItem */
export type UpdateContractItemInput = {
  addons?: InputMaybe<Array<MenuItemAddonInput>>;
  choices?: InputMaybe<Array<MenuItemChoiceInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractFeeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contractTaxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  details?: InputMaybe<Scalars['String']['input']>;
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  displayOnExpressBook?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnGuestMenu?: InputMaybe<Scalars['Boolean']['input']>;
  feeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  internalDetails?: InputMaybe<Scalars['String']['input']>;
  menuCategoryId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantitiesEditableByGuest?: InputMaybe<Scalars['Boolean']['input']>;
  quantitiesOnExtrasEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  taxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateContractItemOption */
export type UpdateContractItemOptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractItemId: Scalars['ID']['input'];
  optionId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateContractItemOption. */
export type UpdateContractItemOptionPayload = {
  __typename?: 'UpdateContractItemOptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  contractItem?: Maybe<ContractItem>;
  errors: Array<Error>;
};

/** Autogenerated return type of UpdateContractItem. */
export type UpdateContractItemPayload = {
  __typename?: 'UpdateContractItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  contractItem?: Maybe<ContractItem>;
  errors: Array<Error>;
};

/** Autogenerated return type of UpdateContract. */
export type UpdateContractPayload = {
  __typename?: 'UpdateContractPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateContractPolicySection */
export type UpdateContractPolicySectionInput = {
  body?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  requiresInitial?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateContractPolicySection. */
export type UpdateContractPolicySectionPayload = {
  __typename?: 'UpdateContractPolicySectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateCurrentGuest */
export type UpdateCurrentGuestInput = {
  address?: InputMaybe<AddressInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCurrentGuest. */
export type UpdateCurrentGuestPayload = {
  __typename?: 'UpdateCurrentGuestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  guest?: Maybe<Guest>;
};

/** Autogenerated input type of UpdateCustomEventTypeName */
export type UpdateCustomEventTypeNameInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCustomEventTypeName. */
export type UpdateCustomEventTypeNamePayload = {
  __typename?: 'UpdateCustomEventTypeNamePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventType?: Maybe<EventType>;
};

/** Autogenerated input type of UpdateDocumentTemplate */
export type UpdateDocumentTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateDocumentTemplate. */
export type UpdateDocumentTemplatePayload = {
  __typename?: 'UpdateDocumentTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  documentTemplate?: Maybe<DocumentTemplate>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateEmailTemplate */
export type UpdateEmailTemplateInput = {
  attachmentFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  attachmentSignedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  body?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypeNames?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reminderDays?: InputMaybe<Scalars['Int']['input']>;
  reminderDirection?: InputMaybe<EmailTemplateReminderDirection>;
  reminderEventState?: InputMaybe<Scalars['String']['input']>;
  reminderOccasion?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateEmailTemplate. */
export type UpdateEmailTemplatePayload = {
  __typename?: 'UpdateEmailTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  emailTemplate?: Maybe<EmailTemplate>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateEventFloorPlan */
export type UpdateEventFloorPlanInput = {
  backgroundImageSignedId?: InputMaybe<Scalars['String']['input']>;
  canvasHeight?: InputMaybe<Scalars['Int']['input']>;
  canvasWidth?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  objects?: InputMaybe<Scalars['JSON']['input']>;
  snapshotSignedId?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateEventFloorPlan. */
export type UpdateEventFloorPlanPayload = {
  __typename?: 'UpdateEventFloorPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  eventFloorPlan?: Maybe<EventFloorPlan>;
};

/** Autogenerated input type of UpdateEvent */
export type UpdateEventInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  budget?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** custom field values by field name and value */
  customFieldValues?: InputMaybe<Scalars['JSON']['input']>;
  dateTimeRange?: InputMaybe<DateTimeRangeInput>;
  eventName?: InputMaybe<Scalars['String']['input']>;
  eventTypeName?: InputMaybe<Scalars['String']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  internalNoteHtml?: InputMaybe<Scalars['String']['input']>;
  org?: InputMaybe<Scalars['String']['input']>;
  planner?: InputMaybe<PlannerInput>;
  plannerId?: InputMaybe<Scalars['ID']['input']>;
  proposalNoteHtml?: InputMaybe<Scalars['String']['input']>;
  rehearsalDateTimeRange?: InputMaybe<DateTimeRangeInput>;
  spaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<EventStatus>;
  tourDateTimeRange?: InputMaybe<DateTimeRangeInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateEvent. */
export type UpdateEventPayload = {
  __typename?: 'UpdateEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  event?: Maybe<Event>;
};

/** Autogenerated input type of UpdateEventPlan */
export type UpdateEventPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endOffset?: InputMaybe<Scalars['Int']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startOffset?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateEventPlan. */
export type UpdateEventPlanPayload = {
  __typename?: 'UpdateEventPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventPlan?: Maybe<EventPlan>;
};

/** Autogenerated input type of UpdateEventStatusAutomationSettings */
export type UpdateEventStatusAutomationSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventStatusAutomationSettings: EventStatusAutomationSettingsInput;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateEventStatusAutomationSettings. */
export type UpdateEventStatusAutomationSettingsPayload = {
  __typename?: 'UpdateEventStatusAutomationSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of UpdateEventbriteOrganizations */
export type UpdateEventbriteOrganizationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventbriteOrganizationIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateEventbriteOrganizations. */
export type UpdateEventbriteOrganizationsPayload = {
  __typename?: 'UpdateEventbriteOrganizationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  eventbriteIntegration?: Maybe<EventbriteIntegration>;
};

/** Autogenerated input type of UpdateExpressBookItem */
export type UpdateExpressBookItemInput = {
  addonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateExpressBookItem. */
export type UpdateExpressBookItemPayload = {
  __typename?: 'UpdateExpressBookItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<GuestProposal>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateExpressBookSettings */
export type UpdateExpressBookSettingsInput = {
  acceptanceTimelineHours?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  maxEventDurationHours?: InputMaybe<Scalars['Float']['input']>;
  maxLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  minBufferTimeHours?: InputMaybe<Scalars['Float']['input']>;
  minEventDurationHours?: InputMaybe<Scalars['Float']['input']>;
  minLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateExpressBookSettings. */
export type UpdateExpressBookSettingsPayload = {
  __typename?: 'UpdateExpressBookSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  expressBookSettings?: Maybe<ExpressBookSettings>;
};

/** Autogenerated input type of UpdateFee */
export type UpdateFeeInput = {
  applyToMinimum?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  taxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of UpdateFee. */
export type UpdateFeePayload = {
  __typename?: 'UpdateFeePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  fee?: Maybe<Fee>;
};

/** Autogenerated input type of UpdateFloorPlanObjectLibraryItem */
export type UpdateFloorPlanObjectLibraryItemInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  chairs?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fill?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  stroke?: InputMaybe<Scalars['String']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateFloorPlanObjectLibraryItem. */
export type UpdateFloorPlanObjectLibraryItemPayload = {
  __typename?: 'UpdateFloorPlanObjectLibraryItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  objectLibraryItem?: Maybe<FloorPlanObjectLibraryItem>;
};

/** Autogenerated input type of UpdateFloorPlanTemplate */
export type UpdateFloorPlanTemplateInput = {
  backgroundImageSignedId?: InputMaybe<Scalars['String']['input']>;
  canvasHeight?: InputMaybe<Scalars['Int']['input']>;
  canvasWidth?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  objects?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of UpdateFloorPlanTemplate. */
export type UpdateFloorPlanTemplatePayload = {
  __typename?: 'UpdateFloorPlanTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  floorPlanTemplate?: Maybe<FloorPlanTemplate>;
};

/** Autogenerated input type of UpdateFoodAndBeverageMinimum */
export type UpdateFoodAndBeverageMinimumInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateFoodAndBeverageMinimum. */
export type UpdateFoodAndBeverageMinimumPayload = {
  __typename?: 'UpdateFoodAndBeverageMinimumPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  foodAndBeverageMinimum?: Maybe<FoodAndBeverageMinimum>;
};

/** Autogenerated input type of UpdateFraudToken */
export type UpdateFraudTokenInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  tokenType?: InputMaybe<FraudTokenTypeEnum>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateFraudToken. */
export type UpdateFraudTokenPayload = {
  __typename?: 'UpdateFraudTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  fraudToken?: Maybe<FraudToken>;
};

/** Autogenerated input type of UpdateHoursOfOperation */
export type UpdateHoursOfOperationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dayOfWeek: Scalars['String']['input'];
  endTime: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  isOpen: Scalars['Boolean']['input'];
  startTime: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateHoursOfOperation. */
export type UpdateHoursOfOperationPayload = {
  __typename?: 'UpdateHoursOfOperationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  hoursOfOperation?: Maybe<HoursOfOperation>;
};

/** Autogenerated input type of UpdateMenuCategory */
export type UpdateMenuCategoryInput = {
  applyTaxesAndFeesToItems?: InputMaybe<Scalars['Boolean']['input']>;
  applyTowardMinimum?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  removeTaxRate?: InputMaybe<Scalars['Boolean']['input']>;
  salesCategoryId?: InputMaybe<Scalars['ID']['input']>;
  taxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of UpdateMenuCategory. */
export type UpdateMenuCategoryPayload = {
  __typename?: 'UpdateMenuCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
  menuCategory?: Maybe<MenuCategory>;
};

/** Autogenerated input type of UpdateMenuItem */
export type UpdateMenuItemInput = {
  addons?: InputMaybe<Array<MenuItemAddonInput>>;
  choices?: InputMaybe<Array<MenuItemChoiceInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  displayOnExpressBook?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnGuestMenu?: InputMaybe<Scalars['Boolean']['input']>;
  feeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  internalDetails?: InputMaybe<Scalars['String']['input']>;
  menuCategoryId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  quantitiesEditableByGuest?: InputMaybe<Scalars['Boolean']['input']>;
  quantitiesOnExtrasEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
  taxIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateMenuItem. */
export type UpdateMenuItemPayload = {
  __typename?: 'UpdateMenuItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
  menuItem?: Maybe<MenuItem>;
};

/** Autogenerated input type of UpdateMessage */
export type UpdateMessageInput = {
  attachmentFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  attachmentSignedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  cc?: InputMaybe<Array<EmailAddressInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  draftMessageBody?: InputMaybe<Scalars['JSON']['input']>;
  expectedRevision?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<EmailAddressInput>;
  htmlBody?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  scheduledSendAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Array<EmailAddressInput>>;
};

/** Autogenerated return type of UpdateMessage. */
export type UpdateMessagePayload = {
  __typename?: 'UpdateMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of UpdateMessageSuggestion */
export type UpdateMessageSuggestionInput = {
  actionMessageId?: InputMaybe<Scalars['ID']['input']>;
  approved: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateMessageSuggestion. */
export type UpdateMessageSuggestionPayload = {
  __typename?: 'UpdateMessageSuggestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  messageSuggestion?: Maybe<MessageSuggestion>;
};

/** Autogenerated input type of UpdateMonthlyGoal */
export type UpdateMonthlyGoalInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endMonth: Scalars['ISO8601Date']['input'];
  metric: Scalars['String']['input'];
  newData: Scalars['JSON']['input'];
  startMonth: Scalars['ISO8601Date']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateMonthlyGoal. */
export type UpdateMonthlyGoalPayload = {
  __typename?: 'UpdateMonthlyGoalPayload';
  analyticsData?: Maybe<Array<AnalyticsDatum>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
};

/** Autogenerated input type of UpdateNoteTemplate */
export type UpdateNoteTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateNoteTemplate. */
export type UpdateNoteTemplatePayload = {
  __typename?: 'UpdateNoteTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  noteTemplate?: Maybe<NoteTemplate>;
};

/** Autogenerated input type of UpdateNotificationSettings */
export type UpdateNotificationSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  newLeadsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  newLeadsSms?: InputMaybe<Scalars['Boolean']['input']>;
  ownerAssignedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  paymentEmails?: InputMaybe<Scalars['Boolean']['input']>;
  reviewSubmittedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  teamMessageEmail?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyDigestEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateNotificationSettings. */
export type UpdateNotificationSettingsPayload = {
  __typename?: 'UpdateNotificationSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organizationMembership?: Maybe<OrganizationMembership>;
};

/** Autogenerated input type of UpdateOauthApplication */
export type UpdateOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logoSignedId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOauthApplication. */
export type UpdateOauthApplicationPayload = {
  __typename?: 'UpdateOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  oauthApplication?: Maybe<OauthApplication>;
};

/** Autogenerated input type of UpdateOfflineCommunication */
export type UpdateOfflineCommunicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  kind: OfflineCommunicationKind;
  note?: InputMaybe<Scalars['String']['input']>;
  occurredAt: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of UpdateOfflineCommunication. */
export type UpdateOfflineCommunicationPayload = {
  __typename?: 'UpdateOfflineCommunicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  offlineCommunication?: Maybe<OfflineCommunication>;
};

export type UpdateOnboarding = {
  __typename?: 'UpdateOnboarding';
  currentlyUsingSoftware?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  monthlyEventsCount?: Maybe<Scalars['String']['output']>;
  numLocations?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  venueLocation?: Maybe<Scalars['String']['output']>;
  venueName?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateOnboarding */
export type UpdateOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentlyUsingSoftware?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invitedTeamMembers?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  monthlyEventsCount?: InputMaybe<Scalars['String']['input']>;
  numLocations?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  venueLocation?: InputMaybe<Scalars['String']['input']>;
  venueName?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOnboarding. */
export type UpdateOnboardingPayload = {
  __typename?: 'UpdateOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  onboarding?: Maybe<UpdateOnboarding>;
};

/** Autogenerated input type of UpdateOrganization */
export type UpdateOrganizationInput = {
  banner?: InputMaybe<Scalars['Upload']['input']>;
  bannerSignedId?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<AddressInput>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  calendarWeekStart?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactFormBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  contactFormButtonColor?: InputMaybe<Scalars['String']['input']>;
  googleTagManagerId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stripeTokenId?: InputMaybe<Scalars['String']['input']>;
  useSubtotalForReporting?: InputMaybe<Scalars['Boolean']['input']>;
  widgetContactFormRedirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateOrganizationMembership */
export type UpdateOrganizationMembershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  newLeadsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  newLeadsSms?: InputMaybe<Scalars['Boolean']['input']>;
  ownerAssignedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  paymentEmails?: InputMaybe<Scalars['Boolean']['input']>;
  reviewSubmittedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Role>;
  teamMessageEmail?: InputMaybe<Scalars['Boolean']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  weeklyDigestEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateOrganizationMembership. */
export type UpdateOrganizationMembershipPayload = {
  __typename?: 'UpdateOrganizationMembershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organizationMembership?: Maybe<OrganizationMembership>;
};

/** Autogenerated return type of UpdateOrganization. */
export type UpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of UpdatePayment */
export type UpdatePaymentInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  attachInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  kind?: InputMaybe<PaymentKind>;
  name?: InputMaybe<Scalars['String']['input']>;
  offlineMethod?: InputMaybe<Scalars['String']['input']>;
  paidAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  scheduledAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  squareTokenId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdatePayment. */
export type UpdatePaymentPayload = {
  __typename?: 'UpdatePaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  payment?: Maybe<Payment>;
};

/** Autogenerated input type of UpdatePlanner */
export type UpdatePlannerInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdatePlanner. */
export type UpdatePlannerPayload = {
  __typename?: 'UpdatePlannerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  planner?: Maybe<Planner>;
};

/** Autogenerated input type of UpdatePolicySection */
export type UpdatePolicySectionInput = {
  body?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdatePolicySection. */
export type UpdatePolicySectionPayload = {
  __typename?: 'UpdatePolicySectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  policySection?: Maybe<PolicySection>;
};

/** Autogenerated input type of UpdateRecurringEvent */
export type UpdateRecurringEventInput = {
  budget?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateTimeRange?: InputMaybe<DateTimeRangeInput>;
  freq?: InputMaybe<Scalars['String']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  planner: PlannerInput;
  spaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateRecurringEvent. */
export type UpdateRecurringEventPayload = {
  __typename?: 'UpdateRecurringEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  recurringEvent?: Maybe<RecurringEvent>;
};

/** Autogenerated input type of UpdateReportView */
export type UpdateReportViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  columns?: InputMaybe<Array<ReportColumnInput>>;
  filters?: InputMaybe<Array<ReportFilterInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  reportViewId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateReportView. */
export type UpdateReportViewPayload = {
  __typename?: 'UpdateReportViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  reportView?: Maybe<ReportView>;
};

/** Autogenerated input type of UpdateReview */
export type UpdateReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  privateFeedback?: InputMaybe<Scalars['String']['input']>;
  publicFeedback: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateReview. */
export type UpdateReviewPayload = {
  __typename?: 'UpdateReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  review?: Maybe<Review>;
};

/** Autogenerated input type of UpdateSalesCategory */
export type UpdateSalesCategoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateSalesCategory. */
export type UpdateSalesCategoryPayload = {
  __typename?: 'UpdateSalesCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  menu?: Maybe<Menu>;
  salesCategory?: Maybe<SalesCategory>;
};

/** Autogenerated input type of UpdateSession */
export type UpdateSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateTimeRange?: InputMaybe<DateTimeRangeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  spaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of UpdateSession. */
export type UpdateSessionPayload = {
  __typename?: 'UpdateSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  session?: Maybe<Session>;
};

/** Autogenerated input type of UpdateSpaceExpressBookSettings */
export type UpdateSpaceExpressBookSettingsInput = {
  acceptanceTimelineHours?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxEventDurationHours?: InputMaybe<Scalars['Float']['input']>;
  maxLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  minBufferTimeHours?: InputMaybe<Scalars['Float']['input']>;
  minEventDurationHours?: InputMaybe<Scalars['Float']['input']>;
  minLeadTimeDays?: InputMaybe<Scalars['Int']['input']>;
  spaceId: Scalars['ID']['input'];
  /** The policy express book contracts for this space start with. Null goes back to the venue default. */
  venuePolicyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateSpaceExpressBookSettings. */
export type UpdateSpaceExpressBookSettingsPayload = {
  __typename?: 'UpdateSpaceExpressBookSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  expressBookSettings?: Maybe<ExpressBookSettings>;
};

/** Autogenerated input type of UpdateSpace */
export type UpdateSpaceInput = {
  amenityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  childSpaceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayColor?: InputMaybe<Scalars['String']['input']>;
  displayInDirectory?: InputMaybe<Scalars['Boolean']['input']>;
  expressBookEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  ignoreConflicts?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  imageSignedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  imagesToRemove?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  seated?: InputMaybe<Scalars['Int']['input']>;
  spaceTypeId?: InputMaybe<Scalars['String']['input']>;
  standing?: InputMaybe<Scalars['Int']['input']>;
  syncToOpentable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateSpace. */
export type UpdateSpacePayload = {
  __typename?: 'UpdateSpacePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  space?: Maybe<Space>;
};

/** Autogenerated input type of UpdateSpacesCventRoomId */
export type UpdateSpacesCventRoomIdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  spaceMap: Scalars['JSON']['input'];
};

/** Autogenerated return type of UpdateSpacesCventRoomId. */
export type UpdateSpacesCventRoomIdPayload = {
  __typename?: 'UpdateSpacesCventRoomIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  spaces?: Maybe<Array<Space>>;
};

/** Autogenerated input type of UpdateTask */
export type UpdateTaskInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateTask. */
export type UpdateTaskPayload = {
  __typename?: 'UpdateTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  task?: Maybe<Task>;
};

/** Autogenerated input type of UpdateTax */
export type UpdateTaxInput = {
  applyToMinimum?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of UpdateTax. */
export type UpdateTaxPayload = {
  __typename?: 'UpdateTaxPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  tax?: Maybe<Tax>;
};

/** Autogenerated input type of UpdateUserFieldDefinition */
export type UpdateUserFieldDefinitionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayOnExternalDocs?: InputMaybe<Scalars['Boolean']['input']>;
  displayOnInternalDocs?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  required: Scalars['Boolean']['input'];
  visible: Scalars['Boolean']['input'];
  visibleOnExpressBook?: InputMaybe<Scalars['Boolean']['input']>;
  visibleOnGuestPortal?: InputMaybe<Scalars['Boolean']['input']>;
  visibleOnQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateUserFieldDefinition. */
export type UpdateUserFieldDefinitionPayload = {
  __typename?: 'UpdateUserFieldDefinitionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  userFieldDefinition?: Maybe<UserFieldDefinition>;
};

/** Autogenerated input type of UpdateUser */
export type UpdateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  schedulingLink?: InputMaybe<Scalars['String']['input']>;
  showLeadsOnGoogleCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  showProposalSentOnGoogleCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  signatureBlock?: InputMaybe<Scalars['String']['input']>;
  suggestMessages?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  user?: Maybe<User>;
};

/** Autogenerated input type of UpdateVacationReply */
export type UpdateVacationReplyInput = {
  body?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of UpdateVacationReply. */
export type UpdateVacationReplyPayload = {
  __typename?: 'UpdateVacationReplyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  vacationReply?: Maybe<VacationReply>;
};

/** Autogenerated input type of UpdateVenueCollection */
export type UpdateVenueCollectionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  venueIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateVenueCollection. */
export type UpdateVenueCollectionPayload = {
  __typename?: 'UpdateVenueCollectionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venueCollection?: Maybe<VenueCollection>;
};

/** Autogenerated input type of UpdateVenue */
export type UpdateVenueInput = {
  address?: InputMaybe<AddressInput>;
  autoAdvanceProposalAction?: InputMaybe<Scalars['Boolean']['input']>;
  autoCancelStaleLeads?: InputMaybe<Scalars['Boolean']['input']>;
  autoGuestGreetingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  banner?: InputMaybe<Scalars['Upload']['input']>;
  bannerSignedId?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<AddressInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactFormBackgroundColor?: InputMaybe<Scalars['String']['input']>;
  contactFormButtonColor?: InputMaybe<Scalars['String']['input']>;
  countersignEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  defaultDepositAmount?: InputMaybe<Scalars['Int']['input']>;
  defaultDepositRate?: InputMaybe<Scalars['Float']['input']>;
  defaultEventOwnerId?: InputMaybe<Scalars['Int']['input']>;
  defaultMinimumAmount?: InputMaybe<Scalars['Int']['input']>;
  defaultMinimumEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultPaymentMethodMechanism?: InputMaybe<PaymentMethodMechanism>;
  defaultPaymentProvider?: InputMaybe<PaymentProvider>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayFeedbackInProfile?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  eventEndOffset?: InputMaybe<Scalars['Int']['input']>;
  eventStartOffset?: InputMaybe<Scalars['Int']['input']>;
  feedbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  gtmId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  imageSignedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  messageSuggestionPreamble?: InputMaybe<Scalars['String']['input']>;
  minGroupSize?: InputMaybe<Scalars['Int']['input']>;
  multiDayEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceCategory?: InputMaybe<Scalars['String']['input']>;
  profileBanner?: InputMaybe<Scalars['Upload']['input']>;
  profileBannerSignedId?: InputMaybe<Scalars['String']['input']>;
  proposalLockCondition?: InputMaybe<ProposalLockCondition>;
  showPvBranding?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  spaceGraph?: InputMaybe<Array<Scalars['JSON']['input']>>;
  squareLocationId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  trialEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  venueTypeId?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  widgetContactFormRedirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateVenue. */
export type UpdateVenuePayload = {
  __typename?: 'UpdateVenuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of UpdateVenuePlan */
export type UpdateVenuePlanInput = {
  billingAddress?: InputMaybe<AddressInput>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  planDefinitionId: Scalars['ID']['input'];
  stripeSourceId?: InputMaybe<Scalars['String']['input']>;
  stripeTokenId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateVenuePlan. */
export type UpdateVenuePlanPayload = {
  __typename?: 'UpdateVenuePlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of UpdateVenuePolicy */
export type UpdateVenuePolicyInput = {
  body?: InputMaybe<Scalars['JSON']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sections?: InputMaybe<Array<VenuePolicySectionInput>>;
};

/** Autogenerated return type of UpdateVenuePolicy. */
export type UpdateVenuePolicyPayload = {
  __typename?: 'UpdateVenuePolicyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venuePolicy?: Maybe<VenuePolicy>;
};

/** Autogenerated input type of UpdateVenueSetup */
export type UpdateVenueSetupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  setup: Scalars['JSON']['input'];
};

/** Autogenerated return type of UpdateVenueSetup. */
export type UpdateVenueSetupPayload = {
  __typename?: 'UpdateVenueSetupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of UpdateVenueSubscriptionPaymentMethod */
export type UpdateVenueSubscriptionPaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  stripeSourceId: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateVenueSubscriptionPaymentMethod. */
export type UpdateVenueSubscriptionPaymentMethodPayload = {
  __typename?: 'UpdateVenueSubscriptionPaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  organization: Organization;
  venue: Venue;
};

/** Autogenerated input type of UpdateVenuesCventPropertyId */
export type UpdateVenuesCventPropertyIdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venueMap: Scalars['JSON']['input'];
};

/** Autogenerated return type of UpdateVenuesCventPropertyId. */
export type UpdateVenuesCventPropertyIdPayload = {
  __typename?: 'UpdateVenuesCventPropertyIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venues?: Maybe<Array<Venue>>;
};

/** Autogenerated input type of UpdateVenuesMerriId */
export type UpdateVenuesMerriIdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venueMap: Scalars['JSON']['input'];
};

/** Autogenerated return type of UpdateVenuesMerriId. */
export type UpdateVenuesMerriIdPayload = {
  __typename?: 'UpdateVenuesMerriIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venues?: Maybe<Array<Venue>>;
};

/** Autogenerated input type of UpdateVenuesPrismmId */
export type UpdateVenuesPrismmIdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venueMap: Scalars['JSON']['input'];
};

/** Autogenerated return type of UpdateVenuesPrismmId. */
export type UpdateVenuesPrismmIdPayload = {
  __typename?: 'UpdateVenuesPrismmIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venues?: Maybe<Array<Venue>>;
};

/** Autogenerated input type of UpdateVenuesSevenShiftsId */
export type UpdateVenuesSevenShiftsIdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  venueMap: Scalars['JSON']['input'];
};

/** Autogenerated return type of UpdateVenuesSevenShiftsId. */
export type UpdateVenuesSevenShiftsIdPayload = {
  __typename?: 'UpdateVenuesSevenShiftsIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venues?: Maybe<Array<Venue>>;
};

/** Autogenerated input type of UploadNotesImage */
export type UploadNotesImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  signedId?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of UploadNotesImage. */
export type UploadNotesImagePayload = {
  __typename?: 'UploadNotesImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  location?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UploadSignatureBlockImage */
export type UploadSignatureBlockImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  signedId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UploadSignatureBlockImage. */
export type UploadSignatureBlockImagePayload = {
  __typename?: 'UploadSignatureBlockImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  location?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpsertVenueAiReplyInstruction */
export type UpsertVenueAiReplyInstructionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  scenario: Scalars['String']['input'];
  venueId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpsertVenueAiReplyInstruction. */
export type UpsertVenueAiReplyInstructionPayload = {
  __typename?: 'UpsertVenueAiReplyInstructionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Error>;
  venueAiReplyInstruction?: Maybe<VenueAiReplyInstruction>;
};

export type User = {
  __typename?: 'User';
  activeVenueMemberships: Array<VenueMembership>;
  atlasHash: Scalars['String']['output'];
  connectedGoogleCalendar: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  cventConnected: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  eventbriteConnected: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  gravatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  magicLoginLink?: Maybe<Scalars['String']['output']>;
  merriConnected: Scalars['Boolean']['output'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationMembership?: Maybe<OrganizationMembership>;
  organizationMemberships: Array<OrganizationMembership>;
  organizations: Array<Organization>;
  phone?: Maybe<Scalars['String']['output']>;
  prismmConnected: Scalars['Boolean']['output'];
  productUpdateEmail: Scalars['Boolean']['output'];
  publicId: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  schedulingLink?: Maybe<Scalars['String']['output']>;
  sevenShiftsConnected: Scalars['Boolean']['output'];
  showLeadsOnGoogleCalendar: Scalars['Boolean']['output'];
  showProposalSentOnGoogleCalendar: Scalars['Boolean']['output'];
  signatureBlock?: Maybe<Scalars['String']['output']>;
  suggestMessages: Scalars['Boolean']['output'];
  tasks: Array<Task>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venueMemberships: Array<VenueMembership>;
  venues: Array<Venue>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserFieldDefinition = {
  __typename?: 'UserFieldDefinition';
  alwaysRequired: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  dataType: UserFieldDefinitionDataType;
  description?: Maybe<Scalars['String']['output']>;
  displayOnExternalDocs: Scalars['Boolean']['output'];
  displayOnInternalDocs: Scalars['Boolean']['output'];
  entityId: Scalars['ID']['output'];
  entityType: ContactFormEntity;
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  options: Scalars['JSON']['output'];
  ownerType: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  systemManaged: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userFieldKey: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
  visibleOnExpressBook: Scalars['Boolean']['output'];
  visibleOnGuestPortal: Scalars['Boolean']['output'];
  visibleOnQuestionnaire: Scalars['Boolean']['output'];
};

export enum UserFieldDefinitionDataType {
  Currency = 'currency',
  Date = 'date',
  Enum = 'enum',
  Integer = 'integer',
  LongText = 'long_text',
  MultiEnum = 'multi_enum',
  Phone = 'phone',
  ShortText = 'short_text',
  Time = 'time',
}

export type VacationReply = {
  __typename?: 'VacationReply';
  active: Scalars['Boolean']['output'];
  body?: Maybe<Scalars['JSON']['output']>;
  enabled: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Venue = {
  __typename?: 'Venue';
  achApplicationFeeRate?: Maybe<Scalars['Float']['output']>;
  achEnabled: Scalars['Boolean']['output'];
  activePlanTierTrial?: Maybe<VenueTierTrial>;
  addOnPlans: Array<AddOnPlan>;
  address?: Maybe<Address>;
  aiReplyProvider: AiReplyProvider;
  allowedOrigins: Array<AllowedOrigin>;
  autoAdvanceProposalAction: Scalars['Boolean']['output'];
  autoCancelStaleLeads: Scalars['Boolean']['output'];
  autoGuestGreetingEnabled: Scalars['Boolean']['output'];
  availabilityBlocks: Array<AvailabilityBlock>;
  banner?: Maybe<Scalars['String']['output']>;
  basicFeaturesEnabled: Scalars['Boolean']['output'];
  beoCustomization: BeoCustomization;
  billingAddress?: Maybe<Address>;
  billingInterval?: Maybe<BillingInterval>;
  canListFees: AuthorizationResult;
  canListMessages: AuthorizationResult;
  canListPayments: AuthorizationResult;
  canListReports: AuthorizationResult;
  canListTaxes: AuthorizationResult;
  canUpdate: AuthorizationResult;
  cardApplicationFeeRate?: Maybe<Scalars['Float']['output']>;
  contactFormBackgroundColor: Scalars['String']['output'];
  contactFormBanner?: Maybe<Scalars['String']['output']>;
  contactFormButtonColor: Scalars['String']['output'];
  contactFormSettings: ContactFormSettings;
  countersignEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency: Scalars['String']['output'];
  customFields: Array<UserFieldDefinition>;
  customerStartedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  cventPropertyId?: Maybe<Scalars['String']['output']>;
  defaultDepositAmount?: Maybe<Scalars['Int']['output']>;
  defaultDepositRate?: Maybe<Scalars['Float']['output']>;
  defaultDiscountEnabled: Scalars['Boolean']['output'];
  defaultEventOwner?: Maybe<VenueMembership>;
  defaultMinimumAmount?: Maybe<Scalars['Int']['output']>;
  defaultMinimumEnabled: Scalars['Boolean']['output'];
  defaultPaymentMethodMechanism: PaymentMethodMechanism;
  defaultPaymentProvider?: Maybe<PaymentProvider>;
  description?: Maybe<Scalars['String']['output']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  discardedEvents: Array<Event>;
  displayFeedbackInProfile: Scalars['Boolean']['output'];
  documentTemplates: Array<DocumentTemplate>;
  documents: Array<Document>;
  email: Scalars['String']['output'];
  emailAddress: EmailAddress;
  emailApiOpenTableAddress?: Maybe<Scalars['String']['output']>;
  emailApiTheKnotAddress?: Maybe<Scalars['String']['output']>;
  emailApiTockAddress?: Maybe<Scalars['String']['output']>;
  emailApiWeddingWireAddress?: Maybe<Scalars['String']['output']>;
  emailTemplates: Array<EmailTemplate>;
  eventEndOffset: Scalars['Int']['output'];
  eventOwners: Array<User>;
  eventStartOffset: Scalars['Int']['output'];
  events: Array<Event>;
  eventsSummary: Scalars['JSON']['output'];
  expressBookSettings: ExpressBookSettings;
  featureFlags: Scalars['JSON']['output'];
  featureScope: FeatureScope;
  feedbackEnabled: Scalars['Boolean']['output'];
  fees: Array<Fee>;
  foodAndBeverageMinimums: Array<FoodAndBeverageMinimum>;
  googlePlaceInfo?: Maybe<GooglePlaceInfo>;
  gtmId?: Maybe<Scalars['String']['output']>;
  helloLeadFormPath: Scalars['String']['output'];
  helloLeadFormUrl: Scalars['String']['output'];
  hoursOfOperation: Array<HoursOfOperation>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Image>>;
  internalName?: Maybe<Scalars['String']['output']>;
  liveAvailability: Scalars['Boolean']['output'];
  menu?: Maybe<Menu>;
  merriId?: Maybe<Scalars['Int']['output']>;
  messageSuggestionPreamble: Scalars['String']['output'];
  minGroupSize?: Maybe<Scalars['Int']['output']>;
  monthlyRate?: Maybe<Scalars['Int']['output']>;
  multiDayEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  opentableConnected: Scalars['Boolean']['output'];
  opentableRestaurantId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  paymentsEnabled: Scalars['Boolean']['output'];
  planName?: Maybe<Scalars['String']['output']>;
  planTierTrialHistory: Array<VenueTierTrial>;
  policySectionInitialsEnabled: Scalars['Boolean']['output'];
  policySections: Array<PolicySection>;
  premiumFeaturesEnabled: Scalars['Boolean']['output'];
  priceCategory: Scalars['String']['output'];
  prismmId?: Maybe<Scalars['String']['output']>;
  proFeaturesEnabled: Scalars['Boolean']['output'];
  profileBanner?: Maybe<Scalars['String']['output']>;
  proposalLockCondition: ProposalLockCondition;
  publicApiKey?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  qrcodePngUrl: Scalars['String']['output'];
  sevenShiftsId?: Maybe<Scalars['Int']['output']>;
  showPvBranding: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  smartFieldDefinitions: Scalars['JSON']['output'];
  spaceGraph: Scalars['JSON']['output'];
  spaces: Array<Space>;
  squareAccount?: Maybe<SquareAccount>;
  squareLocationId?: Maybe<Scalars['String']['output']>;
  stripeAccount?: Maybe<StripeAccount>;
  subscription?: Maybe<SubscriptionPlan>;
  taxes: Array<Tax>;
  timezone: Scalars['String']['output'];
  trialEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unreadMessageCount: Scalars['Int']['output'];
  upcomingSubscription?: Maybe<SubscriptionPlan>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userFieldDefinitions: Array<UserFieldDefinition>;
  users: Array<User>;
  venueAiReplyInstructions: Array<VenueAiReplyInstruction>;
  venueCollection?: Maybe<VenueCollection>;
  venueCollectionId?: Maybe<Scalars['ID']['output']>;
  venueMemberships: Array<VenueMembership>;
  venuePolicies: Array<VenuePolicy>;
  venueType?: Maybe<VenueType>;
  websiteScans: Array<WebsiteScan>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  widgetContactFormRedirectUrl?: Maybe<Scalars['String']['output']>;
  widgetInstanceId: Scalars['String']['output'];
};

export type VenueDiscardedEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type VenueAiReplyInstruction = {
  __typename?: 'VenueAiReplyInstruction';
  id?: Maybe<Scalars['ID']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  scenario: Scalars['String']['output'];
};

export type VenueCollection = {
  __typename?: 'VenueCollection';
  contactFormSettings: ContactFormSettings;
  helloLeadFormPath: Scalars['String']['output'];
  helloLeadFormUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  venues: Array<Venue>;
};

export type VenueDataImport = {
  __typename?: 'VenueDataImport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  errorMessages: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  results?: Maybe<Scalars['JSON']['output']>;
  roomMappings?: Maybe<Scalars['JSON']['output']>;
  stagingResults?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  storageUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type VenueGoalsData = {
  __typename?: 'VenueGoalsData';
  eventData: Array<GoalAttainmentDatum>;
  monthlyGoals: Array<MonthlyGoalRow>;
  year: Scalars['Int']['output'];
};

export type VenueMembership = {
  __typename?: 'VenueMembership';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  venue: Venue;
};

export type VenuePolicy = {
  __typename?: 'VenuePolicy';
  body?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentPolicy?: Maybe<VenuePolicy>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venue: Venue;
  venuePolicySections: Array<VenuePolicySection>;
};

export type VenuePolicySection = {
  __typename?: 'VenuePolicySection';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  policySection: PolicySection;
  position: Scalars['Int']['output'];
  requiresInitial: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type VenuePolicySectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  policySectionId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  requiresInitial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VenueTaskAnalytics = {
  __typename?: 'VenueTaskAnalytics';
  all: Scalars['Int']['output'];
  completedYesterday: Scalars['Int']['output'];
  dueToday: Scalars['Int']['output'];
  dueTomorrow: Scalars['Int']['output'];
  incomplete: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
};

export type VenueTierTrial = {
  __typename?: 'VenueTierTrial';
  createdAt: Scalars['ISO8601DateTime']['output'];
  endDate: Scalars['ISO8601Date']['output'];
  grantedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  originalTier: Scalars['String']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  status: Scalars['String']['output'];
  trialTier: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  willAutoUpgrade: Scalars['Boolean']['output'];
};

export type VenueType = {
  __typename?: 'VenueType';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type WebsiteScan = {
  __typename?: 'WebsiteScan';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  crawledUrls: Array<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  emails: Array<Scalars['String']['output']>;
  gatherDetected: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pendingUrls: Array<Scalars['String']['output']>;
  pvContactFormDetected: Scalars['Boolean']['output'];
  seedUrl: Scalars['String']['output'];
  state: Scalars['String']['output'];
  tripleseatDetected: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venue?: Maybe<Venue>;
};
